(function() {
  'use strict';

  angular
    .module('minotaur', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'pascalprecht.translate',
      'cfp.loadingBar',
      'slick',
      'chart.js',
      'localytics.directives',
      'ngTable',
      'ngFileUpload',
      'firebase',
      'ngAlertify',
      'FBAngular',
      'validation.match',
      'textAngular',
      'ngMap'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurRightbar', minotaurRightbar);

  /** @ngInject */
  function minotaurRightbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partials/rightbar/rightbar.html',
      controller: RightbarController,
      controllerAs: 'rightbar',
      bindToController: true,
      link: function (scope, $el) {

          var app = angular.element('.appWrap'),
              $rightbar_toggle = app.find('#rightbar'),
              $close_righbar = $el.find('#close-rightbar');

          $rightbar_toggle.on('click', function(){
            $el.toggleClass('rightbar-expanded');
            app.toggleClass('rightbar-expanded');
          });

          $close_righbar.on('click', function(){
            $el.removeClass('rightbar-expanded');
            app.removeClass('rightbar-expanded');
          });
      }
    };

    return directive;

    /** @ngInject */
    function RightbarController() {
      //var rightbar = this;



    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurNav', minotaurNav);

  /** @ngInject */
  function minotaurNav($timeout, $window) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partials/navigation/navigation.html',
      controller: NavigationController,
      controllerAs: 'navigation',
      bindToController: true,
      link: function (scope, $el) {

        $timeout(function(){

          var $dropdowns = $el.find('ul').parent('li'),
              $a = $dropdowns.children('a'),
              $notDropdowns = $el.find('.nav-sidebar').children('li').not($dropdowns),
              $notDropdownsLinks = $notDropdowns.children('a'),
              $expand_toggle = $el.find('#expand-toggle'),
              app = angular.element('.appWrap'),
              $navigation_toggle = app.find('#navigation-toggle'),
              w = angular.element($window);

          $el.on('mouseenter', function() {
            if (!$el.hasClass('force-expanded') && !app.hasClass('viewport-sm')) {
              $el.addClass('nav-expanded');
              app.addClass('nav-expanded');
            }
          });
          $el.on('mouseleave', function() {
            if (!$el.hasClass('force-expanded') && !app.hasClass('viewport-sm')) {
              $el.removeClass('nav-expanded');
              app.removeClass('nav-expanded');
            }
          });

          $expand_toggle.on('click', function(){
            $el.toggleClass('force-expanded');
            app.toggleClass('force-expanded');
          });

          $navigation_toggle.on('click', function(){
            $el.toggleClass('nav-expanded');
            app.toggleClass('nav-expanded');
          });

          $dropdowns.addClass('dropdown');

          var $submenus = $dropdowns.find('ul >.dropdown');
          $submenus.addClass('submenu');

          $a.append('<span class="indicator"></span>');

          $a.on('click', function(event) {

            var $this = angular.element(this),
                $parent = $this.parent('li'),
                $openSubmenu = angular.element('.submenu.open');

            if (!$parent.hasClass('submenu')) {
              $dropdowns.not($parent).removeClass('open').find('ul').slideUp();
            }

            $openSubmenu.not($this.parents('.submenu')).removeClass('open').find('ul').slideUp();
            $parent.toggleClass('open').find('>ul').stop().slideToggle();
            event.preventDefault();
          });

          $notDropdownsLinks.on('click', function() {
            $dropdowns.removeClass('open').find('ul').slideUp();
          });

          var $activeDropdown = angular.element('.dropdown>ul>.active').parent();

          $activeDropdown.css('display', 'block');

          scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState){
            if ($el.find('ul').parent('li.open.active').length > 0 && toState.parent !== fromState.parent) {
                $dropdowns.find('ul').slideUp();
            }
            if (app.hasClass('viewport-sm')) {
              $el.removeClass('nav-expanded');
              app.removeClass('nav-expanded');
            }
          });

          function forceExpandVisibility(){
            if($window.innerWidth < 1200){
              $expand_toggle.hide();
              $el.removeClass('force-expanded nav-expanded');
              app.removeClass('force-expanded nav-expanded');
            } else {
              $expand_toggle.show();
            }
          }

          forceExpandVisibility();

          w.bind('resize', forceExpandVisibility);

        });

      }
    };

    return directive;

    /** @ngInject */
    function NavigationController() {
      //var navigation = this;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurHeader', minotaurHeader);

  /** @ngInject */
  function minotaurHeader($window, $timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partials/header/header.html',
      controller: HeaderController,
      controllerAs: 'header',
      bindToController: true,
      link: function (scope, element) {
        var app = angular.element('.appWrap'),
            $el = angular.element(element),
            w = angular.element($window);

        function toggleStickyHeader(){
          if (!$el.hasClass('force-header-sm') && !$el.hasClass('header-aside')){
            if(!$el.hasClass('header-sm') && $window.pageYOffset > 10){
              $el.addClass('header-sm');
              app.addClass('header-sm animate');
              $timeout(function(){
                app.removeClass('animate');
              }, 400);
            } else if($el.hasClass('header-sm') && $window.pageYOffset <= 10){
              $el.removeClass('header-sm');
              app.addClass('animate');
              app.removeClass('header-sm');
              $timeout(function(){
                app.removeClass('animate');
              }, 400);
            }
          }
        }

        w.bind('scroll', toggleStickyHeader);

        function setViewport(){
          if($window.innerWidth < 768){
            $el.addClass('viewport-sm');
            app.addClass('viewport-sm');
          } else {
            $el.removeClass('viewport-sm');
            app.removeClass('viewport-sm');
          }
        }

        setViewport();

        w.bind('resize', setViewport);
      }
    };

    return directive;

    /** @ngInject */
    function HeaderController(Auth, $state, $window) {
      var vm = this;

      vm.logout = function() {
        Auth.$signOut().then(function(){
          $state.go('core.login', {}, {reload: true});
        });
        // destroy all firebase refs
        angular.forEach($window.openFirebaseConnections, function (item) {
          item.$destroy();
        });
      };

      vm.notifications = [{
        content: 'User Imrich cancelled account',
        time: '6 minutes ago',
        icon: 'fa fa-ban',
        color: 'bg-danger'
      },{
        content: 'New user registered',
        time: '12 minutes ago',
        icon: 'fa fa-bolt',
        color: 'bg-primary'
      },{
        content: 'User Robert locked account',
        time: '18 minutes ago',
        icon: 'fa fa-lock',
        color: 'bg-greensea'
      },{
        content: 'User Jon cancelled account',
        time: '36 minutes ago',
        icon: 'fa fa-ban',
        color: 'bg-danger'
      },{
        content: 'User Joffrey has been muted',
        time: '42 minutes ago',
        icon: 'fa fa-bullseye',
        color: 'bg-warning'
      },{
        content: 'User Sam locked account',
        time: '58 minutes ago',
        icon: 'fa fa-lock',
        color: 'bg-greensea'
      }]

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurCustomize', minotaurCustomize);

  /** @ngInject */
  function minotaurCustomize() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partials/customize/minotaur-customize.html',
      link: function (scope, element) {
        var toggle = element.find('.toggle');
        toggle.on('click', function(){
          element.toggleClass('open');
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('UsersController', UsersController)
    .controller('NewUserController', NewUserController)
    .controller('EditUserController', EditUserController)
    .controller('ShowUserController', ShowUserController);

  /** @ngInject */
  function UsersController($scope, $stateParams, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject, currentAuth, Auth) {
    var vm = this;

    var service = $stateParams.service;
    $log.log(service);

  //  console.log(service);

    // General database variable
    var ref = firebase.database().ref();
    if(service){
      vm.users = $firebaseArray(ref.child('users').orderByChild('neService/' + service).equalTo(true));
    } else {
      vm.users = $firebaseArray(ref.child('users'));
    }
    vm.blockedUsers = ref.child('blockedUsers');

    vm.currentUser = $firebaseObject(ref.child('users').child(currentAuth.uid));
    //////////////////////////// *General database variable

    vm.currentUser.$loaded(function(){
      if (vm.currentUser.role_value >= '51'){
        vm.role_value = {
          admin: "95",
          projectmanager: "50",
          moderator: "20",
          user: "10"
        };
      } else {
        vm.role_value = {
          projectmanager: "50",
          moderator: "20",
          user: "10"
        };
      }
    });


    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (user) {
      if (confirm('Are you sure?')) {
        vm.users.$ref().child(user.$id).child('blocked').set(true);
        vm.blockedUsers.child(user.$id).set({blocked: true});
        vm.tableParams.reload();
      }
    };
    //////////////////////////// *Delete CRUD operation

    // password reset operation
    vm.passReset = function (user) {
      if (confirm('Are you sure?')) {
        Auth.$sendPasswordResetEmail(user.email).then(function(){
          toastr.success('We have sent an email with new password', 'Password reset!');
          $log.log("Password reset email sent successfully");
        }, function(error){
          $log.log("Error sending password reset email:", error);
        });
      }
    };
    //////////////////////////// *password reset operation


    // Initialize table
    vm.users.$loaded().then(function() {
    //  $log.log(vm);
      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.users;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({

        // initial filter
        sorting: {
          name: 'asc'
        },
        filter: {
          blocked: false
        }
      }, {
        dataset: vm.users
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewUserController(toastr, $log, firebase, $firebaseArray, $state){
    var vm = this;
    var ref = firebase.database().ref();

    vm.users = $firebaseArray(ref.child('users'));
    var profiles = ref.child('users');

    // Submit operation
    vm.submit = function() {

      vm.userEntry = {
        name: vm.user.name,
        email: vm.user.email,
        role_value: vm.user.role_value,
        neService:{verhalensprokkelaar:true},
        // address: {
        //   street: vm.user.address.street,
        //   city: vm.user.address.city,
        //   zip: vm.user.address.zip,
        //   country: vm.user.address.country
        // },
        // phone: vm.user.phone,
        blocked: false
      };

      /* eslint-disable */
      secondaryApp.auth().createUserWithEmailAndPassword(vm.user.email, vm.user.password)
        .then(function(userData) {
          profiles.child(userData.uid).set(vm.userEntry);
          secondaryApp.auth().signOut();
          secondaryApp.delete();
          $log.log("Successfully created user account with uid:", userData.uid);
          toastr.success('User has been created', 'User Added!');
          $state.go('users.list', {}, {reload: true});
        }, function(error) {
          $log.log("Error creating user:", error);
          toastr.error(error.message, 'Adding User Error!');
        }); /////////////////////// *Create CRUD operation

    };
    /* eslint-enable */
    /////////////////////// *Submit operation

  }

  function EditUserController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.editing = true;

    vm.user = $firebaseObject(ref.child('users').child(id));
    vm.users = $firebaseArray(ref.child('users'));
    var profiles = ref.child('users');

    vm.users.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.userEntry = {
          name: vm.user.name,
          email: vm.user.email,
          role_value: vm.user.role_value
          // address: {
          //   street: vm.user.address.street,
          //   city: vm.user.address.city,
          //   zip: vm.user.address.zip,
          //   country: vm.user.address.country
          // },
          // phone: vm.user.phone
        };

        var updateOnSuccess = function() {
          profiles.child(vm.user.$id).update(vm.userEntry, function() {
            toastr.success('User has been saved', 'User Saved!');
            $state.go('users.list', {}, {reload: true});
          });
        };

        updateOnSuccess();
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowUserController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.user = $firebaseObject(ref.child('users').child(id));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('StoriesController', StoriesController)
    .controller('NewStoryController', NewStoryController)
    .controller('EditStoryController', EditStoryController)
    .controller('ShowStoryController', ShowStoryController);

  /** @ngInject */
  function StoriesController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.stories = $firebaseArray(ref.child('stories'));
    vm.storiesObject = $firebaseObject(ref.child('stories'));

    vm.monuments = $firebaseArray(ref.child('monuments'));
    vm.monumentsObject = $firebaseObject(ref.child('monuments'));

    vm.categories = $firebaseArray(ref.child('categories'));
    vm.categoriesObject = $firebaseObject(ref.child('categories'));

    vm.services = $firebaseArray(ref.child('services'));
    vm.servicesObject = $firebaseObject(ref.child('services'));

    vm.partners = $firebaseArray(ref.child('partners'));
    vm.partnersObject = $firebaseObject(ref.child('partners'));

    vm.cities = $firebaseArray(ref.child('cities'));
    vm.citiesObject = $firebaseObject(ref.child('cities'));
    //////////////////////////// *General database variable

    // get the model
      // if($stateParams.id) {
      //   var id = $stateParams.id;
      //   vm.story = $firebaseObject(ref.child('stories').child(id));
      // } else {
        // vm.story = {
        //   pushradius: '50',
        //   mapdata:{
        //     latitude: '52.376879',
        //     longitude: '4.901941'
        //   }
        // };
      //}

    vm.categories.$loaded().then(function() {
      vm.childCategories = [];
      //extend array
      angular.forEach(vm.categories, function (value) {
        if (value.parentId && vm.categoriesObject[value.parentId]) {
          value.parentName = vm.categoriesObject[value.parentId].name;
          vm.childCategories.push(value);
        } else {
          if ($filter('filter')(vm.categories, {parentId: value.$id}).length === 0) {
            vm.childCategories.push(value);
          }
        }
      });
    });

    vm.cities.$loaded().then(function() {
      vm.childCities = [];
      //extend array
      angular.forEach(vm.cities, function (value) {
        if (value.parentId && vm.citiesObject[value.parentId]) {
          value.parentName = vm.citiesObject[value.parentId].name;
          vm.childCities.push(value);
        } else {
          if ($filter('filter')(vm.cities, {parentId: value.$id}).length === 0) {
            vm.childCities.push(value);
          }
        }
      });
    });

    vm.monuments.$loaded().then(function() {
        vm.childmonuments = [];
        //extend array
        angular.forEach(vm.monuments, function (value) {
          if (value.parentId && vm.monumentsObject[value.parentId]) {
            value.parentName = vm.monumentsObject[value.parentId].name;
            vm.childmonuments.push(value);
          } else {
            if ($filter('filter')(vm.monuments, {parentId: value.$id}).length === 0) {
              vm.childmonuments.push(value);
            }
          }
        });
      });

      vm.services.$loaded().then(function() {
        vm.childServices = [];

        //extend array
        angular.forEach(vm.services, function (value) {
          if (value.parentId && vm.servicesObject[value.parentId]) {
            //console.log(vm.childServices);
            value.parentName = vm.servicesObject[value.parentId].name;
            vm.childServices.push(value);
          } else {
            //console.log(vm.childServices);
            if ($filter('filter')(vm.services, {parentId: value.$id}).length === 0) {
              //console.log(value);
              vm.childServices.push(value);
            }
          }
        });
      });

      vm.partners.$loaded().then(function() {
        vm.childPartners = [];
        angular.forEach(vm.partners, function (value) {
          if (value.parentId && vm.partnersObject[value.parentId]) {
            value.parentName = vm.partnersObject[value.parentId].name;
            vm.childPartners.push(value);
          } else {
            if ($filter('filter')(vm.partners, {parentId: value.$id}).length === 0) {
              vm.childPartners.push(value);
            }
          }
        });
      });

    vm.statuses = {
      published: "published",
      notPublished: "not published",
      banned: "banned"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (story) {
      if (confirm('Are you sure?')) {
        vm.stories.$remove(story).then(function () {
          $log.log('story deleted');
          toastr.success('Story Removed!', 'Story has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.stories.$loaded().then(function() {

      //extend array
      function extendArray(){
        angular.forEach(vm.stories, function(value){
          if (value.category && vm.categoriesObject[value.category]) {
            value.categoryName = vm.categoriesObject[value.category].name;
          }
        });
        angular.forEach(vm.stories, function(value){
          if (value.city && vm.citiesObject[value.city]) {
            value.cityName = vm.citiesObject[value.city].name;
          }
        });
      }
      extendArray();

      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.categories;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.stories
      });

    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewStoryController(toastr, $log, firebase, $firebaseArray, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/stories/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var vm = this;
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    vm.stories = $firebaseArray(ref.child('stories'));
    vm.story = {};

    vm.story = {
          pushradius: '50',
          mapdata:{
            latitude: '52.376879',
            longitude: '4.901941'
          }
        };

        //map en input lat/lng aanpassen na verplaatsen marker
        vm.getCurrentLocation = function(event){          
          vm.pos = this.getPosition();
          vm.story.mapdata.latitude   = vm.pos.lat();
          vm.story.mapdata.longitude  = vm.pos.lng();

        }

    vm.processing = false;

    ref.child('storiesCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.story.id = $filter('digits')(data+1,6);
        } else {
          vm.story.id = '000001';
        }
      });

    // Submit operation
    vm.submit = function() {
      vm.processing = true;

      function save(){
        vm.stories.$add(vm.story).then(function (storyRef) {
          ref.child('storiesCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);

              ref.child('stories').child(storyRef.key)
                .update({id: id, created_at: firebase.database.ServerValue.TIMESTAMP});
            }
          });
          toastr.success('Story Added!', 'Story has been created');
          $state.go('stories.list', {}, {reload: true});
        });
      }

      if (vm.story.images) {
        storageRef.putFiles(vm.story.images).then(function(metadatas) {
          // Get an array of file metadata
          $log.log(metadatas);
          angular.forEach(metadatas, function(meta, key){
            var file = meta.a;
            vm.story.images[key] = {};
            vm.story.images[key].src = file.downloadURLs[0];
          });
          save();
        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });
      } else {
        save();
      }

    };
    /////////////////////// *Submit operation
  }

  function EditStoryController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/stories/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.story = $firebaseObject(ref.child('stories').child(id));
    vm.stories = $firebaseArray(ref.child('stories'));

    vm.editing = true;
    vm.processing = false;

    vm.stories.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.processing = true;

        function save(){
          vm.processing = false;
          vm.story.$save().then(function (storyRef) {
            ref.child('stories').child(storyRef.key)
              .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
            toastr.success('Story Saved!', 'Story has been saved');
            $state.go('stories.list', {}, {reload: true});
          });
        }

        if (vm.form.images.$modelValue[0] && vm.form.images.$modelValue[0].size && vm.form.images.$valid) {
          storageRef.putFiles(vm.story.images).then(function(metadatas) {
            // Get an array of file metadata
            angular.forEach(metadatas, function(meta, key){
              var file = meta.a;
              vm.story.images[key] = {};
              vm.story.images[key].src = file.downloadURLs[0];
            });
            save();
          }).catch(function(error) {
            // If any task fails, handle this
            vm.processing = false;
            $log.error('Upload failed:', error);
          });
        } else {
          save();
        }
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowStoryController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.story = $firebaseObject(ref.child('stories').child(id));
    vm.storiesObject = $firebaseObject(ref.child('stories'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('SignupController', SignupController);

  /** @ngInject */
  function SignupController(currentAuth, firebase, Auth, $log, $state, toastr) {
    var vm = this;

    vm.currentAuth = currentAuth;

    //redirect if user is logged in
    if (vm.currentAuth) {
      $state.go('dashboard', {}, {reload: true});
    }

    vm.createUser = function() {
      vm.message = null;
      vm.error = null;

      //toastr.warning('Please uncomment me in SignupController to make me work', 'This should create an Account!');

      // Create a new user
      Auth.$createUserWithEmailAndPassword(vm.email, vm.password)
        .then(function(firebaseUser) {
          vm.message = "User created with uid: " + firebaseUser.uid;
          // authenticate so we have permission to write to Firebase
          return Auth.$signInWithEmailAndPassword(vm.email, vm.password);
        })
        .then(function(firebaseUser){
          var ref = firebase.database().ref();

          // create a user profile in our data store
          ref.child('users').child(firebaseUser.uid).set({
            blocked: false,
            neService: {verhalensprokkelaar:true},
            role_value: 10,
            name: vm.name,
            email: vm.email,
            created_at: firebase.database.ServerValue.TIMESTAMP,
            updated_at: firebase.database.ServerValue.TIMESTAMP
          });

          toastr.success('Your Account has been Created', 'Account Created!');
          $state.go('dashboard', {}, {reload: true});
        })
        .catch(function(error) {
          vm.error = error;
          //toastr.error(vm.error, 'Creating Account Failed!');
        });
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController(firebase, $firebaseObject, toastr) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.settings = $firebaseObject(ref.child('settings'));
    //////////////////////////// *General database variable

    vm.save = function(){
      vm.settings.$save().then(function(){
        toastr.success('Settings has been updated.', 'Settings Saved!');
      });
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController(firebase, $firebaseObject, currentAuth, Auth, $log, toastr) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var profiles = ref.child('users');
    //////////////////////////// *General database variable

    // Initial model
    vm.user = $firebaseObject(ref.child('users').child(currentAuth.uid));
    /////////////////////// *Initial model

    vm.user.$loaded().then(function(){

      vm.oldEmail = angular.copy(vm.user.email);

    });

    vm.changeEmail = false;
    vm.changePass = false;

    // Submit operation
    vm.save = function() {

      vm.userEntry = {
        avatar: vm.user.avatar,
        name: vm.user.name,
        email: vm.user.email,
        role: vm.user.role,
        address: {
          street: vm.user.address.street,
          city: vm.user.address.city,
          zip: vm.user.address.zip,
          country: vm.user.address.country
        },
        phone: vm.user.phone
      };

      var updateOnSuccess = function() {

        if (vm.user.avatar && vm.user.avatar.size) {
          var file = vm.user.avatar;
          var metadata = {
            'contentType': file.type,
            'contentDisposition': 'inline; filename=' + file.name
          };

          // Push to child path.
          // [START oncomplete]
          storageRef.child('/avatars/' + currentAuth.uid + '/' + file.name).put(file, metadata).then(function(snapshot) {
            var url = snapshot.metadata.downloadURLs[0];
            vm.userEntry.avatar = url;
            $log.log('File available at', url);
            profiles.child(vm.user.$id).update(vm.userEntry);
          }).catch(function(error) {
            // [START onfailure]
            $log.error('Upload failed:', error);
            // [END onfailure]
          });
          // [END oncomplete]
        } else {
          profiles.child(vm.user.$id).update(vm.userEntry);
        }

        toastr.success('Your Personal Informations has been updated', 'Saving success!');
        vm.changeEmail = false;
        vm.changePass = false;
      };

      var changeEmail = vm.changeEmail;
      var changePass = vm.changePass;

      if (changeEmail === true) {
        Auth.$signInWithEmailAndPassword(vm.oldEmail, vm.user.password).then(function(){
          Auth.$updateEmail(vm.user.email).then(function(){
            $log.log("Email changed successfully");
            toastr.success('Email has been changed successfully', 'Email changed!');
            updateOnSuccess();
          }, function(error){
            toastr.error(error.message, 'Error changing email!');
            $log.log("Error changing email:", error);
          });
        });
      } else if (changePass === true) {
        Auth.$signInWithEmailAndPassword(vm.user.email, vm.oldpassword).then(function(){
          Auth.$updatePassword(vm.user.password).then(function(){
            $log.log("Password changed successfully");
            toastr.success('Password has been changed successfully', 'Password changed!');
            updateOnSuccess();
          }, function(error){
            toastr.error(error.message, 'Error changing password!');
            $log.log("Error changing password:", error);
          });
        });
      } else {
        updateOnSuccess();
      }
    };
    /////////////////////// *Submit operation

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('ProductsController', ProductsController)
    .controller('NewProductController', NewProductController)
    .controller('EditProductController', EditProductController)
    .controller('ShowProductController', ShowProductController);

  /** @ngInject */
  function ProductsController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.products = $firebaseArray(ref.child('products'));
    vm.productsObject = $firebaseObject(ref.child('products'));

    vm.categories = $firebaseArray(ref.child('categories'));
    vm.categoriesObject = $firebaseObject(ref.child('categories'));
    //////////////////////////// *General database variable

    vm.categories.$loaded().then(function() {
      vm.childCategories = [];
      //extend array
      angular.forEach(vm.categories, function (value) {
        if (value.parentId && vm.categoriesObject[value.parentId]) {
          value.parentName = vm.categoriesObject[value.parentId].name;
          vm.childCategories.push(value);
        } else {
          if ($filter('filter')(vm.categories, {parentId: value.$id}).length === 0) {
            vm.childCategories.push(value);
          }
        }
      });
    });

    vm.units = {
      pc: "Piece",
      kg: "Kilogram",
      g: "Gram",
      m: "Meter",
      l: "Liter"
    };

    vm.statuses = {
      published: "published",
      notPublished: "not published",
      banned: "banned"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (product) {
      if (confirm('Are you sure?')) {
        vm.products.$remove(product).then(function () {
          $log.log('product deleted');
          toastr.success('Product Removed!', 'Product has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.products.$loaded().then(function() {

      //extend array
      function extendArray(){
        angular.forEach(vm.products, function(value){
          if (value.categoryId && vm.categoriesObject[value.categoryId]) {
            value.categoryName = vm.categoriesObject[value.categoryId].name;
          }
        });
      }
      extendArray();
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.categories;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.products
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewProductController(toastr, $log, firebase, $firebaseArray, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/products/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var vm = this;
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    vm.products = $firebaseArray(ref.child('products'));
    vm.product = {};

    vm.processing = false;

    ref.child('productsCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.product.id = $filter('digits')(data+1,6);
        } else {
          vm.product.id = '000001';
        }
      });

    // Submit operation
    vm.submit = function() {
      vm.processing = true;

      function save(){
        vm.products.$add(vm.product).then(function (productRef) {
          ref.child('productsCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);

              ref.child('products').child(productRef.key)
                .update({id: id, created_at: firebase.database.ServerValue.TIMESTAMP});
            }
          });
          toastr.success('Product Added!', 'Product has been created');
          $state.go('products.list', {}, {reload: true});
        });
      }

      if (vm.product.images) {
        storageRef.putFiles(vm.product.images).then(function(metadatas) {
          // Get an array of file metadata
          $log.log(metadatas);
          angular.forEach(metadatas, function(meta, key){
            var file = meta.a;
            vm.product.images[key] = {};
            vm.product.images[key].src = file.downloadURLs[0];
          });
          save();
        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });
      } else {
        save();
      }

    };
    /////////////////////// *Submit operation
  }

  function EditProductController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/products/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.product = $firebaseObject(ref.child('products').child(id));
    vm.products = $firebaseArray(ref.child('products'));

    vm.editing = true;
    vm.processing = false;

    vm.products.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.processing = true;

        function save(){
          vm.processing = false;
          vm.product.$save().then(function (productRef) {
            ref.child('products').child(productRef.key)
              .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
            toastr.success('Product Saved!', 'Product has been saved');
            $state.go('products.list', {}, {reload: true});
          });
        }

        if (vm.form.images.$modelValue[0] && vm.form.images.$modelValue[0].size && vm.form.images.$valid) {
          storageRef.putFiles(vm.product.images).then(function(metadatas) {
            // Get an array of file metadata
            angular.forEach(metadatas, function(meta, key){
              var file = meta.a;
              vm.product.images[key] = {};
              vm.product.images[key].src = file.downloadURLs[0];
            });
            save();
          }).catch(function(error) {
            // If any task fails, handle this
            vm.processing = false;
            $log.error('Upload failed:', error);
          });
        } else {
          save();
        }
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowProductController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.product = $firebaseObject(ref.child('products').child(id));
    vm.productsObject = $firebaseObject(ref.child('products'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('OrdersController', OrdersController)
    .controller('ShowOrderController', ShowOrderController);

  /** @ngInject */
  function OrdersController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.orders = $firebaseArray(ref.child('orders'));

    vm.categories = $firebaseArray(ref.child('categories'));
    vm.categoriesObject = $firebaseObject(ref.child('categories'));

    vm.products = $firebaseArray(ref.child('products'));
    vm.productsObject = $firebaseObject(ref.child('products'));
    //////////////////////////// *General database variable

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (order) {
      if (confirm('Are you sure?')) {
        vm.orders.$remove(order).then(function () {
          $log.log('order deleted');
          toastr.success('Order Removed!', 'Order has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation

    vm.changeStatus = function (order, status) {
      order.status = status;
      vm.orders.$save(order).then(function () {
        $log.log('status changed');
      });
    };


    // Initialize table
    vm.orders.$loaded().then(function() {


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.orders;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          id: 'asc'
        }
      }, {
        dataset: vm.orders
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function ShowOrderController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.order = $firebaseObject(ref.child('orders').child(id));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(currentAuth, Auth, $log, $state, toastr) {
    var vm = this;

    // toastr.success('demo@tattek.sk, pass: minotaur', 'Login default data!', {progressBar: true, timeOut: '15000'});

    vm.currentAuth = currentAuth;

    //redirect if user is logged in
    if (vm.currentAuth) {
      $state.go('dashboard', {}, {reload: true});
    }

    vm.login = function() {
      vm.error = null;
      Auth.$signInWithEmailAndPassword(vm.email, vm.password)
        .then(function(authData) {
          $log.log("Authenticated successfully with payload:", authData);
          $state.go('dashboard', {}, {reload: true});
        }, function(err) {
          vm.err = err;
          toastr.error(vm.err.message, 'Login Failed!');
          $log.log("Login Failed!", err);
        });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('LocationsController', LocationsController)
    .controller('NewLocationController', NewLocationController)
    .controller('EditLocationController', EditLocationController)
    .controller('ShowLocationController', ShowLocationController);

  /** @ngInject */
  function LocationsController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;
  //  $log.log(vm);
    vm.activeStep = 0;

    //$log.log($scope);

    //console.log(vm);

    // General database variable
    var ref = firebase.database().ref();
    vm.locations = $firebaseArray(ref.child('locations'));
    vm.locationsObject = $firebaseObject(ref.child('locations'));

    vm.monuments = $firebaseArray(ref.child('monuments'));
    vm.monumentsObject = $firebaseObject(ref.child('monuments'));

    vm.location_categories = $firebaseArray(ref.child('location_categories'));
    vm.location_categoriesObject = $firebaseObject(ref.child('location_categories'));

    vm.services = $firebaseArray(ref.child('services'));
    vm.servicesObject = $firebaseObject(ref.child('services'));

    vm.partners = $firebaseArray(ref.child('partners'));
    vm.partnersObject = $firebaseObject(ref.child('partners'));

    vm.cities = $firebaseArray(ref.child('cities'));
    vm.citiesObject = $firebaseObject(ref.child('cities'));
    //////////////////////////// *General database variable

    vm.location_categories.$loaded().then(function() {
      vm.childCategories = [];
      //extend array
      angular.forEach(vm.location_categories, function (value) {
        if (value.parentId && vm.location_categoriesObject[value.parentId]) {
          value.parentName = vm.location_categoriesObject[value.parentId].name;
          vm.childCategories.push(value);
        } else {
          if ($filter('filter')(vm.location_categories, {parentId: value.$id}).length === 0) {
            vm.childCategories.push(value);
          }
        }
      });
    });

    vm.cities.$loaded().then(function() {
      vm.childCities = [];
      //extend array
      angular.forEach(vm.cities, function (value) {
        if (value.parentId && vm.citiesObject[value.parentId]) {
          value.parentName = vm.citiesObject[value.parentId].name;
          vm.childCities.push(value);
        } else {
          if ($filter('filter')(vm.cities, {parentId: value.$id}).length === 0) {
            vm.childCities.push(value);
          }
        }
      });
    });

    // vm.monuments.$loaded().then(function() {
    //     vm.childmonuments = [];
    //     //extend array
    //     angular.forEach(vm.monuments, function (value) {
    //       if (value.parentId && vm.monumentsObject[value.parentId]) {
    //         value.parentName = vm.monumentsObject[value.parentId].name;
    //         vm.childmonuments.push(value);
    //       } else {
    //         if ($filter('filter')(vm.monuments, {parentId: value.$id}).length === 0) {
    //           vm.childmonuments.push(value);
    //         }
    //       }
    //     });
    //   });

      vm.services.$loaded().then(function() {
        vm.childServices = [];

        //extend array
        angular.forEach(vm.services, function (value) {
          if (value.parentId && vm.servicesObject[value.parentId]) {
            //console.log(vm.childServices);
            value.parentName = vm.servicesObject[value.parentId].name;
            vm.childServices.push(value);
          } else {
            //console.log(vm.childServices);
            if ($filter('filter')(vm.services, {parentId: value.$id}).length === 0) {
              //console.log(value);
              vm.childServices.push(value);
            }
          }
        });
      });

      vm.partners.$loaded().then(function() {
        vm.childPartners = [];
        angular.forEach(vm.partners, function (value) {
          if (value.parentId && vm.partnersObject[value.parentId]) {
            value.parentName = vm.partnersObject[value.parentId].name;
            vm.childPartners.push(value);
          } else {
            if ($filter('filter')(vm.partners, {parentId: value.$id}).length === 0) {
              vm.childPartners.push(value);
            }
          }
        });
      });

    vm.statuses = {
      published: "published",
      concept: "concept",
      rejected: "rejected",
      waiting: "moderate"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (location) {
      if (confirm('Are you sure?')) {
        vm.locations.$remove(location).then(function () {
          toastr.success('Artikel verwijderd!', 'De locatie is verwijderd');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.locations.$loaded().then(function() {
      //console.log(vm);
      //extend array
      function extendArray(){
        angular.forEach(vm.locations, function(value){
          if (value.location_category && vm.location_categoriesObject[value.location_category]) {
            value.location_categoryName = vm.location_categoriesObject[value.location_category].name;
          }
        });
        angular.forEach(vm.locations, function(value){
          if (value.location && vm.monumentsObject[value.location]) {
            value.locationName = vm.monumentsObject[value.location].name;
          }
        });
        angular.forEach(vm.locations, function(value){
          if (value.city && vm.citiesObject[value.city]) {
            value.cityName = vm.citiesObject[value.city].name;
          }
        });
      }
      extendArray();

      ///////////////////////////////////////////// *extend array

      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.locations;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.locations
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewLocationController($scope, toastr, $log, firebase, $firebaseArray, $firebaseObject, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        var d = new Date();
        var n = d.getTime();
        var x = Math.floor((Math.random() * 999999) + 1);

        var uploadTask = ref.child('/locations/' + vm.location.title + '/' + x + '-' + n).put(file, metadata);
        vm.currentImage = vm.currentImage + 1;

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            vm.progress = progress;
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                break;
            }
          }, function(error) {
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break;
              case 'storage/canceled':
                // User canceled the upload
                break;
              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break;
          }
        });

        return uploadTask;

      }));
    };
    /* eslint-enable */

    var vm = this;
    vm.user = firebase.auth().currentUser;

    vm.processing = false;

    vm.getCurrentlocation = function(e) {
        vm.address.lat = e.latLng.lat();
        vm.address.lng = e.latLng.lng();
        $log.log(vm);
    };

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    //Watch images & upload
    $scope.$watch('vm.location.imagess', function () {
      if (vm.location.imagess != null) {
        // $log.log(vm);
        vm.currentImage = 0;
        vm.totalImages = vm.location.imagess.length;
        vm.processing = true;

        storageRef.putFiles(vm.location.imagess).then(function(metadatas) {

          angular.forEach(metadatas, function(meta){
            var file = meta.a;

              var fb_ref= ref.child('locations/').child(vm.locationObject.$id).child('/images');
              fb_ref.push({
                src: file.downloadURLs[0],
                updated_at: firebase.database.ServerValue.TIMESTAMP,
                path: file.fullPath,
                main_image: "false",
                caption: null,
                copyright: null
              }).then(function(joehoe){
                ref.child('locations/').child(vm.locationObject.$id).child('/images').child(joehoe.key)
                  .update({_key:joehoe.key});
              })
              reloadImage();
              vm.processing = false;
          });

        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });

      }
      });

    function reloadImage (){
      var objKey = vm.locationObject.$id;

      vm.location = $firebaseObject(ref.child('locations').child(objKey));

    }

    $scope.$watch('vm.location.images', function (){});


    vm.updateImageSelect = function(image){
      var checkImages = vm.location.images;
      angular.forEach(checkImages, function (b) {
        //compare data
        b.main_image = image === b;
        //set object key
        var objKey = vm.location.$id;
        //load fb
        var obj = $firebaseObject(ref.child('locations').child(objKey));
        obj.$loaded()
          .then(function() {
            ref.child('locations').child(objKey).child('/images').child(b._key)
                 .update({main_image:b.main_image});
          })
          .catch(function() {});
      })

    };

    //Delete image function
    vm.imageDelete = function(image){
     // var objKey = vm.locationObject.$id;
      var imgKey = image._key;
      if (confirm('Weet je het zeker?')) {
        ref.child('locations/').child(vm.locationObject.$id).child('/images').child(imgKey).remove().then(function () {
          toastr.success('Foto verwijderd!', 'De foto is verwijderd');
        });
      }
    }


    //save temp steps
    //saving to generate uid, so we can save multiple images to firebase storage
    vm.saveTemp = function(){
      vm.processing = true;
      $log.log(vm);

      if(typeof vm.locationObject !== 'undefined'){
        $log.log('exists!');
        var objKey = vm.locationObject.$id;
        ref.child('locations').child(objKey).update(vm.location);

      } else {

        vm.locations.$add(vm.location).then(function (locationRef) {
          ref.child('locationsCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);
              ref.child('locations').child(locationRef.key)
                .update({id: id, author: vm.user.uid, created_at: firebase.database.ServerValue.TIMESTAMP, geolocation: "null"});
                vm.locationObject = $firebaseObject(ref.child('locations').child(locationRef.key));
            }
          });
          toastr.success('Gefeliciteerd! Stap 1 is achter de rug!', 'Locatie opgeslagen');
        });

      }

    }

    vm.saveTemp2 = function(){
      vm.processing = true;

      var objKey = vm.locationObject.$id;

      var obj = $firebaseObject(ref.child('locations').child(objKey));
      obj.$loaded()
        .then(function() {

          var updates = {};
          updates['/mainImage/'] = vm.mainImage;
          updates['/images'] = vm.location.images;

          ref.child('locations').child(objKey)
               .update(updates);
        })
        .catch(function() {

        });
        toastr.success('Gefeliciteerd! De foto\'s zijn opgeslagen!', 'Locatie opgeslagen');
    }

    //save temp step3 file
    // vm.saveTemp3 = function(){
    //
    //   vm.processing = true;
    //   var objKey = vm.locationObject.$id;
    //
    //   var obj = $firebaseObject(ref.child('locations').child(objKey));
    //   obj.$loaded()
    //     .then(function() {
    //       ref.child('locations').child(objKey)
    //            .update({introduction:vm.location.introduction, full_story:vm.location.description});
    //     })
    //     .catch(function() {
    //       //console.error("Error:", error);
    //     });
    //
    //     $state.go('locations.list', {}, {reload: true});
    //     toastr.success('Gefeliciteerd! De locatie is aangemaakt.', 'Locatie aangemaakt');
    //
    //
    // }

    vm.locations = $firebaseArray(ref.child('locations'));
    vm.location = {};

    vm.processing = false;

    ref.child('locationsCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.location.id = $filter('digits')(data+1,6);
        } else {
          vm.location.id = '000001';
        }
      });

    //Submit operation
    vm.submit = function() {
      vm.processing = true;

      var objKey = vm.locationObject.$id;

      var obj = $firebaseObject(ref.child('locations').child(objKey));
      obj.$loaded()
        .then(function() {
          $log.log(vm.location.introduction);
          ref.child('locations').child(objKey)
               .update({introduction:vm.location.introduction, description:vm.location.description});
        })
        .catch(function() {

        });
        $state.go('locations.list', {}, {reload: true});
        toastr.success('Gefeliciteerd! De locatie is aangemaakt.', 'Locatie aangemaakt');

    };
    /////////////////////// *Submit operation
  }

  function EditLocationController($scope, toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        var d = new Date();
        var n = d.getTime();
        var x = Math.floor((Math.random() * 999999) + 1);

        var uploadTask = ref.child('/locations/' + vm.location.title + '/' + x + '-' + n).put(file, metadata);
        vm.currentImage = vm.currentImage + 1;

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            vm.progress = progress;
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                break;
            }
          }, function(error) {
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break;
              case 'storage/canceled':
                // User canceled the upload
                break;
              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break;
          }
        });

        return uploadTask;

      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;
    //$log.log(vm);

    vm.location = $firebaseObject(ref.child('locations').child(id));
    vm.locations = $firebaseArray(ref.child('locations'));

    vm.editing = true;
    vm.processing = false;

    //Watch images & upload
    $scope.$watch('vm.location.imagess', function () {
      if (vm.location.imagess != null) {
        // $log.log(vm);
        vm.currentImage = 0;
        vm.totalImages = vm.location.imagess.length;
        vm.processing = true;

        storageRef.putFiles(vm.location.imagess).then(function(metadatas) {

          angular.forEach(metadatas, function(meta){
            var file = meta.a;

              var fb_ref= ref.child('locations/').child(vm.locationObject.$id).child('/images');
              fb_ref.push({
                src: file.downloadURLs[0],
                updated_at: firebase.database.ServerValue.TIMESTAMP,
                path: file.fullPath,
                main_image: "false",
                caption: null,
                copyright: null
              }).then(function(joehoe){
                ref.child('locations/').child(vm.locationObject.$id).child('/images').child(joehoe.key)
                  .update({_key:joehoe.key});
              })
              reloadImage();
              vm.processing = false;
          });

        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });

      }
      });

    function reloadImage (){
      var objKey = vm.location.$id;

      vm.location = $firebaseObject(ref.child('locations').child(objKey));

    }

    $scope.$watch('vm.location.images', function (){
      //$log.log('asasas');
    });


    vm.updateImageSelect = function(image){
      var checkImages = vm.location.images;
      angular.forEach(checkImages, function (b) {
        //compare data
        b.main_image = image === b;
        //set object key
        var objKey = vm.location.$id;
        //load fb
        var obj = $firebaseObject(ref.child('locations').child(objKey));
        obj.$loaded()
          .then(function() {
            ref.child('locations').child(objKey).child('/images').child(b._key)
                 .update({main_image:b.main_image});
          })
          .catch(function() {});
      })

    };

    //Delete image function
    vm.imageDelete = function(image){
      var objKey = vm.location.$id;
      var imgKey = image._key;
      $log.log(imgKey);
      $log.log(objKey);
      $log.log(ref);
      if (confirm('Weet je het zeker?')) {
        ref.child('locations/').child(vm.location.$id).child('/images').child(imgKey).remove().then(function () {
          toastr.success('Foto verwijderd!', 'De foto is verwijderd');
        });
      }
    }


    //save temp steps
    //saving to generate uid, so we can save multiple images to firebase storage
    vm.saveTemp = function(){

      var obj = $firebaseObject(ref.child('locations').child(id));
      obj.$loaded()
        .then(function() {
        obj = vm.location;
        obj.$save();
        })
        .catch(function() {
        });
        toastr.success('Het item is geupdate', 'Geupdate!');
      }


    vm.saveTemp2 = function(){
      vm.processing = true;

      var objKey = vm.location.$id;

      var obj = $firebaseObject(ref.child('locations').child(objKey));
      obj.$loaded()
        .then(function() {

          var updates = {};
          updates['/mainImage/'] = vm.mainImage;
          updates['/images'] = vm.location.images;

          ref.child('locations').child(objKey)
               .update(updates);

        })
        .catch(function() {

        });
        toastr.success('Gefeliciteerd! De foto\'s zijn opgeslagen!', 'Item opgeslagen');
    }

    //save temp step3 file
    vm.saveTemp3 = function(){

      vm.processing = true;
      var objKey = vm.location.$id;

      var obj = $firebaseObject(ref.child('locations').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('locations').child(objKey)
               .update({introduction:vm.location.introduction, full_story:vm.location.full_story});
        })
        .catch(function() {
          //console.error("Error:", error);
        });

        toastr.success('We zijn weer een stap verder!', 'Verhaal toegevoegd!');


    }

    // ref.child('locationsCounter')
    //   .once('value', function(snapshot){
    //     var data = snapshot.val();
    //     if (data) {
    //       vm.location.id = $filter('digits')(data+1,6);
    //     } else {
    //       vm.location.id = '000001';
    //     }
    //   });

    //Submit operation
    vm.submit = function() {
      vm.processing = true;

      var objKey = vm.location.$id;

      var obj = $firebaseObject(ref.child('locations').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('locations').child(objKey)
               .update({nationaal_erfgoed: {shared: vm.location.nationaal_erfgoed.shared, agreed: vm.location.nationaal_erfgoed.agreed}, status: 'waiting'});
        })
        .catch(function() {

        });
        $state.go('locations.list', {}, {reload: true});
        toastr.success('Gefeliciteerd! Je artikel is ingediend en wordt wellicht gepubliceerd!', 'Wachtend op publicatie');

    };


  }

  function ShowLocationController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.location = $firebaseObject(ref.child('locations').child(id));
    vm.locationsObject = $firebaseObject(ref.child('locations'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('H2gController', H2gController)
    .controller('NewH2gController', NewH2gController)
    .controller('EditH2gController', EditH2gController)
    .controller('ShowH2gController', ShowH2gController);

  /** @ngInject */
  function H2gController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;
    vm.activeStep = 0;

    //$log.log($scope);

    //console.log(vm);

    // General database variable
    var ref = firebase.database().ref();
    vm.h2gs = $firebaseArray(ref.child('h2g'));
    vm.h2gsObject = $firebaseObject(ref.child('h2g'));

    vm.locations = $firebaseArray(ref.child('locations'));
    vm.locationsObject = $firebaseObject(ref.child('locations'));

    vm.h2g_categories = $firebaseArray(ref.child('h2g_categories'));
    vm.h2g_categoriesObject = $firebaseObject(ref.child('h2g_categories'));

    vm.services = $firebaseArray(ref.child('services'));
    vm.servicesObject = $firebaseObject(ref.child('services'));

    vm.partners = $firebaseArray(ref.child('partners'));
    vm.partnersObject = $firebaseObject(ref.child('partners'));

    vm.cities = $firebaseArray(ref.child('cities'));
    vm.citiesObject = $firebaseObject(ref.child('cities'));
    //////////////////////////// *General database variable

    vm.h2g_categories.$loaded().then(function() {
      vm.childCategories = [];
      //extend array
      angular.forEach(vm.h2g_categories, function (value) {
        if (value.parentId && vm.h2g_categoriesObject[value.parentId]) {
          value.parentName = vm.h2g_categoriesObject[value.parentId].name;
          vm.childCategories.push(value);
        } else {
          if ($filter('filter')(vm.h2g_categories, {parentId: value.$id}).length === 0) {
            vm.childCategories.push(value);
          }
        }
      });
    });

    vm.cities.$loaded().then(function() {
      vm.childCities = [];
      //extend array
      angular.forEach(vm.cities, function (value) {
        if (value.parentId && vm.citiesObject[value.parentId]) {
          value.parentName = vm.citiesObject[value.parentId].name;
          vm.childCities.push(value);
        } else {
          if ($filter('filter')(vm.cities, {parentId: value.$id}).length === 0) {
            vm.childCities.push(value);
          }
        }
      });
    });

    vm.locations.$loaded().then(function() {
        vm.childlocations = [];
        //extend array
        angular.forEach(vm.locations, function (value) {
          if (value.parentId && vm.locationsObject[value.parentId]) {
            value.parentName = vm.locationsObject[value.parentId].name;
            vm.childlocations.push(value);
          } else {
            if ($filter('filter')(vm.locations, {parentId: value.$id}).length === 0) {
              vm.childlocations.push(value);
            }
          }
        });
      });

      vm.services.$loaded().then(function() {
        vm.childServices = [];

        //extend array
        angular.forEach(vm.services, function (value) {
          if (value.parentId && vm.servicesObject[value.parentId]) {
            //console.log(vm.childServices);
            value.parentName = vm.servicesObject[value.parentId].name;
            vm.childServices.push(value);
          } else {
            //console.log(vm.childServices);
            if ($filter('filter')(vm.services, {parentId: value.$id}).length === 0) {
              //console.log(value);
              vm.childServices.push(value);
            }
          }
        });
      });

      vm.partners.$loaded().then(function() {
        vm.childPartners = [];
        angular.forEach(vm.partners, function (value) {
          if (value.parentId && vm.partnersObject[value.parentId]) {
            value.parentName = vm.partnersObject[value.parentId].name;
            vm.childPartners.push(value);
          } else {
            if ($filter('filter')(vm.partners, {parentId: value.$id}).length === 0) {
              vm.childPartners.push(value);
            }
          }
        });
      });

    vm.statuses = {
      published: "published",
      concept: "concept",
      rejected: "rejected",
      waiting: "moderate"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (h2g) {
      if (confirm('Are you sure?')) {
        vm.h2gs.$remove(h2g).then(function () {
          toastr.success('Artikel verwijderd!', 'Het artikel is verwijderd');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.h2gs.$loaded().then(function() {

      //extend array
      function extendArray(){
        angular.forEach(vm.h2gs, function(value){
        //  $log.log(vm);
          if (value.category && vm.h2g_categoriesObject[value.category]) {
            value.h2g_categoryName = vm.h2g_categoriesObject[value.category].name;
          }
        });
        angular.forEach(vm.h2gs, function(value){
          if (value.location && vm.locationsObject[value.location]) {
            value.locationName = vm.locationsObject[value.location].name;
          }
        });
        angular.forEach(vm.h2gs, function(value){
          if (value.city && vm.citiesObject[value.city]) {
            value.cityName = vm.citiesObject[value.city].name;
          }
        });
      }
      extendArray();

      ///////////////////////////////////////////// *extend array

      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.h2gs;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.h2gs
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewH2gController($scope, toastr, $log, firebase, $firebaseArray, $firebaseObject, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        var d = new Date();
        var n = d.getTime();
        var x = Math.floor((Math.random() * 999999) + 1);

        return ref.child('/service/verhalensprokkelaar/' + vm.user.uid + '/' + x + '-' + n).put(file, metadata);

        // return ref.child('/service/verhalensprokkelaar/' + vm.user.uid + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var vm = this;
    vm.user = firebase.auth().currentUser;

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    //Watch images & upload
    $scope.$watch('vm.h2g.imagess', function () {
        if (vm.h2g.imagess != null) {
          storageRef.putFiles(vm.h2g.imagess).then(function(metadatas) {
            var file = metadatas[0].a;
            var fb_ref= ref.child('h2gs/').child(vm.h2gObject.$id).child('/images');
            fb_ref.push({
              src: file.downloadURLs[0],
              updated_at: firebase.database.ServerValue.TIMESTAMP,
              path: file.fullPath,
              main_image: "false",
              caption: null,
              copyright: null
            }).then(function(joehoe){
              ref.child('h2gs/').child(vm.h2gObject.$id).child('/images').child(joehoe.key)
                .update({_key:joehoe.key});
            })
            reloadImage();
          }).catch(function(error) {
            // If any task fails, handle this
            vm.processing = false;
            $log.error('Upload failed:', error);
          });
        }
      });

    function reloadImage (){
      var objKey = vm.h2gObject.$id;

      vm.h2g = $firebaseObject(ref.child('h2g').child(objKey));

    }

    $scope.$watch('vm.h2g.images', function (){});


    vm.updateImageSelect = function(image){
      var checkImages = vm.h2g.images;
      angular.forEach(checkImages, function (b) {
        b.main_image = image === b;

        vm.mainImage = b;
        $log.log(vm);
      })

    };

    //Delete image function
    vm.imageDelete = function(image){
     // var objKey = vm.h2gObject.$id;
      var imgKey = image._key;
      if (confirm('Weet je het zeker?')) {
        ref.child('h2gs/').child(vm.h2gObject.$id).child('/images').child(imgKey).remove().then(function () {
          toastr.success('Foto verwijderd!', 'De foto is verwijderd');
        });
      }
    }


    //save temp steps
    //saving to generate uid, so we can save multiple images to firebase storage
    vm.saveTemp = function(){
      vm.processing = true;
      //$log.log(vm);

      if(typeof vm.h2gObject !== 'undefined'){
        $log.log('exists!');
        var objKey = vm.h2gObject.$id;
        ref.child('h2g').child(objKey).update(vm.h2g);

      } else {

        vm.h2gs.$add(vm.h2g).then(function (h2gRef) {
          ref.child('h2gsCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);
              ref.child('h2g').child(h2gRef.key)
                .update({id: id, author: vm.user.uid, created_at: firebase.database.ServerValue.TIMESTAMP, status: 'concept', pushradius:"25", geolocation: "null", nationaal_erfgoed: {shared: true, agreed: false}});
                vm.h2gObject = $firebaseObject(ref.child('h2g').child(h2gRef.key));
            }
          });
          toastr.success('Gefeliciteerd! Stap 1 is achter de rug!', 'Item opgeslagen');
        });

      }

    }

    vm.saveTemp2 = function(){
      vm.processing = true;

      var objKey = vm.h2gObject.$id;

      var obj = $firebaseObject(ref.child('h2g').child(objKey));
      obj.$loaded()
        .then(function() {

          var updates = {};
          updates['/mainImage/'] = vm.mainImage;
          updates['/images'] = vm.h2g.images;

          ref.child('h2g').child(objKey)
               .update(updates);
        })
        .catch(function() {

        });
        toastr.success('Gefeliciteerd! De foto\'s zijn opgeslagen!', 'Item opgeslagen');
    }

    //save temp step3 file
    vm.saveTemp3 = function(){

      vm.processing = true;
      var objKey = vm.h2gObject.$id;

      var obj = $firebaseObject(ref.child('h2g').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('h2g').child(objKey)
               .update({introduction:vm.h2g.introduction, full_story:vm.h2g.full_story});
        })
        .catch(function() {
          //console.error("Error:", error);
        });

        toastr.success('We zijn weer een stap verder!', 'Verhaal toegevoegd!');


    }

    vm.h2gs = $firebaseArray(ref.child('h2g'));
    vm.h2g = {};
    vm.h2g = {
      pushradius: '50',
      mapdata:{
        latitude: '52.376879',
        longitude: '4.901941'
      }
    };
    //map en input lat/lng aanpassen na verplaatsen marker
    vm.getCurrentLocation = function(event){
      vm.pos = this.getPosition();
      vm.h2g.mapdata.latitude   = vm.pos.lat();
      vm.h2g.mapdata.longitude  = vm.pos.lng();

    }

    $log.log(vm);

    vm.processing = false;

    ref.child('h2gsCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.h2g.id = $filter('digits')(data+1,6);
        } else {
          vm.h2g.id = '000001';
        }
      });

    //Submit operation
    vm.submit = function() {
      vm.processing = true;

      var objKey = vm.h2gObject.$id;

      var obj = $firebaseObject(ref.child('h2g').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('h2g').child(objKey)
               .update({nationaal_erfgoed: {shared: vm.h2g.nationaal_erfgoed.shared, agreed: vm.h2g.nationaal_erfgoed.agreed}, status: 'waiting'});
        })
        .catch(function() {

        });
        $state.go('h2gs.list', {}, {reload: true});
        toastr.success('Gefeliciteerd! Je artikel is ingediend en wordt wellicht gepubliceerd!', 'Wachtend op publicatie');

    };
    /////////////////////// *Submit operation
  }

  function EditH2gController($scope, toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/h2gs/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;
    $log.log(vm);

    vm.h2g = $firebaseObject(ref.child('h2g').child(id));
    vm.h2gs = $firebaseArray(ref.child('h2g'));

    vm.editing = true;
    vm.processing = false;

    //Watch images & upload
    $scope.$watch('vm.h2g.imagess', function () {
        if (vm.h2g.imagess != null) {
          storageRef.putFiles(vm.h2g.imagess).then(function(metadatas) {
            var file = metadatas[0].a;
            var fb_ref= ref.child('h2gs/').child(vm.h2g.$id).child('/images');
            fb_ref.push({
              src: file.downloadURLs[0],
              updated_at: firebase.database.ServerValue.TIMESTAMP,
              path: file.fullPath,
              main_image: 'false',
              caption: null,
              copyright: null
            }).then(function(joehoe){
              ref.child('h2gs/').child(vm.h2g.$id).child('/images').child(joehoe.key)
                .update({_key:joehoe.key});
            })
            reloadImage();
          }).catch(function(error) {
            // If any task fails, handle this
            vm.processing = false;
            $log.error('Upload failed:', error);
          });
        }
      });

    function reloadImage (){
      var objKey = vm.h2g.$id;

      vm.h2g = $firebaseObject(ref.child('h2g').child(objKey));

    }

    $scope.$watch('vm.h2g.images', function (){
      //$log.log('asasas');
    });


    vm.updateImageSelect = function(image){
      var checkImages = vm.h2g.images;
      angular.forEach(checkImages, function (b) {
        b.main_image = image === b;

        vm.mainImage = b;
        $log.log(vm);
      })

    };

    //Delete image function
    vm.imageDelete = function(image){
      var objKey = vm.h2g.$id;
      var imgKey = image._key;
      $log.log(imgKey);
      $log.log(objKey);
      $log.log(ref);
      if (confirm('Weet je het zeker?')) {
        ref.child('h2gs/').child(vm.h2g.$id).child('/images').child(imgKey).remove().then(function () {
          toastr.success('Foto verwijderd!', 'De foto is verwijderd');
        });
      }
    }


    //save temp steps
    //saving to generate uid, so we can save multiple images to firebase storage
    vm.saveTemp = function(){

      var obj = $firebaseObject(ref.child('h2g').child(id));
      obj.$loaded()
        .then(function() {
        obj = vm.h2g;
        obj.$save();
        })
        .catch(function() {
        });
        toastr.success('Het item is geupdate', 'Geupdate!');
      }


    vm.saveTemp2 = function(){
      vm.processing = true;

      var objKey = vm.h2g.$id;

      var obj = $firebaseObject(ref.child('h2g').child(objKey));
      obj.$loaded()
        .then(function() {

          var updates = {};
          updates['/mainImage/'] = vm.mainImage;
          updates['/images'] = vm.h2g.images;

          ref.child('h2g').child(objKey)
               .update(updates);

        })
        .catch(function() {

        });
        toastr.success('Gefeliciteerd! De foto\'s zijn opgeslagen!', 'Item opgeslagen');
    }

    //save temp step3 file
    vm.saveTemp3 = function(){

      vm.processing = true;
      var objKey = vm.h2g.$id;

      var obj = $firebaseObject(ref.child('h2g').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('h2g').child(objKey)
               .update({introduction:vm.h2g.introduction, full_story:vm.h2g.full_story});
        })
        .catch(function() {
          //console.error("Error:", error);
        });

        toastr.success('We zijn weer een stap verder!', 'Verhaal toegevoegd!');


    }

    // ref.child('h2gsCounter')
    //   .once('value', function(snapshot){
    //     var data = snapshot.val();
    //     if (data) {
    //       vm.h2g.id = $filter('digits')(data+1,6);
    //     } else {
    //       vm.h2g.id = '000001';
    //     }
    //   });

    //Submit operation
    vm.submit = function() {
      vm.processing = true;

      var objKey = vm.h2g.$id;

      var obj = $firebaseObject(ref.child('h2g').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('h2g').child(objKey)
               .update({nationaal_erfgoed: {shared: vm.h2g.nationaal_erfgoed.shared, agreed: vm.h2g.nationaal_erfgoed.agreed}, status: 'waiting'});
        })
        .catch(function() {

        });
        $state.go('h2gs.list', {}, {reload: true});
        toastr.success('Gefeliciteerd! Je artikel is ingediend en wordt wellicht gepubliceerd!', 'Wachtend op publicatie');

    };


  }

  function ShowH2gController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.h2g = $firebaseObject(ref.child('h2g').child(id));
    vm.h2gsObject = $firebaseObject(ref.child('h2g'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('ForgotpassController', ForgotpassController);

  /** @ngInject */
  function ForgotpassController(currentAuth, Auth, $log, $state, toastr) {
    var vm = this;

    vm.currentAuth = currentAuth;

    //redirect if user is logged in
    if (vm.currentAuth) {
      $state.go('dashboard', {}, {reload: true});
    }

    vm.submit = function() {
      Auth.$sendPasswordResetEmail(vm.email)
        .then(function() {
          $log.log("Password reset email sent successfully");
          toastr.success('Your password has been reseted, check your email', 'Password reset!');
          $state.go('core.login', {}, {reload: true});
        }, function(error) {
          $log.log("Error sending password reset email:", error);
          toastr.error(error.code, 'Reset Error!');
        });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('DashboardController', DashboardController)

  /** @ngInject */
  function DashboardController($timeout, NgMap, toastr, $firebaseArray, firebase, $filter) {
    var vm = this;
    //console.log(vm);



    //toastr.success('All crud operations are disabled for demo purposes on firebase db level, but will be functional on your own firebase database', 'CRUD Operations Disabled!', {progressBar: true, timeOut: '30000'});

    // General database variable
    var ref = firebase.database().ref();
    vm.bappzs = $firebaseArray(ref.child('bappzs'));
    vm.locations = $firebaseArray(ref.child('locations'));
    vm.stories = $firebaseArray(ref.child('stories'));
    vm.h2days = $firebaseArray(ref.child('h2days'));
    vm.users = $firebaseArray(ref.child('users'));
    vm.categories = $firebaseArray(ref.child('categories'));
    //////////////////////////// *General database variable

    vm.bappzs.$loaded(function(){
      vm.bappzModerate = $filter('filter')(vm.bappzs, {status: 'waiting'});

    });

    vm.users.$loaded(function(){
      vm.activeverhalensprokkelaarUsers = $filter('filter')(vm.users, {blocked: false, neService:{verhalensprokkelaar:true}});
      vm.activeUsers = $filter('filter')(vm.users);

    });

    //maps

    //MAPS



  }


})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('CategoriesController', CategoriesController)
    .controller('NewCategoryController', NewCategoryController)
    .controller('EditCategoryController', EditCategoryController)
    .controller('ShowCategoryController', ShowCategoryController);

  /** @ngInject */
  function CategoriesController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.categories = $firebaseArray(ref.child('categories'));
    vm.categoriesObject = $firebaseObject(ref.child('categories'));
    //////////////////////////// *General database variable

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (category) {
      if (confirm('Are you sure?')) {
        vm.categories.$remove(category).then(function () {
          $log.log('category deleted');
          toastr.success('Category Removed!', 'Category has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.categories.$loaded().then(function() {

      //extend array
      angular.forEach(vm.categories, function(value){
        if (value.parentId && vm.categoriesObject[value.parentId]) {
          value.parentName = vm.categoriesObject[value.parentId].name;
        }
      });
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.categories;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.categories
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewCategoryController(toastr, $log, firebase, $firebaseArray, $state){
    var vm = this;
    var ref = firebase.database().ref();

    vm.categories = $firebaseArray(ref.child('categories'));

    // Submit operation
    vm.submit = function() {
      if (!vm.category.parentId) {
        vm.category.parent = true;
      } else {
        vm.category.parent = false;
      }
      vm.categories.$add(vm.category).then(function (categoryRef) {
        ref.child('categories').child(categoryRef.key)
          .update({created_at: firebase.database.ServerValue.TIMESTAMP});
        toastr.success('Category Added!', 'Category has been created');
        $state.go('categories.list', {}, {reload: true});
      });
    };
    /////////////////////// *Submit operation
  }

  function EditCategoryController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.category = $firebaseObject(ref.child('categories').child(id));
    vm.categories = $firebaseArray(ref.child('categories'));

    vm.categories.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        if (!vm.category.parentId) {
          vm.category.parent = true;
        } else {
          vm.category.parent = false;
        }
        vm.category.$save().then(function (categoryRef) {
          ref.child('categories').child(categoryRef.key)
            .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
          toastr.success('Category Saved!', 'Category has been saved');
          $state.go('categories.list', {}, {reload: true});
        });
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowCategoryController(firebase, $firebaseObject, $stateParams){
     var ref = firebase.database().ref();
      var vm = this;
      var id = $stateParams.id;

      vm.category = $firebaseObject(ref.child('categories').child(id));
      vm.categoriesObject = $firebaseObject(ref.child('categories'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('BappzsController', BappzsController)
    .controller('NewBappzController', NewBappzController)
    .controller('EditBappzController', EditBappzController)
    .controller('ShowBappzController', ShowBappzController);

  /** @ngInject */
  function BappzsController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;
    vm.activeStep = 0;

    // General database variable
    var ref = firebase.database().ref();
    vm.bappzs = $firebaseArray(ref.child('bappzs'));
    vm.bappzsObject = $firebaseObject(ref.child('bappzs'));

    vm.locations = $firebaseArray(ref.child('locations'));
    vm.locationsObject = $firebaseObject(ref.child('locations'));

    vm.bappz_categories = $firebaseArray(ref.child('bappz_categories'));
    vm.bappz_categoriesObject = $firebaseObject(ref.child('bappz_categories'));

    vm.services = $firebaseArray(ref.child('services'));
    vm.servicesObject = $firebaseObject(ref.child('services'));

    vm.partners = $firebaseArray(ref.child('partners'));
    vm.partnersObject = $firebaseObject(ref.child('partners'));

    vm.cities = $firebaseArray(ref.child('cities'));
    vm.citiesObject = $firebaseObject(ref.child('cities'));

    vm.users = $firebaseArray(ref.child('users'));
    vm.usersObject = $firebaseObject(ref.child('users'));
    //////////////////////////// *General database variable

    vm.bappz_categories.$loaded().then(function() {
      vm.childCategories = [];
      //extend array
      angular.forEach(vm.bappz_categories, function (value) {
        if (value.parentId && vm.bappz_categoriesObject[value.parentId]) {
          value.parentName = vm.bappz_categoriesObject[value.parentId].name;
          vm.childCategories.push(value);
        } else {
          if ($filter('filter')(vm.bappz_categories, {parentId: value.$id}).length === 0) {
            vm.childCategories.push(value);
          }
        }
      });
    });

    vm.users.$loaded().then(function() {
      vm.childUsers = [];
      //extend array
      angular.forEach(vm.users, function (value) {
        if (value.parentId && vm.usersObject[value.parentId]) {
          value.parentName = vm.usersObject[value.parentId].name;
          vm.childUsers.push(value);
        } else {
          if ($filter('filter')(vm.users, {parentId: value.$id}).length === 0) {
            vm.childUsers.push(value);
          }
        }
      });
    });

    vm.cities.$loaded().then(function() {
      vm.childCities = [];
      //extend array
      angular.forEach(vm.cities, function (value) {
        if (value.parentId && vm.citiesObject[value.parentId]) {
          value.parentName = vm.citiesObject[value.parentId].name;
          vm.childCities.push(value);
        } else {
          if ($filter('filter')(vm.cities, {parentId: value.$id}).length === 0) {
            vm.childCities.push(value);
          }
        }
      });
    });

    vm.locations.$loaded().then(function() {
        vm.childlocations = [];
        //extend array
        angular.forEach(vm.locations, function (value) {
          if (value.parentId && vm.locationsObject[value.parentId]) {
            value.parentName = vm.locationsObject[value.parentId].name;
            vm.childlocations.push(value);
          } else {
            if ($filter('filter')(vm.locations, {parentId: value.$id}).length === 0) {
              vm.childlocations.push(value);
            }
          }
        });
      });

      vm.services.$loaded().then(function() {
        vm.childServices = [];

        //extend array
        angular.forEach(vm.services, function (value) {
          if (value.parentId && vm.servicesObject[value.parentId]) {
            //console.log(vm.childServices);
            value.parentName = vm.servicesObject[value.parentId].name;
            vm.childServices.push(value);
          } else {
            //console.log(vm.childServices);
            if ($filter('filter')(vm.services, {parentId: value.$id}).length === 0) {
              //console.log(value);
              vm.childServices.push(value);
            }
          }
        });
      });

      vm.partners.$loaded().then(function() {
        vm.childPartners = [];
        angular.forEach(vm.partners, function (value) {
          if (value.parentId && vm.partnersObject[value.parentId]) {
            value.parentName = vm.partnersObject[value.parentId].name;
            vm.childPartners.push(value);
          } else {
            if ($filter('filter')(vm.partners, {parentId: value.$id}).length === 0) {
              vm.childPartners.push(value);
            }
          }
        });
      });

    vm.statuses = {
      published: "published",
      concept: "concept",
      rejected: "rejected",
      waiting: "waiting",
      moderated: "moderated"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (bappz) {
      if (confirm('Are you sure?')) {
        vm.bappzs.$remove(bappz).then(function () {
          toastr.success('Artikel verwijderd!', 'Het artikel is verwijderd');
        });
      }
    };

    vm.publish = function (bappz) {
      if (confirm('Are you sure you want to publish?')) {

        var objKey = bappz.$id;
        //load fb
        var obj = $firebaseObject(ref.child('bappzs').child(objKey));
        obj.$loaded()
          .then(function() {
            ref.child('bappzs').child(objKey)
                 .update({status:'published'});
                 toastr.success('Verhaal gepubliceerd!', 'Het verhaal is gepubliceerd');
          })
          .catch(function() {});

        // vm.bappzs.$remove(bappz).then(function () {
        //
        // });
      }
    };

    vm.reject = function (bappz) {
      if (confirm('Are you sure you want to reject this story?')) {

        var objKey = bappz.$id;
        //load fb
        var obj = $firebaseObject(ref.child('bappzs').child(objKey));
        obj.$loaded()
          .then(function() {
            ref.child('bappzs').child(objKey)
                 .update({status:'rejected'});
                //vm.tableParamsModerate.reload();
                 toastr.success('Verhaal afgewezen!', 'Het verhaal is afgewezen');
          })
          .catch(function() {});

        // vm.bappzs.$remove(bappz).then(function () {
        //
        // });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table bappz
    vm.bappzs.$loaded().then(function() {

    //  vm.bappzModerate = $filter('filter')(vm.bappzs, {status: 'waiting'});

      //extend array
      function extendArray(){
        angular.forEach(vm.bappzs, function(value){
          if (value.category && vm.bappz_categoriesObject[value.category]) {
            value.bappz_categoryName = vm.bappz_categoriesObject[value.category].name;
          }
        });
        angular.forEach(vm.bappzs, function(value){
          if (value.author && vm.usersObject[value.author]) {
            value.usersName = vm.usersObject[value.author].name;
          }
        });
        angular.forEach(vm.bappzs, function(value){
          if (value.location && vm.locationsObject[value.location]) {
            value.locationName = vm.locationsObject[value.location].name;
          }
        });
        angular.forEach(vm.bappzs, function(value){
          if (value.city && vm.citiesObject[value.city]) {
            value.cityName = vm.citiesObject[value.city].name;
          }
        });
      }
      extendArray();

      ///////////////////////////////////////////// *extend array

      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.bappzs;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
          vm.tableParamsModerate.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
          vm.tableParamsModerate.filter({ $: newVal });
          vm.tableParamsModerate.reload();
        }
      });

      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.bappzs
      });

      vm.tableParamsModerate = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        },
        filter: { status: "waiting" }
      }, {
        dataset: vm.bappzs
      });

    });


    ////////////////////////////////////////// *Initialize table

  }

  function NewBappzController($scope, toastr, $log, firebase, $firebaseArray, $firebaseObject, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        var d = new Date();
        var n = d.getTime();
        var x = Math.floor((Math.random() * 999999) + 1);

        var uploadTask = ref.child('/service/verhalensprokkelaar/' + vm.bappz.title + '/' + x + '-' + n).put(file, metadata);
        vm.currentImage = vm.currentImage + 1;

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            vm.progress = progress;
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                break;
            }
          }, function(error) {
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break;
              case 'storage/canceled':
                // User canceled the upload
                break;
              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break;
          }
        });

        return uploadTask;

      }));
    };
    /* eslint-enable */

    var vm = this;
    vm.user = firebase.auth().currentUser;

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    vm.processing = false;

    //Watch images & upload
    $scope.$watch('vm.bappz.imagess', function () {

        if (vm.bappz.imagess != null) {
          // $log.log(vm);
          vm.currentImage = 0;
          vm.totalImages = vm.bappz.imagess.length;
          vm.processing = true;

          storageRef.putFiles(vm.bappz.imagess).then(function(metadatas) {

            angular.forEach(metadatas, function(meta){
              var file = meta.a;

                var fb_ref= ref.child('bappzs/').child(vm.bappzObject.$id).child('/images');
                fb_ref.push({
                  src: file.downloadURLs[0],
                  updated_at: firebase.database.ServerValue.TIMESTAMP,
                  path: file.fullPath,
                  main_image: "false",
                  caption: null,
                  copyright: null
                }).then(function(joehoe){
                  ref.child('bappzs/').child(vm.bappzObject.$id).child('/images').child(joehoe.key)
                    .update({_key:joehoe.key});
                })
                reloadImage();
                vm.processing = false;
            });

          }).catch(function(error) {
            // If any task fails, handle this
            vm.processing = false;
            $log.error('Upload failed:', error);
          });

        }
      });

    function reloadImage (){
      var objKey = vm.bappzObject.$id;

      vm.bappz = $firebaseObject(ref.child('bappzs').child(objKey));

    }

    $scope.$watch('vm.bappz.images', function (){});


    vm.updateImageSelect = function(image){
      var checkImages = vm.bappz.images;
      angular.forEach(checkImages, function (b) {
        //compare data
        b.main_image = image === b;
        //set object key
        var objKey = vm.bappz.$id;
        //load fb
        var obj = $firebaseObject(ref.child('bappzs').child(objKey));
        obj.$loaded()
          .then(function() {
            ref.child('bappzs').child(objKey).child('/images').child(b._key)
                 .update({main_image:b.main_image});
          })
          .catch(function() {});
      })

    };

    //Delete image function
    vm.imageDelete = function(image){
     // var objKey = vm.bappzObject.$id;
      var imgKey = image._key;
      if (confirm('Weet je het zeker?')) {
        ref.child('bappzs/').child(vm.bappzObject.$id).child('/images').child(imgKey).remove().then(function () {
          toastr.success('Foto verwijderd!', 'De foto is verwijderd');
        });
      }
    }


    //save temp steps
    //saving to generate uid, so we can save multiple images to firebase storage
    vm.saveTemp = function(){
      if(typeof vm.bappzObject !== 'undefined'){
        $log.log('exists!');
        var objKey = vm.bappzObject.$id;
        ref.child('bappzs').child(objKey).update(vm.bappz);

      } else {

        vm.bappzs.$add(vm.bappz).then(function (bappzRef) {
          ref.child('bappzsCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);
              ref.child('bappzs').child(bappzRef.key)
                .update({id: id, author: vm.user.uid, created_at: firebase.database.ServerValue.TIMESTAMP, status: 'concept', pushradius:"25", geolocation: "null", nationaal_erfgoed: {shared: true, agreed: false}});
                vm.bappzObject = $firebaseObject(ref.child('bappzs').child(bappzRef.key));
            }
          });
          toastr.success('Gefeliciteerd! Stap 1 is achter de rug!', 'Item opgeslagen');
        });

      }

    }

    vm.saveTemp2 = function(){

        toastr.success('Gefeliciteerd! De foto\'s zijn opgeslagen!', 'Item opgeslagen');
    }

    //save temp step3 file
    vm.saveTemp3 = function(){

      var objKey = vm.bappzObject.$id;

      var obj = $firebaseObject(ref.child('bappzs').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('bappzs').child(objKey)
               .update({introduction:vm.bappz.introduction, full_story:vm.bappz.full_story});
        })
        .catch(function() {
          //console.error("Error:", error);
        });

        toastr.success('We zijn weer een stap verder!', 'Verhaal toegevoegd!');


    }

    vm.bappzs = $firebaseArray(ref.child('bappzs'));
    vm.bappz = {};


    ref.child('bappzsCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.bappz.id = $filter('digits')(data+1,6);
        } else {
          vm.bappz.id = '000001';
        }
      });

    //Submit operation
    vm.submit = function() {

      var objKey = vm.bappzObject.$id;

      var obj = $firebaseObject(ref.child('bappzs').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('bappzs').child(objKey)
               .update({nationaal_erfgoed: {shared: vm.bappz.nationaal_erfgoed.shared, agreed: vm.bappz.nationaal_erfgoed.agreed}, status: 'waiting'});
        })
        .catch(function() {

        });
        $state.go('bappzs.list', {}, {reload: true});
        toastr.success('Gefeliciteerd! Je artikel is ingediend en wordt wellicht gepubliceerd!', 'Wachtend op publicatie');

    };
    /////////////////////// *Submit operation
  }

  function EditBappzController($scope, toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        var d = new Date();
        var n = d.getTime();
        var x = Math.floor((Math.random() * 999999) + 1);

        var uploadTask = ref.child('/service/verhalensprokkelaar/' + vm.bappz.title + '/' + x + '-' + n).put(file, metadata);
        vm.currentImage = vm.currentImage + 1;

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            vm.progress = progress;
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                break;
            }
          }, function(error) {
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break;
              case 'storage/canceled':
                // User canceled the upload
                break;
              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break;
          }
        });

        return uploadTask;

      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;
    //$log.log(vm);

    vm.bappz = $firebaseObject(ref.child('bappzs').child(id));
    vm.bappzs = $firebaseArray(ref.child('bappzs'));

    vm.editing = true;
    vm.processing = false;

    //Watch images & upload
    $scope.$watch('vm.bappz.imagess', function () {

        if (vm.bappz.imagess != null) {
          //$log.log(vm);
          vm.currentImage = 0;
          vm.totalImages = vm.bappz.imagess.length;
          vm.processing = true;

          storageRef.putFiles(vm.bappz.imagess).then(function(metadatas) {

            angular.forEach(metadatas, function(meta){
              var file = meta.a;

                var fb_ref= ref.child('bappzs/').child(vm.bappz.$id).child('/images');
                fb_ref.push({
                  src: file.downloadURLs[0],
                  updated_at: firebase.database.ServerValue.TIMESTAMP,
                  path: file.fullPath,
                  main_image: "false",
                  caption: null,
                  copyright: null
                }).then(function(joehoe){
                  ref.child('bappzs/').child(vm.bappz.$id).child('/images').child(joehoe.key)
                    .update({_key:joehoe.key});
                })
                reloadImage();
                vm.processing = false;
            });

          }).catch(function(error) {
            // If any task fails, handle this
            vm.processing = false;
            $log.error('Upload failed:', error);
          });

        }
      });

    function reloadImage (){
      var objKey = vm.bappz.$id;

      vm.bappz = $firebaseObject(ref.child('bappzs').child(objKey));

    }

    $scope.$watch('vm.bappz.images', function (){
      //$log.log('asasas');
    });


    vm.updateImageSelect = function(image){
      var checkImages = vm.bappz.images;
      angular.forEach(checkImages, function (b) {
        //compare data
        b.main_image = image === b;
        //set object key
        //$log.log(b);
        var objKey = vm.bappz.$id;
        //load fb
        var obj = $firebaseObject(ref.child('bappzs').child(objKey));
        obj.$loaded()
          .then(function() {
            ref.child('bappzs').child(objKey).child('/images').child(b._key)
                 .update({main_image:b.main_image});
          })
          .catch(function() {});
      })

    };

    //Delete image function
    vm.imageDelete = function(image){
      var imgKey = image._key;
      if (confirm('Weet je het zeker?')) {
        ref.child('bappzs/').child(vm.bappz.$id).child('/images').child(imgKey).remove().then(function () {
          toastr.success('Foto verwijderd!', 'De foto is verwijderd');
        });
      }
    }


    //save temp steps
    //saving to generate uid, so we can save multiple images to firebase storage
    vm.saveTemp = function(){

      var obj = $firebaseObject(ref.child('bappzs').child(id));
      obj.$loaded()
        .then(function() {
        obj = vm.bappz;
        obj.$save();
        })
        .catch(function() {
        });
        toastr.success('Het item is geupdate', 'Geupdate!');
      }


    vm.saveTemp2 = function(){

      toastr.success('Gefeliciteerd! De foto\'s zijn opgeslagen!', 'Item opgeslagen');
    }

    //save temp step3 file
    vm.saveTemp3 = function(){

      var objKey = vm.bappz.$id;

      var obj = $firebaseObject(ref.child('bappzs').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('bappzs').child(objKey)
               .update({introduction:vm.bappz.introduction, full_story:vm.bappz.full_story});
        })
        .catch(function() {
          //console.error("Error:", error);
        });

        toastr.success('We zijn weer een stap verder!', 'Verhaal toegevoegd!');


    }


    //Submit operation
    vm.submit = function() {
      var objKey = vm.bappz.$id;

      var obj = $firebaseObject(ref.child('bappzs').child(objKey));
      obj.$loaded()
        .then(function() {
          ref.child('bappzs').child(objKey)
               .update({nationaal_erfgoed: {shared: vm.bappz.nationaal_erfgoed.shared, agreed: vm.bappz.nationaal_erfgoed.agreed}, status: 'waiting'});
        })
        .catch(function() {

        });
        $state.go('bappzs.list', {}, {reload: true});
        toastr.success('Gefeliciteerd! Je artikel is ingediend en wordt wellicht gepubliceerd!', 'Wachtend op publicatie');

    };


  }

  function ShowBappzController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.bappz = $firebaseObject(ref.child('bappzs').child(id));
    vm.bappzsObject = $firebaseObject(ref.child('bappzs'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('CategoriesController', CategoriesController)
    .controller('NewCategoryController', NewCategoryController)
    .controller('EditCategoryController', EditCategoryController)
    .controller('ShowCategoryController', ShowCategoryController);

  /** @ngInject */
  function CategoriesController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.bappz_categories = $firebaseArray(ref.child('bappz_categories'));
    vm.bappz_categoriesObject = $firebaseObject(ref.child('bappz_categories'));
    //////////////////////////// *General database variable

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (bappz_category) {
      if (confirm('Are you sure?')) {
        vm.bappz_categories.$remove(bappz_category).then(function () {
          $log.log('bappz_category deleted');
          toastr.success('Category Removed!', 'Category has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.bappz_categories.$loaded().then(function() {

      //extend array
      angular.forEach(vm.bappz_categories, function(value){
        if (value.parentId && vm.bappz_categoriesObject[value.parentId]) {
          value.parentName = vm.bappz_categoriesObject[value.parentId].name;
        }
      });
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.bappz_categories;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.bappz_categories
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewCategoryController(toastr, $log, firebase, $firebaseArray, $state){
    var vm = this;
    var ref = firebase.database().ref();

    vm.bappz_categories = $firebaseArray(ref.child('bappz_categories'));

    // Submit operation
    vm.submit = function() {

      vm.bappz_categories.$add(vm.bappz_category).then(function (bappz_categoryRef) {
        ref.child('bappz_categories').child(bappz_categoryRef.key)
          .update({created_at: firebase.database.ServerValue.TIMESTAMP});
        toastr.success('Category Added!', 'Category has been created');
        $state.go('bappz_categories.list', {}, {reload: true});
      });
    };
    /////////////////////// *Submit operation
  }

  function EditCategoryController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.bappz_category = $firebaseObject(ref.child('bappz_categories').child(id));
    vm.bappz_categories = $firebaseArray(ref.child('bappz_categories'));

    vm.bappz_categories.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        if (!vm.bappz_category.parentId) {
          vm.bappz_category.parent = true;
        } else {
          vm.bappz_category.parent = false;
        }
        vm.bappz_category.$save().then(function (bappz_categoryRef) {
          ref.child('bappz_categories').child(bappz_categoryRef.key)
            .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
          toastr.success('Category Saved!', 'Category has been saved');
          $state.go('bappz_categories.list', {}, {reload: true});
        });
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowCategoryController(firebase, $firebaseObject, $stateParams){
     var ref = firebase.database().ref();
      var vm = this;
      var id = $stateParams.id;

      vm.bappz_category = $firebaseObject(ref.child('bappz_categories').child(id));
      vm.bappz_categoriesObject = $firebaseObject(ref.child('bappz_categories'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .filter('digits', digits);

  /** @ngInject */
  function digits() {
    return function(input, digits) {
      if (digits === 2) {
        if (input < 10) {
          input = '0' + input;
        }
      }
      if (digits === 3) {
        if (input < 10) {
          input = '00' + input;
        } else if (input >= 10 && input < 100) {
          input = '0' + input;
        }
      }
      if (digits === 4) {
        if (input < 10) {
          input = '000' + input;
        } else if (input >= 10 && input < 100) {
          input = '00' + input;
        } else if (input >= 100 && input < 1000) {
          input = '0' + input;
        }
      }
      if (digits === 5) {
        if (input < 10) {
          input = '0000' + input;
        } else if (input >= 10 && input < 100) {
          input = '000' + input;
        } else if (input >= 100 && input < 1000) {
          input = '00' + input;
        } else if (input >= 1000 && input < 10000) {
          input = '0' + input;
        }
      }
      if (digits === 6) {
        if (input < 10) {
          input = '00000' + input;
        } else if (input >= 10 && input < 100) {
          input = '0000' + input;
        } else if (input >= 100 && input < 1000) {
          input = '000' + input;
        } else if (input >= 1000 && input < 10000) {
          input = '00' + input;
        } else if (input >= 10000 && input < 100000) {
          input = '0' + input;
        }
      }

      return input;
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .factory('Auth', Auth);

  /** @ngInject */
  function Auth($firebaseAuth) {
    return $firebaseAuth();
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('vectorMap', vectorMap);

  /** @ngInject */
  function vectorMap() {
    var directive = {
      restrict: 'AE',
      scope: {
        options: '='
      },
      link: function postLink(scope, element) {
        var options = scope.options;
        element.vectorMap(options);
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('validateOnSubmit', validateOnSubmit);

  /** @ngInject */
  function validateOnSubmit() {
    var directive = {
      require: 'form',
      restrict: 'A',
      link: function( scope , element , attributes ){
        var $element = angular.element(element);
        $element.on('submit', function() {
          $element.find('.ng-pristine').removeClass('ng-pristine').addClass('ng-dirty');
          var form = scope[ attributes.name ];
          angular.forEach( form , function ( formElement , fieldName ) {
            if ( fieldName[0] === '$' ) {return;}
            formElement.$pristine = false;
            formElement.$dirty = true;
          },this);
          form.$setDirty();
          scope.$apply();
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('sparkline', sparkline);

  /** @ngInject */
  function sparkline($timeout) {
    var directive = {
      restrict: 'A',
      scope: {
        data: '=',
        options: '='
      },
      link: function($scope, $el) {
        var data = $scope.data,
            options = $scope.options,
            chartResize,
            chartRedraw = function() {
              return $el.sparkline(data, options);
            };

        angular.element(window).resize(function() {
          clearTimeout(chartResize);
          chartResize = $timeout(chartRedraw, 200);
        });

        return chartRedraw();
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('slimscroll', slimscroll);

  /** @ngInject */
  function slimscroll() {
    var directive = {
      restrict: 'A',
      link: function ($scope, $elem, $attr) {
        var off = [];
        var option = {};

        var refresh = function () {
          if ($attr.slimscroll) {
            option = $scope.$eval($attr.slimscroll);
          } else if ($attr.slimscrollOption) {
            option = $scope.$eval($attr.slimscrollOption);
          }

          angular.element($elem).slimScroll({ destroy: true });

          angular.element($elem).slimScroll(option);
        };

        var registerWatch = function () {
          if ($attr.slimscroll && !option.noWatch) {
            off.push($scope.$watchCollection($attr.slimscroll, refresh));
          }

          if ($attr.slimscrollWatch) {
            off.push($scope.$watchCollection($attr.slimscrollWatch, refresh));
          }

          if ($attr.slimscrolllistento) {
            off.push($scope.$on($attr.slimscrolllistento, refresh));
          }
        };

        var destructor = function () {
          angular.element($elem).slimScroll({ destroy: true });
          off.forEach(function (unbind) {
            unbind();
          });
          off = null;
        };

        off.push($scope.$on('$destroy', destructor));

        registerWatch();
      }
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('nativeTabs', nativeTabs);

  /** @ngInject */
  function nativeTabs() {
    var directive = {
      restrict: 'EA',
      link: function(scope, element){
        var $element = angular.element(element);
        $element.on('click', function(e) {
          e.preventDefault();
          $element.tab('show');
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('ngMixitup', ngMixitup);

  /** @ngInject */
  function ngMixitup($timeout) {
    var directive = {
      restrict: 'EA',
      link: function(scope, element, attrs){
        /* eslint-disable */
        var options;
        if (attrs.ngMixitup) {
          options = scope.$eval(attrs.ngMixitup);
        }
        $timeout(function(){
          var mixer = mixitup(element, options);
        });
        /* eslint-enable */
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileRefresh', minotaurTileRefresh);

  /** @ngInject */
  function minotaurTileRefresh($timeout, cfpLoadingBar) {
    var directive = {
      restrict: 'EA',
      template: '<i class="fa fa-refresh"></i>Refresh',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.on('click', function(){
          tile.addClass('loading');
          cfpLoadingBar.start();

          $timeout(function(){
            tile.removeClass('loading');
            cfpLoadingBar.complete();
          },3000)
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileMinimize', minotaurTileMinimize);

  /** @ngInject */
  function minotaurTileMinimize() {
    var directive = {
      restrict: 'EA',
      template: '<i class="fa fa-angle-up"></i>Minimize',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.on('click', function(){

          if (tile.hasClass('collapsed')) {
            element[0].innerHTML = '<i class="fa fa-angle-up"></i>Minimize'
          } else {
            element[0].innerHTML = '<i class="fa fa-angle-down"></i>Expand'
          }

          tile.toggleClass('collapsed');
          tile.children().not('.tile-header').slideToggle(150);

        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileLightbox', minotaurTileLightbox);

  /** @ngInject */
  function minotaurTileLightbox() {
    var directive = {
      restrict: 'EA',
      template: '<i class="fa fa-magnet"></i>Open in Lightbox',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.magnificPopup({
          items: {
            src: tile[0],
            type: 'inline'
          },
          closeBtnInside: false
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileFullscreen', minotaurTileFullscreen);

  /** @ngInject */
  function minotaurTileFullscreen($log, Fullscreen) {
    var directive = {
      restrict: 'EA',
      template: '<i class="fa fa-expand"></i>Fullscreen',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.on('click', function(){
          if (Fullscreen.isEnabled()) {
            Fullscreen.cancel();
          }
          else {
            Fullscreen.enable(tile[0]);
          }
        });
        Fullscreen.$on('FBFullscreen.change', function(evt, isFullscreenEnabled){
          if (isFullscreenEnabled) {
            tile.addClass('isInFullScreen');
          } else {
            tile.removeClass('isInFullScreen');
          }
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileClose', minotaurTileClose);

  /** @ngInject */
  function minotaurTileClose($log, alertify) {
    var directive = {
      restrict: 'E',
      template: '<button class="btn btn-transparent"><i class="fa fa-times"></i></button>',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.on('click', function(){
          alertify.confirm("Do you want remove this tile?", function () {
            tile.addClass('closed').fadeOut();
          }, function() {
            // user clicked "cancel"
          });
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurLoading', minotaurLoading);

  /** @ngInject */
  function minotaurLoading($window, $timeout, cfpLoadingBar) {
    var directive = {
      restrict: 'E',
      controller: MinotaurLoadingController,
      controllerAs: 'loading',
      bindToController: true,
      link: function (scope, element) {
        if (!element.hasClass('hide')){
          element.addClass('animate');
        }
        scope.$on('$stateChangeStart', function(event, toState) {
          if (element.hasClass('hide') && toState.specialClass === 'core'){
            element.removeClass('hide');
          }
          cfpLoadingBar.start();
        });
        scope.$on('$stateChangeSuccess', function (event) {
          event.targetScope.$watch('$viewContentLoaded', function () {
            $timeout(function () {
              cfpLoadingBar.complete();
              element.addClass('hide');
            }, 1000);
          });
        });
      }
    };

    return directive;

    /** @ngInject */
    function MinotaurLoadingController() {

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('magnificPopup', magnificPopup);

  /** @ngInject */
  function magnificPopup() {
    var directive = {
      restrict:'A',
      scope: true,
      link: function (scope, element, attrs) {
        var options;
        if (attrs.magnificPopup) {
          options = scope.$eval(attrs.magnificPopup);
        }
        element.magnificPopup(options);
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('keypressEscape', keypressEscape);

  /** @ngInject */
  function keypressEscape() {
    var ESCAPE_KEY = 27;

    var directive = {
      restrict: 'A',
      link: function postLink(scope, element, attrs) {
        element.bind('keydown', function (event) {
          if (event.keyCode === ESCAPE_KEY) {
            scope.$apply(attrs.keypressEscape);
          }
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('inputMask', inputMask);

  /** @ngInject */
  function inputMask() {
    var directive = {
      restrict:'A',
      scope: true,
      link: function (scope, element, attrs) {
        var options;
        if (attrs.inputMask) {
          options = scope.$eval(attrs.inputMask);
        } else if (attrs.maskOptions) {
          options = scope.$eval(attrs.maskOptions);
        }
        angular.element(element).inputmask(options);
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('gaugeChart', gaugeChart);

  /** @ngInject */
  function gaugeChart() {
    /* eslint-disable */
    var directive = {
      restrict: 'A',
      scope: {
        data: '=',
        options: '='
      },
      link: function($scope, $el) {
        var data = $scope.data,
            options = $scope.options,
            gauge = new Gauge($el[0]).setOptions(options);

        gauge.maxValue = data.maxValue;
        gauge.animationSpeed = data.animationSpeed;
        gauge.set(data.val);
      }
    };

    return directive;
    /* esling-enable */

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('countTo', countTo);

  /** @ngInject */
  function countTo($timeout) {
    /* eslint-disable */
    var directive = {
      replace: false,
      scope: true,
      link: function (scope, element, attrs) {

        var e = element[0];
        var num, refreshInterval, duration, steps, step, countTo, value, increment;

        var calculate = function () {
          refreshInterval = 30;
          step = 0;
          scope.timoutId = null;
          countTo = parseInt(attrs.countTo) || 0;
          scope.value = parseInt(attrs.value, 10) || 0;
          duration = (parseFloat(attrs.duration) * 1000) || 0;

          steps = Math.ceil(duration / refreshInterval);
          increment = ((countTo - scope.value) / steps);
          num = scope.value;
        };

        var tick = function () {
          scope.timoutId = $timeout(function () {
            num += increment;
            step++;
            if (step >= steps) {
              $timeout.cancel(scope.timoutId);
              num = countTo;
              e.textContent = countTo;
            } else {
              e.textContent = Math.round(num);
              tick();
            }
          }, refreshInterval);

        };

        var start = function () {
          if (scope.timoutId) {
            $timeout.cancel(scope.timoutId);
          }
          calculate();
          tick();
        };

        attrs.$observe('countTo', function (val) {
          if (val) {
            start();
          }
        });

        attrs.$observe('value', function (val) {
          start();
        });

        return true;
      }
    };

    return directive;
    /* esling-enable */

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('clock', clock);

  /** @ngInject */
  function clock($interval, moment) {
    var directive = {
      restrict: 'EA',
      replace: true,
      scope: {
        radius: '@',
        zone: '@?',
        lightFill: '@?',
        darkFill: '@?'
      },
      template: '<div class=\'bloc-clock\' ng-style=\'divStyle()\'>\n  <svg xmlns="http://www.w3.org/2000/svg"\n   style="padding: 10px 0"\n    width="100%"\n       height="100%"\n       viewBox="0 0 200 200">\n    <g class=\'face\' style=\'stroke: black; stroke-width: 0px;\'>\n      <g>\n        <circle style="stroke: rgba(255,255,255,.5); fill: rgba(255,255,255,0); stroke-width: 6px;"\n                cx="100"\n                cy="100"\n                r="100"/>\n        <line x1="100"\n              x2="100"\n              y1="10"\n              y2="0"\n              />\n        <line x1="150"\n              x2="145"\n              y1="13"\n              y2="22"\n              />\n        <line x1="150"\n              x2="145"\n              y1="13"\n              y2="22"\n              />\n        <line x1="187"\n              x2="178"\n              y1="50"\n              y2="55"\n              />\n        <line x1="190"\n              x2="200"\n              y1="100"\n              y2="100"\n              />\n        <line x1="187"\n              x2="178"\n              y1="150"\n              y2="145"\n              />\n        <line x1="150"\n              x2="145"\n              y1="187"\n              y2="178"\n              />\n        <line x1="100"\n              x2="100"\n              y1="190"\n              y2="200"\n              />\n        <line x1="50"\n              x2="55"\n              y1="187"\n              y2="178"\n              />\n        <line x1="13"\n              x2="22"\n              y1="150"\n              y2="145"\n              />\n        <line x1="0"\n              x2="10"\n              y1="100"\n              y2="100"\n              />\n        <line x1="13"\n              x2="22"\n              y1="50"\n              y2="55"\n              />\n        <line x1="50"\n              x2="55"\n              y1="13"\n              y2="22"\n              />\n      </g>\n      <g>\n          <line x1="100"\n                y1="100"\n                x2="100"\n                y2="45"\n                style="stroke-width: 6px"\n                class="hourhand"/>\n          <line x1="100"\n                y1="100"\n                x2="100"\n                y2="15"\n                style="stroke-width: 6px"\n                class="minutehand" />\n          <line x1="100"\n                y1="100"\n                x2="100"\n                y2="5"\n                style="stroke-width: 3px; stroke: rgba(255,255,255,.5)"\n                class="secondhand"/>\n      <circle cx="100"\n cy="100"\n r="8"\n fill="white"\n />\n   </g>\n    </g>\n  </svg>\n</div>',
      link: function(scope, el) {
        var drawHands, getRad, getX, getY;

        scope.divStyle = function() {
          return {
            width: scope.w(),
            height: scope.w(),
            margin: '0 auto'
          };
        };

        scope.w = function() {
          return scope.radius * 2;
        };

        getX = function(degrees, r, adjust, x) {
          var adj;
          x = x || r;
          adj = adjust || 1;
          return x + r * adj * Math.cos(getRad(degrees));
        };

        getY = function(degrees, r, adjust, y) {
          var adj;
          y = y || r;
          adj = adjust || 1;
          return y + r * adj * Math.sin(getRad(degrees));
        };

        getRad = function(degrees) {
          var adjust;
          adjust = Math.PI / 2;
          return (degrees * Math.PI / 180) - adjust;
        };

        drawHands = function() {
          var H_HAND_SIZE, M_HAND_SIZE, S_HAND_SIZE, drawHand, hour, r, strokeColor, t;
          S_HAND_SIZE = 0.95;
          M_HAND_SIZE = 0.85;
          H_HAND_SIZE = 0.55;
          t = scope.zone ? moment.tz(new Date(), scope.zone) : moment();
          r = 100;
          strokeColor = 'rgba(255,255,255,1)';
          el.find('line').not('.secondhand').css('stroke', strokeColor);
          drawHand = function(hand, value, size, degrees) {
            var deg, x2, y2;
            deg = degrees * value;
            x2 = getX(deg, r, size, r);
            y2 = getY(deg, r, size, r);
            hand.attr('x1', r);
            hand.attr('y1', r);
            hand.attr('x2', x2);
            hand.attr('y2', y2);
          };
          hour = t.hour() + t.minute() / 60;
          drawHand(angular.element(el).find('.secondhand'), t.second(), S_HAND_SIZE, 6);
          drawHand(angular.element(el).find('.minutehand'), t.minute(), M_HAND_SIZE, 6);
          drawHand(angular.element(el).find('.hourhand'), hour, H_HAND_SIZE, 30);
        };
        drawHands();
        $interval(drawHands, 1000);
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('filestyle', filestyle);

  /** @ngInject */
  function filestyle() {
    var directive = {
      restrict:'AC',
      scope: true,
      link: function (scope, element, attrs) {
        var options = {
          'input': attrs.input === 'false' ? false : true,
          'icon': attrs.icon === 'false' ? false : true,
          'buttonBefore': attrs.buttonBefore === 'true' ? true : false,
          'disabled': attrs.disabled === 'true' ? true : false,
          'size': attrs.size,
          'buttonText': attrs.buttonText,
          'buttonName': attrs.buttonName,
          'iconName': attrs.iconName,
          'badge': attrs.badge === 'false' ? false : true,
          'placeholder': attrs.placeholder
        };
        angular.element(element).filestyle(options);
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('back', back);

  /** @ngInject */
  function back($window) {
    var directive = {
      restrict: 'A',
        link: function (scope, elem) {
            elem.bind('click', function () {
                $window.history.back();
            });
        }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('anchorScroll', anchorScroll);

  /** @ngInject */
  function anchorScroll($location, $anchorScroll) {
    var directive = {
      restrict: 'AC',
      link: function(scope, el, attr) {
        el.on('click', function() {
          $location.hash(attr.anchorScroll);
          $anchorScroll();
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('activeToggle', activeToggle);

  /** @ngInject */
  function activeToggle() {
    var directive = {
      restrict: 'A',
      link: function postLink(scope, element, attr) {

        element.on('click', function(){

          var target = angular.element(attr.target) || Array(element);

          if (element.hasClass('active')) {
            element.removeClass('active');
            target.removeClass('show');
          } else {
            element.addClass('active');
            target.addClass('show');
          }

        });

      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('activateButton', activateButton);

  /** @ngInject */
  function activateButton($timeout) {
    var directive = {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var activatedClass = 'btn-activated';
        var status = attrs.activateButton;
        var activate = function() {
          element.addClass(activatedClass);
          $timeout(function() {
            element.removeClass(activatedClass);
          }, 1000 );
        };

        element.on('click', function() {
          if (!element.hasClass(activatedClass) && status === 'success') {
            element.addClass('btn-activated-success');
            $timeout(function() {
              element.removeClass('btn-activated-success');
            }, 1000 );
          } else if (!element.hasClass(activatedClass) && status === 'error') {
            element.addClass('btn-activated-error');
            $timeout(function() {
              element.removeClass('btn-activated-error');
            }, 1000 );
          } else if (!element.hasClass(activatedClass)) {
            activate();
          }
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, $stateParams) {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;

    var unregisterSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
      event.targetScope.$watch('$viewContentLoaded', function () {
        angular.element('html, body, #content').animate({ scrollTop: 0 }, 200);
      });
      $rootScope.$state.current = toState;
      $rootScope.specialClass = toState.specialClass;
    });
    $rootScope.$on('$destroy', unregisterSuccess);

    var unregisterError = $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
      // We can catch the error thrown when the $requireSignIn promise is rejected
      // and redirect the user back to the home page
      if (error === "AUTH_REQUIRED") {
        $state.go("core.login");
      }
    });
    $rootScope.$on('$destroy', unregisterError);
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
    //dashboard
      .state('dashboard', {
        url: '/app/dashboard',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })

      //categories
      .state('categories', {
        url: '/categories',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('categories.list', {
        url: '/list',
        templateUrl: 'app/pages/categories/list.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('categories.new', {
        url: '/new',
        templateUrl: 'app/pages/categories/new.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('categories.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/categories/edit.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('categories.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/categories/show.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })

      //Verhalensprokkelaar categories
      .state('bappz_categories', {
        url: '/bappz_categories',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('bappz_categories.list', {
        url: '/list',
        templateUrl: 'app/pages/bappz_categories/list.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('bappz_categories.new', {
        url: '/new',
        templateUrl: 'app/pages/bappz_categories/new.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('bappz_categories.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/bappz_categories/edit.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('bappz_categories.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/bappz_categories/show.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })



      //
      .state('h2g', {
        abstract: true,
        url: '/history2go',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('h2g.list', {
        url: '/list',
        templateUrl: 'app/pages/h2g/list.html',
        controller: 'H2gController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {

            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('h2g.new', {
        url: '/new',
        templateUrl: 'app/pages/h2g/new.html',
        controller: 'H2gController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('h2g.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/h2g/edit.html',
        controller: 'H2gController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('h2g.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/h2g/show.html',
        controller: 'H2gController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {

            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })

      //
      .state('bappzs', {
        abstract: true,
        url: '/bappzs',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('bappzs.list', {
        url: '/list',
        templateUrl: 'app/pages/bappzs/list.html',
        controller: 'BappzsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {

            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('bappzs.moderate', {
        url: '/moderate',
        templateUrl: 'app/pages/bappzs/moderate.html',
        controller: 'BappzsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {

            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('bappzs.new', {
        url: '/new',
        templateUrl: 'app/pages/bappzs/new.html',
        controller: 'BappzsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('bappzs.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/bappzs/edit.html',
        controller: 'BappzsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('bappzs.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/bappzs/show.html',
        controller: 'BappzsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {

            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })


      //
      .state('locations', {
        abstract: true,
        url: '/locations',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('locations.list', {
        url: '/list',
        templateUrl: 'app/pages/locations/list.html',
        controller: 'LocationsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {

            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('locations.new', {
        url: '/new',
        templateUrl: 'app/pages/locations/new.html',
        controller: 'LocationsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('locations.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/locations/edit.html',
        controller: 'LocationsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('locations.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/locations/show.html',
        controller: 'LocationsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {

            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })

      //users
      .state('users', {
        abstract: true,
        url: '/users',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('users.list', {
        url: '/list/:service',
        templateUrl: 'app/pages/users/list.html',
        controller: 'UsersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('users.new', {
        url: '/new',
        templateUrl: 'app/pages/users/new.html',
        controller: 'UsersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('users.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/users/edit.html',
        controller: 'UsersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('users.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/users/show.html',
        controller: 'UsersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })

      //Verhalensprokkelaarusers
      // .state('bappz-users', {
      //   abstract: true,
      //   url: '/bappz-users',
      //   template: '<div ui-view></div>',
      //   resolve: {
      //     // controller will not be loaded until $requireSignIn resolves
      //     // Auth refers to our $firebaseAuth wrapper in the factory below
      //     'currentAuth': ['Auth', function(Auth) {
      //       // $requireSignIn returns a promise so the resolve waits for it to complete
      //       // If the promise is rejected, it will throw a $stateChangeError (see above)
      //       return Auth.$requireSignIn();
      //     }]
      //   }
      // })
      // .state('bappz-users.list', {
      //   url: '/list',
      //   templateUrl: 'app/pages/users/list.html',
      //   controller: 'UsersController',
      //   controllerAs: 'ctrl',
      //   resolve: {
      //     // controller will not be loaded until $requireSignIn resolves
      //     // Auth refers to our $firebaseAuth wrapper in the factory below
      //     'currentAuth': ['Auth', function(Auth) {
      //       // $requireSignIn returns a promise so the resolve waits for it to complete
      //       // If the promise is rejected, it will throw a $stateChangeError (see above)
      //       return Auth.$requireSignIn();
      //     }]
      //   }
      // })
      // .state('bappz-users.new', {
      //   url: '/new',
      //   templateUrl: 'app/pages/users/new.html',
      //   controller: 'UsersController',
      //   controllerAs: 'ctrl',
      //   resolve: {
      //     // controller will not be loaded until $requireSignIn resolves
      //     // Auth refers to our $firebaseAuth wrapper in the factory below
      //     'currentAuth': ['Auth', function(Auth) {
      //       // $requireSignIn returns a promise so the resolve waits for it to complete
      //       // If the promise is rejected, it will throw a $stateChangeError (see above)
      //       return Auth.$requireSignIn();
      //     }]
      //   }
      // })
      // .state('bappz-users.edit', {
      //   url: '/edit/:id',
      //   templateUrl: 'app/pages/users/edit.html',
      //   controller: 'UsersController',
      //   controllerAs: 'ctrl',
      //   resolve: {
      //     // controller will not be loaded until $requireSignIn resolves
      //     // Auth refers to our $firebaseAuth wrapper in the factory below
      //     'currentAuth': ['Auth', function(Auth) {
      //       // $requireSignIn returns a promise so the resolve waits for it to complete
      //       // If the promise is rejected, it will throw a $stateChangeError (see above)
      //       return Auth.$requireSignIn();
      //     }]
      //   }
      // })
      // .state('bappz-users.show', {
      //   url: '/show/:id',
      //   templateUrl: 'app/pages/users/show.html',
      //   controller: 'UsersController',
      //   controllerAs: 'ctrl',
      //   resolve: {
      //     // controller will not be loaded until $requireSignIn resolves
      //     // Auth refers to our $firebaseAuth wrapper in the factory below
      //     'currentAuth': ['Auth', function(Auth) {
      //       // $requireSignIn returns a promise so the resolve waits for it to complete
      //       // If the promise is rejected, it will throw a $stateChangeError (see above)
      //       return Auth.$requireSignIn();
      //     }]
      //   }
      // })

      .state('profile', {
        url: '/profile',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfileController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('settings', {
        url: '/settings',
        templateUrl: 'app/pages/settings/settings.html',
        controller: 'SettingsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })

      .state('core', {
        abstract: true,
        url: '/core',
        template: '<div ui-view></div>',
        specialClass: 'core',
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$waitForSignIn();
          }]
        }
      })
      .state('core.login', {
        url: '/login',
        templateUrl: 'app/pages/login/login.html',
        controller: 'LoginController',
        controllerAs: 'ctrl',
        specialClass: 'core',
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$waitForSignIn();
          }]
        }
      })
      .state('core.signup', {
        url: '/signup',
        templateUrl: 'app/pages/signup/signup.html',
        controller: 'SignupController',
        controllerAs: 'ctrl',
        specialClass: 'core',
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$waitForSignIn();
          }]
        }
      })
      .state('core.forgotpass', {
        url: '/forgotpass',
        templateUrl: 'app/pages/forgotpass/forgotpass.html',
        controller: 'ForgotpassController',
        controllerAs: 'ctrl',
        specialClass: 'core',
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$waitForSignIn();
          }]
        }
      });

    $urlRouterProvider.otherwise('/app/dashboard');
  }

})();

(function() {
  'use strict';


/*
User roles - role_value
0 - GUEST
10 - USER
20 - MODERATOR
50 - PROJECTMANAGER
95 - SUPERADMIN
99 - EINDBAAS
*/


  angular
    .module('minotaur')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($translate, Auth, $firebaseObject, firebase) {
    var vm = this;
    // console.log(vm);



    vm.auth = Auth;

    // any time auth state changes, add the user data to scope
    vm.auth.$onAuthStateChanged(function(firebaseUser) {
      if (firebaseUser) {
        vm.settings = $firebaseObject(firebase.database().ref().child('settings'));
        vm.currentUser = $firebaseObject(firebase.database().ref().child('users').child(firebaseUser.uid));
      }
      vm.firebaseUser = firebaseUser;
    });

    //console.log(vm.currentUser);

    vm.changeLanguage = function (langKey) {
      $translate.use(langKey);
      vm.currentLanguage = langKey;
    };
    vm.currentLanguage = $translate.proposedLanguage() || $translate.use();
  }
})();

/* global moment:false, firebase: false */
(function() {
  'use strict';

  /* eslint-disable */
  angular
    .module('minotaur')
    .constant('moment', moment)
    .constant('firebase', firebase);
  /*eslint-enable*/

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $translateProvider, $locationProvider, $provide) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 8000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    // angular-language
    $translateProvider.useStaticFilesLoader({
      prefix: 'assets/languages/',
      suffix: '.json'
    });
    $translateProvider.useLocalStorage();
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy(null);

    // remove ! hash prefix
    $locationProvider.hashPrefix('');

    // inject the $delegate dependency into our decorator method
    firebaseDecorator.$inject = ['$delegate'];

    // Whenever $firebaseArray's and $firebaseObjects are created,
    // they'll now be tracked by window.openFirebaseConnections
    $provide.decorator("$firebaseArray", firebaseDecorator);
    $provide.decorator("$firebaseObject", firebaseDecorator);

    function firebaseDecorator ($delegate) {
      return function (ref) {
        var list = $delegate(ref);
        /* eslint-disable */
        window.openFirebaseConnections.push(list);
        /* eslint-enable */
        return list;
      };
    }

  }

})();

angular.module("minotaur").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/bappz_categories/_form.html","<form name=form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"Category name...\" ng-model=vm.bappz_category.name required></div></div><!-- <div class=\"form-group\">\n    <label for=\"parent\" class=\"col-sm-3 control-label minotaur-label\">Parent Category</label>\n    <div class=\"col-sm-9\">\n      <select chosen=\"{width: \'100%\'}\" name=\"parent\" class=\"form-control\" id=\"parent\" ng-options=\"c.$id as c.name for c in vm.bappz_categories\" ng-model=\"vm.bappz_category.parentId\" data-placeholder=\"Select a parent category...\">\n          <option></option>\n      </select>\n    </div>\n  </div> --><div class=form-footer><button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=form.$invalid>Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=bappz_categories.list><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/bappz_categories/edit.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"EditCategoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=bappz_categories.list>Categories</a></li><li class=active>{{vm.bappz_category.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/bappz_categories/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/bappz_categories/list.html","<div class=\"page page-categories pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=bappz_categories.list>Categories</a></li><li class=active>Manage Categories</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Categorieën - Verhalensprokkelaar</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add Category\" tooltip-placement=bottom ui-sref=bappz_categories.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"bappz_category in $data\"><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"bappz_categories.show({ id: bappz_category.$id })\">{{bappz_category.name}}</a></td><!-- <td data-title=\"\'Parent Category\'\" sortable=\"\'parentName\'\">\n                  {{bappz_category.parentName}}\n                </td> --><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"bappz_categories.edit({ id: bappz_category.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(bappz_category)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/bappz_categories/new.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"NewCategoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=bappz_categories.list>Categories</a></li><li class=active>New Category</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/bappz_categories/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/bappz_categories/show.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"ShowCategoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Categories</a></li><li class=active>{{vm.bappz_category.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><ul class=\"list-unstyled m-20\"><li><strong>Name:</strong> {{vm.bappz_category.name}}</li><li ng-if=vm.category.parentId><strong>Parent Category:</strong> {{vm.bappz_categoriesObject[vm.bappz_category.parentId].name}}</li></ul><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=bappz_categories.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/components/templates/messages_tmpl.html","<p ng-message=required style=\"margin: 0\">This field is required</p><p ng-message=minlength style=\"margin: 0\">This field is too short</p><p ng-message=maxlength style=\"margin: 0\">This field is too long</p><p ng-message=email style=\"margin: 0\">This needs to be a valid email</p><p ng-message=number style=\"margin: 0\">This needs to be a valid number</p><p ng-message=match style=\"margin: 0\">Values do not match!</p><p ng-message=pattern style=\"margin: 0\">Input in bad format!</p><p ng-message=min style=\"margin: 0\">This value is too low</p><p ng-message=max style=\"margin: 0\">This value is too high</p>");
$templateCache.put("app/pages/bappzs/_form.html","<form name=outerForm role=form novalidate class=form-validation><uib-tabset active=forms.activeStep justified=true class=\"tab-wizard padded\"><uib-tab index=0><uib-tab-heading><i class=\"fa fa-check\" ng-if=step1.$valid></i> Algemeen <span class=\"pull-right wizard-step\">1</span></uib-tab-heading><ng-form name=step1><div class=row><div class=\"form-group col-md-12\"><label for=username class=\"control-label minotaur-label\">Titel van het verhaal <span class=text-red>*</span>:</label><input type=text name=name id=name class=form-control placeholder=Titel ng-model=vm.bappz.title required><div ng-messages=step1.name.$error ng-if=step1.name.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div><div class=\"form-group col-md-6\"><label for=category class=\"control-label minotaur-label\">Categorie <span class=text-red>*</span>:</label><div class=form-group><select chosen=\"{width: \'100%\'}\" name=category class=form-control id=category ng-options=\"c.$id as c.name for c in ctrl.childCategories | orderBy:\'name\'\" ng-model=vm.bappz.category data-placeholder=\"Select a category...\" required><option></option></select><div ng-messages=step1.username.$error ng-if=step1.username.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div></div><div class=\"form-group col-md-6\"><label for=category class=\"control-label minotaur-label\">Locatie <span class=text-red>*</span>:</label><div class=form-group><select chosen=\"{width: \'100%\'}\" name=category class=form-control id=locations ng-options=\"l.$id as l.name group by l.parentName for l in ctrl.childlocations | orderBy:\'name\'\" ng-model=vm.bappz.location data-placeholder=\"Select a city...\" required><option></option></select><div ng-messages=step1.username.$error ng-if=step1.username.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div><!--<input type=\"text\" name=\"city\" class=\"form-control\" id=\"city\" placeholder=\"which city...\" places-auto-complete ng-model=\"vm.story.address.city\" required>--></div><!-- <input type=\"text\" name=\"username\" id=\"username\" class=\"form-control\" ng-model=\"forms.user.username\" ng-minlength=\"3\" ng-maxlength=\"8\" required> --></div></div><h4>Wanneer speelt het verhaal zich af?</h4><div class=row><div class=\"form-group col-md-2\"><label for=startDate class=\"control-label minotaur-label\">Start jaar<span class=text-red>*</span>:</label><input type=text name=startDate id=startDate class=form-control ng-model=vm.bappz.date.start_year placeholder=YYYY ng-pattern=/[0-9]{1}$/ required></div><div class=\"form-group col-md-2\"><label for=startDate class=\"control-label minotaur-label\">Start maand:</label><input type=text name=startDate id=startDate class=form-control ng-model=vm.bappz.date.start_month placeholder=MM ng-pattern=/(0[1-9]|1[012])$/ ></div><div class=\"form-group col-md-2\"><label for=startDate class=\"control-label minotaur-label\">Start dag:</label><input type=text name=startDate id=startDate class=form-control ng-model=vm.bappz.date.start_day placeholder=DD ng-pattern=/(0[1-9]|1[0-9]|2[0-9]|3[01])$/ ></div></div><h4>Is er een einddatum?</h4><p><small><i>Wanneer een verhaal niet op een specifieke datum afspeelt graag hier de einddatum (indien van toepassing) aangeven.</i></small></p><div class=row><div class=\"form-group col-md-2\"><label for=endDate class=\"control-label minotaur-label\">Eind jaar:</label><input type=text name=endDate id=endDate class=form-control ng-model=vm.bappz.date.end_year placeholder=YYYY ng-pattern=/[0-9]{1}$/ ></div><div class=\"form-group col-md-2\"><label for=endDate class=\"control-label minotaur-label\">Eind maand:</label><input type=text name=endDate id=endDate class=form-control ng-model=vm.bappz.date.end_month placeholder=MM ng-pattern=/(0[1-9]|1[012])$/ ></div><div class=\"form-group col-md-2\"><label for=endDate class=\"control-label minotaur-label\">Eind dag:</label><input type=text name=endDate id=endDate class=form-control ng-model=vm.bappz.date.end_day placeholder=DD ng-pattern=/(0[1-9]|1[0-9]|2[0-9]|3[01])$/ ></div></div><button class=\"btn btn-warning minotaur-btn\" back>Terug naar overzicht</button> <button ng-disabled=step1.$invalid class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 1; vm.saveTemp()\">Next</button></ng-form></uib-tab><uib-tab index=1 disable=step1.$invalid><uib-tab-heading><i class=\"fa fa-check\" ng-if=step2.$valid></i> Foto\'s <span class=\"pull-right wizard-step\">2</span></uib-tab-heading><ng-form name=step2><h4>Foto\'s</h4><p><small><i>Upload en selecteer hier de foto\'s die je gebruikt in het verhaal.</i></small></p><div class=\"row mb20\"><div class=form-group><div class=\"col-sm-12 mb20\"><div ngf-drop ngf-select ngf-drag-over-class=dragover ngf-resize=\"{width: 1400, height: 1000, quality: 0.9, centerCrop: false, type: \'image/jpeg\'}\" ngf-multiple=true accept=image/* ng-model=vm.bappz.imagess class=\"fileupload drop-box\" name=images>Klik hier of sleep foto\'s hier naartoe...</div><div class=upload-progress ng-if=vm.processing><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> <span>Uploading {{vm.totalImages}} images</span></div></div><div class=\"col-sm-12 fileupload-list\"><ul class=\"list-unstyled list-inline\"><li ng-repeat=\"image in vm.bappz.images\" class=\"col-sm-6 wizard-image\"><button class=btn-image-delete ng-click=vm.imageDelete(image) ng-show=image><i class=\"fa fa-trash\" aria-hidden=true></i></button><div class=row><div class=col-sm-4><img ngf-thumbnail=image alt=\"\" style=\"width: 100%; height: 120px\"> <img ngf-thumbnail=image.src alt=\"\" style=\"width: 100%; height: 120px\"></div><div class=col-sm-8><input type=text name=caption ng-model=image.caption class=\"form-control thumb-caption mb10 mt5\" placeholder=Onderschrift> <input type=text name=copyright ng-model=image.copyright class=\"form-control thumb-caption mb10\" placeholder=Copyright><div class=\"onoffswitch greensea inline-block\"><input type=radio name=onoffswitch-radio ng-click=vm.updateImageSelect(image) ng-value=image.main_image class=onoffswitch-checkbox id=\"{{ \'switch\' + $index }}\"><label class=onoffswitch-label for=\"{{ \'switch\' + $index }}\"><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div><label class=switch-label>Hoofd foto</label></div></div><uib-progressbar class=\"progress-xxs mt-10\" value=image.progress type=cyan ng-show=\"image.progress >= 0\"></uib-progressbar></li></ul></div></div></div><button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 0\">Vorige</button> <button ng-disabled=step2.$invalid class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 2; vm.saveTemp2()\">Next</button></ng-form></uib-tab><uib-tab index=2 disable=step1.$invalid><uib-tab-heading><i class=\"fa fa-check\" ng-if=step3.$valid></i> Verhaal <span class=\"pull-right wizard-step\">3</span></uib-tab-heading><ng-form name=step3><div class=row><div class=\"form-group col-md-12\"><label for=intro class=\"control-label minotaur-label\">Inleiding <span class=text-red>*</span>:</label><textarea type=text name=intro id=intro class=form-control ng-model=vm.bappz.introduction placeholder=\"Korte inleiding\" rows=4 required></textarea></div><div class=\"form-group col-md-12\"><label for=story class=\"control-label minotaur-label\">Het verhaal <span class=text-red>*</span>:</label><text-angular ng-model=vm.bappz.full_story ta-toolbar=\"[[\'h1\',\'h2\',\'h3\'],[\'bold\',\'italics\',\'quote\', \'clear\']]\" required></text-angular><!-- <textarea type=\"text\" name=\"story\" id=\"story\" class=\"form-control\" ng-model=\"vm.bappz.full_story\" placeholder=\"Het verhaal\" rows=\"10\" required></textarea> --></div></div><button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 1\">Vorige</button> <button ng-disabled=step3.$invalid class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 3; vm.saveTemp3()\">Next</button></ng-form></uib-tab><uib-tab index=3 disable=step3.$invalid><uib-tab-heading><i class=\"fa fa-check\" ng-if=step4.$valid></i> Extra info <span class=\"pull-right wizard-step\">4</span></uib-tab-heading><ng-form name=step4><h4>Algemene voorwaarden</h4><ng-form name=step4><p class=well>Hier komt een korte disclaimer wat er met de verhalen gaat gebeuren.</p><label class=\"checkbox minotaur-checkbox\">Ik ga akkoord met de <a href class=text-info>Algemene Voorwaarden</a> <input type=checkbox name=agree id=agree ng-model=vm.bappz.nationaal_erfgoed.agreed ng-true-value=true ng-false-value=false required><div class=input-indicator></div></label><div ng-messages=step5.agree.$error ng-if=step5.agree.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div><label class=\"checkbox minotaur-checkbox\">Deel met <a href class=text-info>Stichting Nationaal Erfgoed</a> <input type=checkbox name=nationaalerfgoed id=nationaalerfgoed ng-model=vm.bappz.nationaal_erfgoed.shared ng-true-value=true ng-false-value=false checked><div class=input-indicator></div></label><button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 2\">Vorige</button> <button ng-disabled=step4.$invalid class=\"btn btn-success minotaur-btn pull-right\" ng-click=vm.submit()>Indienen</button></ng-form></ng-form></uib-tab></uib-tabset></form>");
$templateCache.put("app/pages/bappzs/edit.html","<div class=\"page page-bappzs pull-to-header\" ng-controller=\"EditBappzController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=bappzs.list>Verhalensprokkelaar</a></li><li class=active>{{vm.bappz.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-8><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body style=\"padding: 0!important\" ng-include=\"\'app/pages/bappzs/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --><div class=col-md-4><div class=tile-mobile><!-- tile body --><section class=mobile-screen><img class=iphone src=/assets/images/iphone.png><div class=mobile-header><div ng-repeat=\"image in vm.bappz.images\" ng-if=\"image.main_image == true\"><img src={{image.src}}></div><div class=mobile-title>{{vm.bappz.title}}</div></div><div class=mobile-body><div class=mobile-infobar></div><div class=mobile-content ng-bind-html=vm.bappz.full_story></div></div></section><!-- /tile body --></div></div></div><!-- /row --></div>");
$templateCache.put("app/pages/bappzs/list.html","<div class=\"page page-bappzs pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=bappzs.list>Verhalensprokkelaar</a></li><li class=active>Manage</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Verhalen</h1><div class=controls><button class=\"btn btn-default mb10\" uib-tooltip=\"Item toevoegen\" tooltip-placement=bottom ui-sref=bappzs.new><i class=\"fa fa-plus\"></i> Voeg item toe</button></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"bappz in $data\"><td data-title=\"\'ID\'\" sortable>{{bappz.id}}</td><!-- <td data-title=\"\'Name\'\" sortable=\"\'name\'\">\n                  <a href=\"javascript:;\" ui-sref=\"bappzs.show({ id: bappz.$id })\">{{bappz.title}}</a>\n                </td> --><td data-title=\"\'Titel\'\" sortable>{{bappz.title}}</td><td data-title=\"\'Category\'\" sortable>{{bappz.bappz_categoryName}}</td><!-- <td data-title=\"\'Date Created\'\" sortable=\"\'created_at\'\">\n                  {{bappz.created_at | date: \'mediumDate\'}}\n                </td> --><td data-title=\"\'Locatie\'\" sortable>{{bappz.locationName}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : bappz.status == \'published\',\'bg-warning\' : bappz.status == \'waiting\',\'bg-lightred\' : bappz.status == \'rejected\', \'bg-amethyst\' : bappz.status == \'concept\', \'bg-drank\' : bappz.status == \'moderated\'}\">{{ bappz.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"bappzs.edit({ id: bappz.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(bappz)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/bappzs/moderate.html","<div class=\"page page-bappzs pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li class=active>Redactie</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Redactie</h1><!-- <div class=\"controls\">\n            <button class=\"btn btn-default mb10\" uib-tooltip=\"Item toevoegen\" tooltip-placement=\"bottom\" ui-sref=\"bappzs.new\"><i class=\"fa fa-plus\"></i> Voeg item toe</button>\n          </div> --></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParamsModerate class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"bappz in $data\"><!-- <td data-title=\"\'ID\'\" sortable=\"\'id\'\">\n                  {{bappz.id}}\n                </td> --><!-- <td data-title=\"\'Name\'\" sortable=\"\'name\'\">\n                  <a href=\"javascript:;\" ui-sref=\"bappzs.show({ id: bappz.$id })\">{{bappz.title}}</a>\n                </td> --><td data-title=\"\'Titel\'\" sortable>{{bappz.title}}</td><td data-title=\"\'Date Created\'\" sortable>{{bappz.created_at | date: \'yyyy-MM-dd\'}}</td><!-- <td data-title=\"\'Category\'\" sortable=\"\'bappz_categoryName\'\">\n                  {{bappz.bappz_categoryName}}\n                </td>--><td data-title=\"\'Locatie\'\" sortable>{{bappz.locationName}}</td><td data-title=\"\'Auteur\'\" sortable>{{bappz.usersName}}</td><!-- <td data-title=\"\'Status\'\" sortable=\"\'status\'\">\n                  <span class=\"label\" ng-class=\"{\'bg-success\' : bappz.status == \'published\',\'bg-warning\' : bappz.status == \'waiting\',\'bg-lightred\' : bappz.status == \'rejected\', \'bg-amethyst\' : bappz.status == \'concept\', \'bg-drank\' : bappz.status == \'moderated\'}\">\n                    {{ bappz.status }}\n                  </span>\n                </td> --><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"bappzs.show({ id: bappz.$id })\">Bekijk</button> <button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"bappzs.edit({ id: bappz.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.reject(bappz)>Reject</button> <button class=\"btn btn-success btn-xs minotaur-btn\" ng-click=ctrl.publish(bappz)>Publiceer</button><!-- <button class=\"btn btn-success btn-xs minotaur-btn\" ng-click=\"ctrl.delete(bappz)\">Delete</button> --></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/bappzs/new.html","<div class=\"page page-bappzs pull-to-header\" ng-controller=\"NewBappzController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=bappzs.list>Verhalensprokkelaar</a></li><li class=active ng-bind-html=vm.bappz.title>New item</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-8><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=\"tile-body p-0\" ng-include=\"\'app/pages/bappzs/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --><div class=col-md-4><div class=tile-mobile><!-- tile body --><section class=mobile-screen><img class=iphone src=/assets/images/iphone.png><div class=mobile-header><div class=mobile-image><div ng-repeat=\"image in vm.bappz.images\" ng-if=\"image.main_image == true\"><img src={{image.src}}></div></div><div class=mobile-title>{{vm.bappz.title}}</div></div><div class=mobile-body><div class=mobile-infobar></div><div class=mobile-content ng-bind-html=vm.bappz.full_story></div></div></section><!-- /tile body --></div></div></div><!-- /row --></div>");
$templateCache.put("app/pages/bappzs/show.html","<div class=\"page page-bappzs pull-to-header\" ng-controller=\"ShowBappzController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a back>Redactie</a></li><li class=active>{{vm.bappz.title}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-4 magnific-popup=\"{delegate: \'a.img-link\', type: \'image\'}\"><div ng-repeat=\"mainImage in vm.bappz.images\" ng-if=\"mainImage.main_image == true\"><a href={{mainImage.src}} class=img-link><img ng-src={{mainImage.src}} class=\"img-responsive mb-20\"></a></div><a href=javascript:; ng-show=\"vm.bappz.images.length === 0 || !vm.bappz.images\"><img src=assets/images/no-bappz-image.png alt=vm.bappz.name class=\"img-responsive mb-20\"> </a><!-- thumbnails --><slick dots=true infinite=false speed=300 slides-to-show=4 touch-move=false slides-to-scroll=1 arrows=false init-onload=true data=vm.bappz.images><div ng-repeat=\"image in vm.bappz.images\" ng-if=\"image.main_image == false\" href={{image.src}} class=mr-5><a href={{image.src}} class=img-link><img ng-src={{image.src}} class=img-responsive></a></div></slick><!-- /thumbnails --></div><!-- /col --><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.bappz.title}} <span class=label ng-class=\"{\'bg-success\' : vm.bappz.status == \'published\',\'bg-warning\' : vm.bappz.status == \'not published\',\'bg-lightred\' : vm.bappz.status == \'banned\'}\">{{ vm.bappz.status }}</span></h2><p class=\"short-desc text-sm text-default lt mb-20\">{{vm.bappz.introduction}}</p><p class=\"desc text-default lt mb-20\" ng-bind-html=vm.bappz.full_story></p><h6><strong>Categorie:</strong> {{ctrl.bappz_categoriesObject[vm.bappz.category].name}}</h6><h4 class=\"mt-40 mb-0 text-success\">{{ctrl.locationsObject[vm.bappz.location].name}}</h4><!-- <p class=\"discount text-sm text-default lt\">{{vm.bappz.discount}}%</p> --></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" back><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/categories/_form.html","<form name=form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"Category name...\" ng-model=vm.category.name required></div></div><div class=form-group><label for=parent class=\"col-sm-3 control-label minotaur-label\">Parent Category</label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=parent class=form-control id=parent ng-options=\"c.$id as c.name for c in vm.categories\" ng-model=vm.category.parentId data-placeholder=\"Select a parent category...\"><option></option></select></div></div><div class=form-footer><button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=form.$invalid>Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=categories.list><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/categories/edit.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"EditCategoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Categories</a></li><li class=active>{{vm.category.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/categories/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/categories/list.html","<div class=\"page page-categories pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Categories</a></li><li class=active>Manage Categories</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Categories</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add Category\" tooltip-placement=bottom ui-sref=categories.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"category in $data\"><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"categories.show({ id: category.$id })\">{{category.name}}</a></td><td data-title=\"\'Parent Category\'\" sortable>{{category.parentName}}</td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"categories.edit({ id: category.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(category)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/categories/new.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"NewCategoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Categories</a></li><li class=active>New Category</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/categories/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/categories/show.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"ShowCategoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Categories</a></li><li class=active>{{vm.category.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><ul class=\"list-unstyled m-20\"><li><strong>Name:</strong> {{vm.category.name}}</li><li ng-if=vm.category.parentId><strong>Parent Category:</strong> {{vm.categoriesObject[vm.category.parentId].name}}</li></ul><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=categories.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/dashboard/dashboard.html","<div class=\"page page-dashboard pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li class=active>Dashboard</li></ol><!-- row --><!-- tile body --><section class=tile-body style=\"padding: 0!important\" ng-include=\"\'app/pages/dashboard/widgets.html\'\"></section><!-- /tile body --></div>");
$templateCache.put("app/pages/dashboard/widgets.html","<div class=nationaal-erfgoed-widgets ng-if=\"main.currentUser.neService.nationaal_erfgoed == true\" ng-cloak><!-- row --><div class=row><!-- col --><div class=col-md-6><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Maps</h1></section><!-- /tile header --><!-- tile body --><section class=tile-body><!-- MAP --><!-- <leaflet center=\"vm.center\" height=\"480px\" width=\"640px\"></leaflet> --><!-- <ng-map center=\"51.494576, 4.287162\" zoom=\"14\" geo-fallback-center=\"[51.494576, 4.287162]\" trigger-resize=\"true\"></ng-map> --><!-- /MAP --></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --><!-- col --><div class=col-md-6><div class=\"tile tile-simple bg-greensea carousel-widget\"><!-- tile header --><section class=tile-header><h1 class=heading>Moderatie wachtrij <button type=button class=\"btn btn-border btn-rounded-20 btn-white btn-xs mr-5\" style=\"width:22px; font-size: 10px; line-height: 18px\" ui-sref=bappzs.moderate><i class=\"fa fa-arrow-right\"></i></button></h1></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=\"media social-feed\" ng-repeat=\"item in ctrl.bappzModerate | limitTo: 4\"><span class=pull-left><button type=button class=\"btn btn-border btn-rounded-20 btn-white btn-xs mr-5\" style=\"width:22px; font-size: 10px; line-height: 18px\" ui-sref=\"bappzs.show({ id: item.$id })\"><i class=\"fa fa-eye\"></i></button></span><div class=media-body><p class=media-heading><strong ng-bind-html=item.title></strong></p><p class=text-transparent-white ng-bind-html=item.introduction></p></div></div></section><!-- /tile body --></div></div><!-- /col --></div><!-- /row --><!-- cards nationaal erfgoed row --><div class=row ng-show=\"main.currentUser.neService.nationaal_erfgoed == true\" ng-cloak><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\" ng-show=\"main.currentUser.role_value >= 90\"><div class=card><div class=\"front bg-lightred\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-book fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to={{ctrl.stories.length}} value=0 duration=0.3></p><span><ng-pluralize count=ctrl.stories.length when=\"{\'0\': \'stories\',\n                       \'one\': \'story\',\n                       \'other\': \'stories\'}\"></ng-pluralize></span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-lightred\"><!-- row --><div class=row ng-show=\"main.currentUser.role_value >= 49\"><!-- col --><div class=col-xs-6><a href=javascript:; ui-sref=stories.list><i class=\"fa fa-ellipsis-h fa-2x\"></i> Manage Locaties</a></div><div class=col-xs-6><a href=javascript:; ui-sref=stories.new><i class=\"fa fa-plus fa-2x\"></i> Voeg Locatie toe</a></div><!-- /col --></div><!-- /row --></div></div></div><!-- /col --><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\" ng-show=\"main.currentUser.role_value >= 11\"><div class=card><div class=\"front bg-greensea\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-university fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to={{ctrl.h2days.length}} value=0 duration=0.3></p><span><ng-pluralize count=ctrl.h2days.length when=\"{\'0\': \'history2day\',\n                       \'one\': \'history2day\',\n                       \'other\': \'history2days\'}\"></ng-pluralize></span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-greensea\" ng-show=\"main.currentUser.role_value >= 11\"><!-- row --><div class=row><!-- col --><!-- <div class=\"col-xs-12\">\n              <a href=\"javascript:;\" ui-sref=\"h2days.list\"><i class=\"fa fa-ellipsis-h fa-2x\"></i> Voeg item toe</a>\n            </div> --><!-- /col --></div><!-- /row --></div></div></div><!-- /col --><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\" ng-show=\"main.currentUser.role_value >= 11\"><div class=card><div class=\"front bg-slategray\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-users fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to=\"{{ctrl.activeUsers.length + 30}}\" value=0 duration=0.3></p><span><ng-pluralize count=ctrl.activeUsers.length when=\"{\'0\': \'Users\',\n                       \'one\': \'User\',\n                       \'other\': \'Users\'}\"></ng-pluralize></span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-slategray\"><!-- row --><div class=row><!-- col --><div class=col-xs-6><a href=javascript:; ui-sref=users.list><i class=\"fa fa-ellipsis-h fa-2x\"></i> Manage Users</a></div><div class=col-xs-6><a href=javascript:; ui-sref=users.new><i class=\"fa fa-plus fa-2x\"></i> Add User</a></div><!-- /col --></div><!-- /row --></div></div></div><!-- /col --><!-- col --><!--  --><!-- /col --></div><!-- /row --></div><div class=verhalensprokkelaar-widgets ng-if=\"main.currentUser.neService.verhalensprokkelaar == true\" ng-cloak><!-- row --><div class=row><!-- col --><div class=col-md-6><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Maps</h1></section><!-- /tile header --><!-- tile body --><section class=tile-body><ng-map default-style=true center=[51.494576,4.287162] zoom=15><info-window id=foo><div ng-non-bindable=\"\">Lat/Lng: {{anchor.getPosition().lat()}}/ {{anchor.getPosition().lng()}}<br><ul><li ng-repeat=\"item in vm.store.items\">{{item}}</li></ul></div></info-window><marker ng-repeat=\"(id, store) in vm.stores\" id={{id}} position={{store.position}} on-click=\"vm.showStore(event, id)\"></marker><info-window id=bar><div ng-non-bindable=\"\">Lat: {{anchor.getPosition().lat()}}<br>Lng: {{anchor.getPosition().lng()}}<br></div></info-window><marker position=\"41, -79\" on-click=\"vm.map.showInfoWindow(\'bar\')\"></marker></ng-map></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --><!-- col --><div class=col-md-6><div class=\"tile tile-simple bg-greensea carousel-widget\"><!-- tile header --><section class=tile-header><h1 class=heading>Moderatie wachtrij <button ng-if=\"main.currentUser.role_value >= 19\" type=button class=\"btn btn-border btn-rounded-20 btn-white btn-xs mr-5\" style=\"width:22px; font-size: 10px; line-height: 18px\" ui-sref=bappzs.moderate><i class=\"fa fa-arrow-right\"></i></button></h1></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=\"media social-feed\" ng-repeat=\"item in ctrl.bappzModerate | limitTo: 4\"><span class=pull-left><button ng-if=\"main.currentUser.role_value >= 19\" type=button class=\"btn btn-border btn-rounded-20 btn-white btn-xs mr-5\" style=\"width:22px; font-size: 10px; line-height: 18px\" ui-sref=\"bappzs.show({ id: item.$id })\"><i class=\"fa fa-eye\"></i></button></span><div class=media-body><p class=media-heading><strong ng-bind-html=item.title></strong></p><p class=text-transparent-white ng-bind-html=item.introduction></p></div></div></section><!-- /tile body --></div></div><!-- /col --></div><!-- /row --><div class=row ng-cloak><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\" ng-show=\"main.currentUser.role_value >= 9 && main.currentUser.neService.verhalensprokkelaar == true\"><div class=card><div class=\"front bg-lightred\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-location-arrow fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to={{ctrl.locations.length}} value=0 duration=0.3></p><span><ng-pluralize count=ctrl.locations.length when=\"{\'0\': \'Locations\',\n                       \'one\': \'Location\',\n                       \'other\': \'Locations\'}\"></ng-pluralize></span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-lightred\"><!-- row --><div class=row ng-show=\"main.currentUser.role_value >= 49 && main.currentUser.neService.verhalensprokkelaar == true\"><!-- col --><div class=col-xs-6><a href=javascript:; ui-sref=list><i class=\"fa fa-ellipsis-h fa-2x\"></i> Manage Locaties</a></div><div class=col-xs-6><a href=javascript:; ui-sref=new><i class=\"fa fa-plus fa-2x\"></i> Voeg Locatie toe</a></div><!-- /col --></div><!-- /row --></div></div></div><!-- /col --><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\" ng-show=\"main.currentUser.role_value >= 9 && main.currentUser.neService.verhalensprokkelaar == true\"><div class=card><div class=\"front bg-greensea\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-university fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to={{ctrl.bappzs.length}} value=0 duration=0.3></p><span><ng-pluralize count=ctrl.bappzs.length when=\"{\'0\': \'Item\',\n                       \'one\': \'Item\',\n                       \'other\': \'Items\'}\"></ng-pluralize></span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-greensea\" ng-show=\"main.currentUser.role_value >= 9 && main.currentUser.neService.verhalensprokkelaar == true\"><!-- row --><div class=row><!-- col --><div class=col-xs-12><a href=javascript:; ui-sref=bappzs.list><i class=\"fa fa-ellipsis-h fa-2x\"></i> Voeg item toe</a></div><!-- /col --></div><!-- /row --></div></div></div><!-- /col --><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\" ng-show=\"main.currentUser.role_value >= 9 && main.currentUser.neService.verhalensprokkelaar == true\"><div class=card><div class=\"front bg-slategray\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-users fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to={{ctrl.activeverhalensprokkelaarUsers.length}} value=0 duration=0.3></p><span><ng-pluralize count=ctrl.activeverhalensprokkelaarUsers.length when=\"{\'0\': \'Users\',\n                       \'one\': \'User\',\n                       \'other\': \'Users\'}\"></ng-pluralize></span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-slategray\"><!-- row --><div class=row><!-- col --><div class=col-xs-6><a ng-if=\"main.currentUser.role_value >= 48\" href=javascript:; ui-sref=\"users.list({service:\'verhalensprokkelaar\'})\"><i class=\"fa fa-ellipsis-h fa-2x\"></i> Manage Users</a></div><div class=col-xs-6><a ng-if=\"main.currentUser.role_value >= 48\" href=javascript:; ui-sref=users.new><i class=\"fa fa-plus fa-2x\"></i> Add User</a></div><!-- /col --></div><!-- /row --></div></div></div><!-- /col --><!-- /row --></div></div>");
$templateCache.put("app/pages/forgotpass/forgotpass.html","<div class=\"page page-core page-forgotpass\"><div class=login-modal><div class=branding><img src=assets/images/logo-alt.png alt><h2 class=brand><strong>Nationaal</strong>Erfgoed</h2></div><form name=form ng-submit=ctrl.submit()><p class=\"help-block text-left\">Enter your e-mail address below to reset your password.</p><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-envelope></i></span> <input type=email placeholder=\"Email address\" class=form-control ng-model=ctrl.email required></div><button type=submit class=\"btn btn-lg btn-block btn-rounded-40\" ng-disabled=form.$invalid>Submit</button></form><div class=\"mt-15 text-center\">Know your password? <a ui-sref=core.login>Please log in</a></div></div></div>");
$templateCache.put("app/pages/locations/_form.html","<form name=outerForm role=form novalidate class=form-validation><uib-tabset active=forms.activeStep justified=true class=\"tab-wizard padded\"><uib-tab index=0><uib-tab-heading><i class=\"fa fa-check\" ng-if=step1.$valid></i> Algemeen <span class=\"pull-right wizard-step\">1</span></uib-tab-heading><ng-form name=step1><div class=row><div class=\"form-group col-md-6\"><label for=locationname class=\"control-label minotaur-label\">Naam van de Locatie<span class=text-red>*</span>:</label><input type=text name=name id=name class=form-control placeholder=Name ng-model=vm.location.name required><div ng-messages=step1.name.$error ng-if=step1.name.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div><div class=\"form-group col-md-6\"><label for=locationname class=\"control-label minotaur-label\">RCE object nummer:</label><input type=text name=name id=name class=form-control placeholder=Name ng-model=vm.location.rce_number><div ng-messages=step1.name.$error ng-if=step1.name.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div></div><h4>Locatie</h4><div class=row><div class=\"form-group col-md-6\"><label for=city class=\"control-label minotaur-label\">Stad <span class=text-red>*</span>:</label><div class=form-group><select chosen=\"{width: \'100%\'}\" name=city class=form-control id=monuments ng-options=\"l.$id as l.name group by l.parentName for l in ctrl.childCities | orderBy:\'name\'\" ng-model=vm.location.city data-placeholder=\"Select a city...\" required><option></option></select><div ng-messages=step1.username.$error ng-if=step1.username.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div></div><div class=\"form-group col-md-6\"><label for=locationname class=\"control-label minotaur-label\">Straatnaam <span class=text-red>*</span>:</label><input type=text name=name id=name class=form-control placeholder=Straatnaam ng-model=vm.location.address.street required><div ng-messages=step1.name.$error ng-if=step1.name.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div></div><div class=row><div class=\"form-group col-md-2\"><label for=locationname class=\"control-label minotaur-label\">Huisnummer:</label><input type=text name=name id=name class=form-control ng-model=vm.location.address.number><div ng-messages=step1.name.$error ng-if=step1.name.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div><div class=\"form-group col-md-2\"><label for=locationname class=\"control-label minotaur-label\">Postcode:</label><input type=text name=name id=name class=form-control ng-model=vm.location.address.zipcode><div ng-messages=step1.name.$error ng-if=step1.name.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div></div><div class=row><div class=\"form-group col-md-12\"><div map-lazy-load=https://maps.google.com/maps/api/js><ng-map lf-center=current-location zoom=14><marker draggable=true position={{pos.lat}},{{pos.lng}} on-dragend=vm.getCurrentLocation()></marker></ng-map></div></div></div><h4>Bouwjaar</h4><div class=row><div class=\"form-group col-md-2\"><label for=startDate class=\"control-label minotaur-label\">Jaar:</label><input type=text name=startDate id=startDate class=form-control ng-model=vm.location.date.year placeholder=YYYY ng-pattern=/[0-9]{1}$/ ></div><div class=\"form-group col-md-2\"><label for=startDate class=\"control-label minotaur-label\">Maand:</label><input type=text name=startDate id=startDate class=form-control ng-model=vm.location.date.month placeholder=MM ng-pattern=/(0[1-9]|1[012])$/ ></div><div class=\"form-group col-md-2\"><label for=startDate class=\"control-label minotaur-label\">Dag:</label><input type=text name=startDate id=startDate class=form-control ng-model=vm.location.date.day placeholder=DD ng-pattern=/(0[1-9]|1[0-9]|2[0-9]|3[01])$/ ></div></div><button class=\"btn btn-warning minotaur-btn\" ui-sref=locations.list>Terug naar overzicht</button> <button ng-disabled=step1.$invalid class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 1; vm.saveTemp()\">Next</button></ng-form></uib-tab><uib-tab index=1 disable=step1.$invalid><uib-tab-heading><i class=\"fa fa-check\" ng-if=step2.$valid></i> Foto\'s <span class=\"pull-right wizard-step\">2</span></uib-tab-heading><ng-form name=step2><h4>Foto\'s</h4><p><small><i>Upload en selecteer hier de foto\'s van de locatie.</i></small></p><div class=\"row mb20\"><div class=form-group><div class=\"col-sm-12 mb20\"><div ngf-drop ngf-select ngf-drag-over-class=dragover ngf-multiple=true accept=image/* ng-model=vm.location.imagess class=\"fileupload drop-box\" name=images>Klik hier of sleep foto\'s hier naartoe...</div></div><div class=col-sm-12><ul class=\"list-unstyled list-inline\"><li ng-repeat=\"image in vm.location.images\" class=\"col-sm-6 wizard-image\"><button class=btn-image-delete ng-click=vm.imageDelete(image) ng-show=image><i class=\"fa fa-trash\" aria-hidden=true></i></button><div class=row><div class=col-sm-4><img ngf-thumbnail=image alt=\"\" style=\"width: 100%; height: 120px\"> <img ngf-thumbnail=image.src alt=\"\" style=\"width: 100%; height: 120px\"></div><div class=col-sm-8><input type=text name=caption ng-model=image.caption class=\"form-control thumb-caption mb10 mt5\" placeholder=Onderschrift> <input type=text name=copyright ng-model=image.copyright class=\"form-control thumb-caption mb10\" placeholder=Copyright><div class=\"onoffswitch greensea inline-block\"><input type=radio name=onoffswitch-radio ng-click=vm.updateImageSelect(image) ng-value=image.main_image class=onoffswitch-checkbox id=\"{{ \'switch\' + $index }}\"><label class=onoffswitch-label for=\"{{ \'switch\' + $index }}\"><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div><label class=switch-label>Hoofd foto</label></div></div><uib-progressbar class=\"progress-xxs mt-10\" value=image.progress type=cyan ng-show=\"image.progress >= 0\"></uib-progressbar></li></ul></div></div></div><button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 0\">Vorige</button> <button ng-disabled=step2.$invalid class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 2; vm.saveTemp2()\">Next</button></ng-form></uib-tab><uib-tab index=2 disable=step1.$invalid><uib-tab-heading><i class=\"fa fa-check\" ng-if=step3.$valid></i> Verhaal <span class=\"pull-right wizard-step\">3</span></uib-tab-heading><ng-form name=step3><div class=row><div class=\"form-group col-md-12\"><label for=intro class=\"control-label minotaur-label\">Korte omschrijving <span class=text-red>*</span>:</label><textarea type=text name=intro id=intro class=form-control ng-model=vm.location.introduction placeholder=\"Korte inleiding\" rows=4></textarea></div><div class=\"form-group col-md-12\"><label for=story class=\"control-label minotaur-label\">Omschrijving:</label><text-angular ng-model=vm.location.description ta-toolbar=\"[[\'h1\',\'h2\',\'h3\'],[\'bold\',\'italics\',\'quote\', \'clear\']]\"></text-angular><!-- <textarea type=\"text\" name=\"story\" id=\"story\" class=\"form-control\" ng-model=\"vm.location.full_story\" placeholder=\"Het verhaal\" rows=\"10\" required></textarea> --></div></div><button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 1\">Vorige</button> <button ng-disabled=step4.$invalid class=\"btn btn-success minotaur-btn pull-right\" ng-click=vm.submit()>Aanmaken</button></ng-form></uib-tab><!-- <uib-tab index=\"3\" disable=\"step3.$invalid\">\n\n      <uib-tab-heading>\n        <i class=\"fa fa-check\" ng-if=\"step4.$valid\"></i>\n        Extra info\n        <span class=\"pull-right wizard-step\">4</span>\n      </uib-tab-heading>\n\n      <ng-form name=\"step4\">\n\n        <h4>Algemene voorwaarden</h4>\n\n        <ng-form name=\"step4\">\n\n          <p class=\"well\">Kort verhaal; wat gebeurt er met de verhalen -> invuller staat open voor vragen en factchecking, verhaal kan gedeeld worden met andere initiatieven binnen Nationaal Erfgoed.</p>\n\n          <label class=\"checkbox minotaur-checkbox\">Ik ga akkoord met de <a href class=\"text-info\">Algemene Voorwaarden</a>\n            <input type=\"checkbox\" name=\"agree\" id=\"agree\" ng-model=\"vm.location.nationaal_erfgoed.agreed\" ng-true-value=\"true\" ng-false-value=\"false\" required>\n            <div class=\"input-indicator\"></div>\n          </label>\n          <div ng-messages=\"step5.agree.$error\" ng-if=\"step5.agree.$dirty\" role=\"alert\" class=\"help-block text-red\">\n            <div ng-messages-include=\"app/components/templates/messages_tmpl.html\"></div>\n          </div>\n\n          <label class=\"checkbox minotaur-checkbox\">Deel met <a href class=\"text-info\">Stichting Nationaal Erfgoed</a>\n            <input type=\"checkbox\" name=\"nationaalerfgoed\" value=\"\" id=\"nationaalerfgoed\" ng-model=\"vm.location.nationaal_erfgoed.shared\" ng-true-value=\"true\" ng-false-value=\"false\" checked>\n            <div class=\"input-indicator\"></div>\n          </label>\n\n          <button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 2\">Vorige</button>\n          <button ng-disabled=\"step4.$invalid\" class=\"btn btn-success minotaur-btn pull-right\" ng-click=\"vm.submit()\">Indienen</button>\n\n        </ng-form>\n\n\n      </ng-form>\n\n    </uib-tab> --><!-- <uib-tab index=\"4\" disable=\"step4.$invalid\">\n\n      <uib-tab-heading>\n        <i class=\"fa fa-check\" ng-if=\"step5.$valid\"></i>\n        Contact\n        <span class=\"pull-right wizard-step\">5</span>\n      </uib-tab-heading>\n\n      <ng-form name=\"step5\">\n\n        <div class=\"row\">\n          <div class=\"form-group col-md-6\">\n            <label for=\"email\" class=\"control-label minotaur-label\">Email <span class=\"text-red\">*</span>: </label>\n            <input type=\"email\" name=\"email\" id=\"email\" class=\"form-control\" ng-model=\"forms.user.email\" required>\n            <div ng-messages=\"step4.email.$error\" ng-if=\"step4.email.$dirty\" role=\"alert\" class=\"help-block text-red\">\n              <div ng-messages-include=\"app/components/templates/messages_tmpl.html\"></div>\n            </div>\n          </div>\n          <div class=\"form-group col-md-6\">\n            <label for=\"phone\" class=\"control-label minotaur-label\">Phone: </label>\n            <input type=\"text\" name=\"phone\" id=\"phone\" class=\"form-control\" ng-model=\"forms.user.phone\" placeholder=\"(XXX) XXXX XXX\"  ng-pattern=\"/\\([0-9]{3}\\) ([0-9]{4}) ([0-9]{3})$/\">\n            <div ng-messages=\"step4.phone.$error\" ng-if=\"step4.phone.$dirty\" role=\"alert\" class=\"help-block text-red\">\n              <div ng-messages-include=\"app/components/templates/messages_tmpl.html\"></div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"web\" class=\"control-label minotaur-label\">Website: </label>\n          <input type=\"url\" name=\"web\" id=\"web\" class=\"form-control\" ng-model=\"forms.user.web\" placeholder=\"http://\">\n          <div ng-messages=\"step4.web.$error\" ng-if=\"step4.web.$dirty\" role=\"alert\" class=\"help-block text-red\">\n            <div ng-messages-include=\"app/components/templates/messages_tmpl.html\"></div>\n          </div>\n        </div>\n\n        <button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 2\">Vorige</button>\n        <button ng-disabled=\"step5.$invalid\" class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 5\">Next</button>\n\n      </ng-form>\n\n    </uib-tab>\n --><!-- <uib-tab index=\"4\" disable=\"step4.$invalid\">\n\n      <uib-tab-heading>\n        <i class=\"fa fa-check\" ng-if=\"step5.$valid\"></i>\n        EULA\n        <span class=\"pull-right wizard-step\">5</span>\n      </uib-tab-heading>\n\n      <ng-form name=\"step5\">\n\n        <p class=\"well\">But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?</p>\n\n        <label class=\"checkbox minotaur-checkbox\">I agree to the <a href class=\"text-info\">Terms of Service</a>\n          <input type=\"checkbox\" name=\"agree\" id=\"agree\" ng-model=\"forms.user.agree\" required>\n          <div class=\"input-indicator\"></div>\n        </label>\n        <div ng-messages=\"step5.agree.$error\" ng-if=\"step5.agree.$dirty\" role=\"alert\" class=\"help-block text-red\">\n          <div ng-messages-include=\"app/components/templates/messages_tmpl.html\"></div>\n        </div>\n\n        <label class=\"checkbox minotaur-checkbox\">Receive newsletter\n          <input type=\"checkbox\" name=\"newsletter\" id=\"newsletter\" ng-model=\"forms.user.newsletter\">\n          <div class=\"input-indicator\"></div>\n        </label>\n\n        <button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 3\">Vorige</button>\n        <button ng-disabled=\"step5.$invalid\" class=\"btn btn-success minotaur-btn pull-right\" ng-click=\"forms.submit()\">Finish</button>\n\n      </ng-form>\n\n    </uib-tab> --></uib-tabset></form>");
$templateCache.put("app/pages/locations/edit.html","<div class=\"page page-locations pull-to-header\" ng-controller=\"EditLocationController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=locations.list>Locaties</a></li><li class=active>{{vm.location.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-8><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body style=\"padding: 0!important\" ng-include=\"\'app/pages/locations/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/locations/list.html","<div class=\"page page-locations pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=locations.list>Verhalensprokkelaar</a></li><li class=active>Manage</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Locations</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Locatie toevoegen\" tooltip-placement=bottom ui-sref=locations.new><i class=\"fa fa-plus\"></i> Voeg locatie toe</button></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"location in $data\"><td data-title=\"\'ID\'\" sortable>{{location.id}}</td><!-- <td data-title=\"\'Name\'\" sortable=\"\'name\'\">\n                  <a href=\"javascript:;\" ui-sref=\"locations.show({ id: location.$id })\">{{location.title}}</a>\n                </td> --><td data-title=\"\'Name\'\" sortable>{{location.name}}</td><!-- <td data-title=\"\'Category\'\" sortable=\"\'location.location_categoryName\'\">\n                  {{location.location_categoryName}}\n                </td> --><!-- <td data-title=\"\'Date Created\'\" sortable=\"\'created_at\'\">\n                  {{location.created_at | date: \'mediumDate\'}}\n                </td> --><td data-title=\"\'City\'\" sortable>{{location.cityName}}</td><!-- <td data-title=\"\'Status\'\" sortable=\"\'status\'\">\n                  <span class=\"label\" ng-class=\"{\'bg-success\' : location.status == \'published\',\'bg-warning\' : location.status == \'waiting\',\'bg-lightred\' : location.status == \'rejected\', \'bg-amethyst\' : location.status == \'concept\'}\">\n                    {{ location.status }}\n                  </span>\n                </td> --><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"locations.edit({ id: location.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(location)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/locations/new.html","<div class=\"page page-locations pull-to-header\" ng-controller=\"NewLocationController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=locations.list>Locaties</a></li><li class=active ng-bind-html=vm.location.title>Nieuwe locatie</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-8><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=\"tile-body p-0\" ng-include=\"\'app/pages/locations/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --><!-- <div class=\"col-md-4\">\n      <div class=\"tile-mobile\">\n\n          <section class=\"mobile-screen\">\n            <img class=\"iphone\" src=\"../assets/images/iphone.png\">\n            <div class=\"mobile-header\">\n              <div class=\"mobile-image\"><img src=\"{{vm.location.mainImage.src}}\"></div>\n              <div class=\"mobile-title\">{{vm.location.title}}</div>\n            </div>\n            <div class=\"mobile-body\">\n              <div class=\"mobile-infobar\"></div>\n              <div class=\"mobile-content\" ng-bind-html=\"vm.location.full_story\"></div>\n            </div>\n          </section>\n\n      </div>\n    </div> --></div><!-- /row --></div>");
$templateCache.put("app/pages/locations/show.html","<div class=\"page page-locations pull-to-header\" ng-controller=\"ShowLocationController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=location.list>Locations</a></li><li class=active>{{vm.location.title}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-4 magnific-popup=\"{delegate: \'a.img-link\', type: \'image\'}\"><a href={{vm.location.images[0].src}} class=img-link ng-show=\"vm.location.images.length > 0\"><img ng-src={{vm.location.images[0].src}} alt=vm.location.name class=\"img-responsive mb-20\"> </a><a href=javascript:; ng-show=\"vm.location.images.length === 0 || !vm.location.images\"><img src=assets/images/no-location-image.png alt=vm.location.name class=\"img-responsive mb-20\"> </a><!-- thumbnails --><slick dots=true infinite=false speed=300 slides-to-show=4 touch-move=false slides-to-scroll=1 arrows=false init-onload=true data=vm.location.images><div ng-repeat=\"image in vm.location.images\" ng-if=!$first href={{vm.location.images[$index].src}} class=mr-5><a href={{vm.location.images[$index].src}} class=img-link><img ng-src={{vm.location.images[$index].src}} alt=vm.location.name class=img-responsive></a></div></slick><!-- /thumbnails --></div><!-- /col --><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.location.name}} <span class=label ng-class=\"{\'bg-success\' : vm.location.status == \'published\',\'bg-warning\' : vm.location.status == \'not published\',\'bg-lightred\' : vm.location.status == \'banned\'}\">{{ vm.location.status }}</span></h2><p class=\"short-desc text-sm text-default lt mb-20\">{{vm.location.shortDescription}}</p><p class=\"desc text-default lt mb-20\">{{vm.location.description}}</p><h6><strong>Category:</strong> {{ctrl.categoriesObject[vm.location.categoryId].name}}</h6><h3 class=\"price mt-40 mb-0 text-success\">{{ vm.location.price | currency}} / <small>{{vm.location.unit}}</small></h3><p class=\"discount text-sm text-default lt\">Discount: {{vm.location.discount}}%</p></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=locations.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/h2g/_form.html","<form name=outerForm role=form novalidate class=form-validation><uib-tabset active=forms.activeStep justified=true class=\"tab-wizard padded\"><uib-tab index=0><uib-tab-heading><i class=\"fa fa-check\" ng-if=step1.$valid></i> Algemeen <span class=\"pull-right wizard-step\">1</span></uib-tab-heading><ng-form name=step1><div class=row><div class=\"form-group col-md-12\"><label for=username class=\"control-label minotaur-label\">Titel van het verhaal <span class=text-red>*</span>:</label><input type=text name=name id=name class=form-control placeholder=Titel ng-model=vm.h2g.title required><div ng-messages=step1.name.$error ng-if=step1.name.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div><div class=\"form-group col-md-6\"><label for=category class=\"control-label minotaur-label\">Categorie <span class=text-red>*</span>:</label><div class=form-group><select chosen=\"{width: \'100%\'}\" name=category class=form-control id=category ng-options=\"c.$id as c.name for c in ctrl.childCategories\" ng-model=vm.h2g.category data-placeholder=\"Select a category...\" required><option></option></select><div ng-messages=step1.username.$error ng-if=step1.username.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div></div></div></div><h4>Wat is de locatie van het verhaal?</h4><div class=row><div class=form-group><div class=col-sm-12><ng-map center=\"{{vm.h2g.mapdata.latitude}}, {{vm.h2g.mapdata.longitude}}\" zoom=16 pan-control=false map-type-control=false><marker position=\"{{vm.h2g.mapdata.latitude}}, {{vm.h2g.mapdata.longitude}}\" title=\"drag me\" draggable=true on-dragend=vm.getCurrentLocation()></marker><shape id=circle name=circle centered=true center=\"{{vm.h2g.mapdata.latitude}}, {{vm.h2g.mapdata.longitude}}\" stroke-color=#FF0000 stroke-opacity=0.8 stroke-weight=1 radius={{vm.h2g.pushradius}} editable=false></shape></ng-map><span class=help-block>Versleep de marker om de locatie te bepalen</span><div class=\"col-sm-6 p-0 pr-20\">Latitude: <input type=text class=form-control id=us2-lat ng-model=vm.h2g.mapdata.latitude><br>Pushradius: <input type=text class=form-control id=us2-radius ng-model=vm.h2g.pushradius> <span class=help-block>Pushradius geeft het gebied aan waarbinnen een pushbericht verzonden wordt naar de gebruiker.</span></div><div class=\"col-sm-6 p-0\">p Longitude: <input type=text class=form-control id=us2-lon ng-model=vm.h2g.mapdata.longitude><br>Address: <input class=form-control places-auto-complete ng-model=vm.h2g.address.fulladdress></div></div></div></div><h4>Wanneer speelt het verhaal zich af?</h4><div class=row><div class=\"form-group col-md-2\"><label for=startDate class=\"control-label minotaur-label\">Start jaar<span class=text-red>*</span>:</label><input type=text name=startDate id=startDate class=form-control ng-model=vm.h2g.date.start_year placeholder=YYYY ng-pattern=/[0-9]{1}$/ required></div><div class=\"form-group col-md-2\"><label for=startDate class=\"control-label minotaur-label\">Start maand:</label><input type=text name=startDate id=startDate class=form-control ng-model=vm.h2g.date.start_month placeholder=MM ng-pattern=/(0[1-9]|1[012])$/ ></div><div class=\"form-group col-md-2\"><label for=startDate class=\"control-label minotaur-label\">Start dag:</label><input type=text name=startDate id=startDate class=form-control ng-model=vm.h2g.date.start_day placeholder=DD ng-pattern=/(0[1-9]|1[0-9]|2[0-9]|3[01])$/ ></div></div><h4>Is er een einddatum?</h4><p><small><i>Wanneer een verhaal niet op een specifieke datum afspeelt graag hier de einddatum (indien van toepassing) aangeven.</i></small></p><div class=row><div class=\"form-group col-md-2\"><label for=endDate class=\"control-label minotaur-label\">Eind jaar:</label><input type=text name=endDate id=endDate class=form-control ng-model=vm.h2g.date.end_year placeholder=YYYY ng-pattern=/[0-9]{1}$/ ></div><div class=\"form-group col-md-2\"><label for=endDate class=\"control-label minotaur-label\">Eind maand:</label><input type=text name=endDate id=endDate class=form-control ng-model=vm.h2g.date.end_month placeholder=MM ng-pattern=/(0[1-9]|1[012])$/ ></div><div class=\"form-group col-md-2\"><label for=endDate class=\"control-label minotaur-label\">Eind dag:</label><input type=text name=endDate id=endDate class=form-control ng-model=vm.h2g.date.end_day placeholder=DD ng-pattern=/(0[1-9]|1[0-9]|2[0-9]|3[01])$/ ></div></div><button class=\"btn btn-warning minotaur-btn\" ui-sref=h2g.list>Terug naar overzicht</button> <button ng-disabled=step1.$invalid class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 1; vm.saveTemp()\">Next</button></ng-form></uib-tab><uib-tab index=1 disable=step1.$invalid><uib-tab-heading><i class=\"fa fa-check\" ng-if=step2.$valid></i> Foto\'s <span class=\"pull-right wizard-step\">2</span></uib-tab-heading><ng-form name=step2><h4>Foto\'s</h4><p><small><i>Upload en selecteer hier de foto\'s die je gebruikt in het verhaal.</i></small></p><div class=\"row mb20\"><div class=form-group><div class=\"col-sm-12 mb20\"><div ngf-drop ngf-select ngf-drag-over-class=dragover ngf-resize=\"{width: 1400, height: 1000, quality: 0.9, centerCrop: false, type: \'image/jpeg\'}\" ngf-multiple=true accept=image/* ng-model=vm.h2g.imagess class=\"fileupload drop-box\" name=images>Klik hier of sleep foto\'s hier naartoe...</div></div><div class=col-sm-12><ul class=\"list-unstyled list-inline\"><li ng-repeat=\"image in vm.h2g.images\" class=\"col-sm-6 wizard-image\"><button class=btn-image-delete ng-click=vm.imageDelete(image) ng-show=image><i class=\"fa fa-trash\" aria-hidden=true></i></button><div class=row><div class=col-sm-4><img ngf-thumbnail=image alt=\"\" style=\"width: 100%; height: 120px\"> <img ngf-thumbnail=image.src alt=\"\" style=\"width: 100%; height: 120px\"></div><div class=col-sm-8><input type=text name=caption ng-model=image.caption class=\"form-control thumb-caption mb10 mt5\" placeholder=Onderschrift> <input type=text name=copyright ng-model=image.copyright class=\"form-control thumb-caption mb10\" placeholder=Copyright><div class=\"onoffswitch greensea inline-block\"><input type=radio name=onoffswitch-radio ng-click=vm.updateImageSelect(image) ng-value=image.main_image class=onoffswitch-checkbox id=\"{{ \'switch\' + $index }}\"><label class=onoffswitch-label for=\"{{ \'switch\' + $index }}\"><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div><label class=switch-label>Hoofd foto</label></div></div><uib-progressbar class=\"progress-xxs mt-10\" value=image.progress type=cyan ng-show=\"image.progress >= 0\"></uib-progressbar></li></ul></div></div></div><button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 0\">Vorige</button> <button ng-disabled=step2.$invalid class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 2; vm.saveTemp2()\">Next</button></ng-form></uib-tab><uib-tab index=2 disable=step1.$invalid><uib-tab-heading><i class=\"fa fa-check\" ng-if=step3.$valid></i> Verhaal <span class=\"pull-right wizard-step\">3</span></uib-tab-heading><ng-form name=step3><div class=row><div class=\"form-group col-md-12\"><label for=intro class=\"control-label minotaur-label\">Inleiding <span class=text-red>*</span>:</label><textarea type=text name=intro id=intro class=form-control ng-model=vm.h2g.introduction placeholder=\"Korte inleiding\" rows=4 required></textarea></div><div class=\"form-group col-md-12\"><label for=story class=\"control-label minotaur-label\">Het verhaal <span class=text-red>*</span>:</label><text-angular ng-model=vm.h2g.full_story ta-toolbar=\"[[\'h1\',\'h2\',\'h3\'],[\'bold\',\'italics\',\'quote\', \'clear\']]\" required></text-angular><!-- <textarea type=\"text\" name=\"story\" id=\"story\" class=\"form-control\" ng-model=\"vm.h2g.full_story\" placeholder=\"Het verhaal\" rows=\"10\" required></textarea> --></div></div><button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 1\">Vorige</button> <button ng-disabled=step3.$invalid class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 3; vm.saveTemp3()\">Next</button></ng-form></uib-tab><uib-tab index=3 disable=step3.$invalid><uib-tab-heading><i class=\"fa fa-check\" ng-if=step4.$valid></i> Extra info <span class=\"pull-right wizard-step\">4</span></uib-tab-heading><ng-form name=step4><h4>Algemene voorwaarden</h4><ng-form name=step4><p class=well>Hier komt een korte disclaimer wat er met de verhalen gaat gebeuren.</p><label class=\"checkbox minotaur-checkbox\">Ik ga akkoord met de <a href class=text-info>Algemene Voorwaarden</a> <input type=checkbox name=agree id=agree ng-model=vm.h2g.nationaal_erfgoed.agreed ng-true-value=true ng-false-value=false required><div class=input-indicator></div></label><div ng-messages=step5.agree.$error ng-if=step5.agree.$dirty role=alert class=\"help-block text-red\"><div ng-messages-include=app/components/templates/messages_tmpl.html></div></div><label class=\"checkbox minotaur-checkbox\">Deel met <a href class=text-info>Stichting Nationaal Erfgoed</a> <input type=checkbox name=nationaalerfgoed id=nationaalerfgoed ng-model=vm.h2g.nationaal_erfgoed.shared ng-true-value=true ng-false-value=false checked><div class=input-indicator></div></label><button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 2\">Vorige</button> <button ng-disabled=step4.$invalid class=\"btn btn-success minotaur-btn pull-right\" ng-click=vm.submit()>Indienen</button></ng-form></ng-form></uib-tab><!-- <uib-tab index=\"4\" disable=\"step4.$invalid\">\n\n      <uib-tab-heading>\n        <i class=\"fa fa-check\" ng-if=\"step5.$valid\"></i>\n        Contact\n        <span class=\"pull-right wizard-step\">5</span>\n      </uib-tab-heading>\n\n      <ng-form name=\"step5\">\n\n        <div class=\"row\">\n          <div class=\"form-group col-md-6\">\n            <label for=\"email\" class=\"control-label minotaur-label\">Email <span class=\"text-red\">*</span>: </label>\n            <input type=\"email\" name=\"email\" id=\"email\" class=\"form-control\" ng-model=\"forms.user.email\" required>\n            <div ng-messages=\"step4.email.$error\" ng-if=\"step4.email.$dirty\" role=\"alert\" class=\"help-block text-red\">\n              <div ng-messages-include=\"app/components/templates/messages_tmpl.html\"></div>\n            </div>\n          </div>\n          <div class=\"form-group col-md-6\">\n            <label for=\"phone\" class=\"control-label minotaur-label\">Phone: </label>\n            <input type=\"text\" name=\"phone\" id=\"phone\" class=\"form-control\" ng-model=\"forms.user.phone\" placeholder=\"(XXX) XXXX XXX\"  ng-pattern=\"/\\([0-9]{3}\\) ([0-9]{4}) ([0-9]{3})$/\">\n            <div ng-messages=\"step4.phone.$error\" ng-if=\"step4.phone.$dirty\" role=\"alert\" class=\"help-block text-red\">\n              <div ng-messages-include=\"app/components/templates/messages_tmpl.html\"></div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"web\" class=\"control-label minotaur-label\">Website: </label>\n          <input type=\"url\" name=\"web\" id=\"web\" class=\"form-control\" ng-model=\"forms.user.web\" placeholder=\"http://\">\n          <div ng-messages=\"step4.web.$error\" ng-if=\"step4.web.$dirty\" role=\"alert\" class=\"help-block text-red\">\n            <div ng-messages-include=\"app/components/templates/messages_tmpl.html\"></div>\n          </div>\n        </div>\n\n        <button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 2\">Vorige</button>\n        <button ng-disabled=\"step5.$invalid\" class=\"btn btn-default minotaur-btn pull-right\" ng-click=\"forms.activeStep = 5\">Next</button>\n\n      </ng-form>\n\n    </uib-tab>\n --><!-- <uib-tab index=\"4\" disable=\"step4.$invalid\">\n\n      <uib-tab-heading>\n        <i class=\"fa fa-check\" ng-if=\"step5.$valid\"></i>\n        EULA\n        <span class=\"pull-right wizard-step\">5</span>\n      </uib-tab-heading>\n\n      <ng-form name=\"step5\">\n\n        <p class=\"well\">But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?</p>\n\n        <label class=\"checkbox minotaur-checkbox\">I agree to the <a href class=\"text-info\">Terms of Service</a>\n          <input type=\"checkbox\" name=\"agree\" id=\"agree\" ng-model=\"forms.user.agree\" required>\n          <div class=\"input-indicator\"></div>\n        </label>\n        <div ng-messages=\"step5.agree.$error\" ng-if=\"step5.agree.$dirty\" role=\"alert\" class=\"help-block text-red\">\n          <div ng-messages-include=\"app/components/templates/messages_tmpl.html\"></div>\n        </div>\n\n        <label class=\"checkbox minotaur-checkbox\">Receive newsletter\n          <input type=\"checkbox\" name=\"newsletter\" id=\"newsletter\" ng-model=\"forms.user.newsletter\">\n          <div class=\"input-indicator\"></div>\n        </label>\n\n        <button class=\"btn btn-default minotaur-btn\" ng-click=\"forms.activeStep = 3\">Vorige</button>\n        <button ng-disabled=\"step5.$invalid\" class=\"btn btn-success minotaur-btn pull-right\" ng-click=\"forms.submit()\">Finish</button>\n\n      </ng-form>\n\n    </uib-tab> --></uib-tabset></form>");
$templateCache.put("app/pages/h2g/edit.html","<div class=\"page page-h2gs pull-to-header\" ng-controller=\"EditH2gController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=h2g.list>History2Go</a></li><li class=active>{{vm.h2g.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-8><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body style=\"padding: 0!important\" ng-include=\"\'app/pages/h2g/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --><div class=col-md-4><div class=tile-mobile><!-- tile body --><section class=mobile-screen><img class=iphone src=/assets/images/iphone.png><div class=mobile-header><div class=mobile-image><img src={{vm.h2g.mainImage.src}}></div><div class=mobile-title>{{vm.h2g.title}}</div></div><div class=mobile-body><div class=mobile-infobar></div><div class=mobile-content ng-bind-html=vm.h2g.full_story></div></div></section><!-- /tile body --></div></div></div><!-- /row --></div>");
$templateCache.put("app/pages/h2g/list.html","<div class=\"page page-h2gs pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=h2g.list>History2Go</a></li><li class=active>Manage</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage History2Go</h1><div class=controls><button class=\"btn btn-default mb10\" uib-tooltip=\"Item toevoegen\" tooltip-placement=bottom ui-sref=h2g.new><i class=\"fa fa-plus\"></i> Voeg item toe</button></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"h2g in $data\"><td data-title=\"\'ID\'\" sortable>{{h2g.id}}</td><!-- <td data-title=\"\'Name\'\" sortable=\"\'name\'\">\n                  <a href=\"javascript:;\" ui-sref=\"h2gs.show({ id: h2g.$id })\">{{h2g.title}}</a>\n                </td> --><td data-title=\"\'Name\'\" sortable>{{h2g.title}}</td><td data-title=\"\'Category\'\" sortable>{{h2g.h2g_categoryName}}</td><!-- <td data-title=\"\'Date Created\'\" sortable=\"\'created_at\'\">\n                  {{h2g.created_at | date: \'mediumDate\'}}\n                </td> --><td data-title=\"\'Locatie\'\" sortable>{{h2g.locationName}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : h2g.status == \'published\',\'bg-warning\' : h2g.status == \'waiting\',\'bg-lightred\' : h2g.status == \'rejected\', \'bg-amethyst\' : h2g.status == \'concept\'}\">{{ h2g.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"h2g.edit({ id: h2g.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(h2g)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/h2g/new.html","<div class=\"page page-h2gs pull-to-header\" ng-controller=\"NewH2gController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=h2g.list>History2Go</a></li><li class=active ng-bind-html=vm.h2g.title>New item</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-8><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=\"tile-body p-0\" ng-include=\"\'app/pages/h2g/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --><div class=col-md-4><div class=tile-mobile><!-- tile body --><section class=mobile-screen><img class=iphone src=/assets/images/iphone.png><div class=mobile-header><div class=mobile-image><img src={{vm.h2g.mainImage.src}}></div><div class=mobile-title>{{vm.h2g.title}}</div></div><div class=mobile-body><div class=mobile-infobar></div><div class=mobile-content ng-bind-html=vm.h2g.full_story></div></div></section><!-- /tile body --></div></div></div><!-- /row --></div>");
$templateCache.put("app/pages/h2g/show.html","<div class=\"page page-h2gs pull-to-header\" ng-controller=\"ShowH2gController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=h2g.list>History2Go</a></li><li class=active>{{vm.h2g.title}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-4 magnific-popup=\"{delegate: \'a.img-link\', type: \'image\'}\"><a href={{vm.h2g.images[0].src}} class=img-link ng-show=\"vm.h2g.images.length > 0\"><img ng-src={{vm.h2g.images[0].src}} alt=vm.h2g.name class=\"img-responsive mb-20\"> </a><a href=javascript:; ng-show=\"vm.h2g.images.length === 0 || !vm.h2g.images\"><img src=assets/images/no-h2g-image.png alt=vm.h2g.name class=\"img-responsive mb-20\"> </a><!-- thumbnails --><slick dots=true infinite=false speed=300 slides-to-show=4 touch-move=false slides-to-scroll=1 arrows=false init-onload=true data=vm.h2g.images><div ng-repeat=\"image in vm.h2g.images\" ng-if=!$first href={{vm.h2g.images[$index].src}} class=mr-5><a href={{vm.h2g.images[$index].src}} class=img-link><img ng-src={{vm.h2g.images[$index].src}} alt=vm.h2g.name class=img-responsive></a></div></slick><!-- /thumbnails --></div><!-- /col --><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.h2g.name}} <span class=label ng-class=\"{\'bg-success\' : vm.h2g.status == \'published\',\'bg-warning\' : vm.h2g.status == \'not published\',\'bg-lightred\' : vm.h2g.status == \'banned\'}\">{{ vm.h2g.status }}</span></h2><p class=\"short-desc text-sm text-default lt mb-20\">{{vm.h2g.shortDescription}}</p><p class=\"desc text-default lt mb-20\">{{vm.h2g.description}}</p><h6><strong>Category:</strong> {{ctrl.categoriesObject[vm.h2g.categoryId].name}}</h6><h3 class=\"price mt-40 mb-0 text-success\">{{ vm.h2g.price | currency}} / <small>{{vm.h2g.unit}}</small></h3><p class=\"discount text-sm text-default lt\">Discount: {{vm.h2g.discount}}%</p></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=h2g.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/login/login.html","<div class=\"page page-core page-login\"><div class=login-modal><div class=branding><img src=assets/images/logo-alt.png alt><h2 class=brand><strong>Nationaal</strong> Erfgoed</h2></div><form name=form ng-submit=ctrl.login();><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-user></i></span> <input type=email placeholder=\"Email address\" ng-model=ctrl.email class=form-control required></div><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-key></i></span> <input type=password placeholder=Password ng-model=ctrl.password class=form-control required></div><div class=form-group><a ui-sref=core.forgotpass>Forgot Password?</a></div><button type=submit class=\"btn btn-block btn-lg btn-rounded-40\" ng-disabled=form.$invalid>Login</button></form><!-- <div class=\"mt-15 text-center\">Not Registered? <a ui-sref=\"core.signup\">Create an account</a></div> --></div></div>");
$templateCache.put("app/pages/orders/list.html","<div class=\"page page-orders pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=orders.list>Orders</a></li><li class=active>Manage Orders</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Orders</h1><div class=controls><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive style=\"overflow-x: visible\"><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"order in $data\"><td data-title=\"\'ID\'\" sortable><a ui-sref=\"orders.show({id: order.$id})\">{{order.id}}</a></td><td data-title=\"\'Date\'\" sortable>{{order.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Customer\'\" sortable>{{order.customer.name}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : order.status == \'approved\',\'bg-warning\' : order.status == \'pending\',\'bg-lightred\' : order.status == \'cancelled\',\'bg-primary\' : order.status == \'received\'}\">{{ order.status }}</span></td><td data-title=\"\'Ship To\'\" sortable>{{ order.shipTo.name }}, {{ order.shipTo.street }}, {{ order.shipTo.city }} {{ order.shipTo.zip }}, {{ order.shipTo.country }}</td><td data-title=\"\'Total\'\" sortable>{{order.subTotal | currency }}</td><td data-title=\"\'Actions\'\" class=w-md><div class=\"text-left rounded-dropdown\" uib-dropdown><button type=button class=\"btn btn-default btn-sm btn-rounded-20\" uib-dropdown-toggle><span><span ng-class=\"{\'text-success\' : order.status == \'approved\',\'text-warning\' : order.status == \'pending\',\'text-lightred\' : order.status == \'cancelled\',\'text-primary\' : order.status == \'received\'}\">{{order.status}}</span> <i class=\"fa fa-chevron-down\"></i></span></button><ul class=\"dropdown-menu pull-right\" role=menu aria-labelledby=single-button><li role=menuitem><a href=javascript:; ng-click=\"ctrl.changeStatus(order, \'pending\')\">Pending</a></li><li role=menuitem><a href=javascript:; ng-click=\"ctrl.changeStatus(order, \'approved\')\">Approved</a></li><li role=menuitem><a href=javascript:; ng-click=\"ctrl.changeStatus(order, \'cancelled\')\">Cancelled</a></li><li role=menuitem><a href=javascript:; ng-click=\"ctrl.changeStatus(order, \'received\')\">Received</a></li></ul></div><button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(category)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/orders/show.html","<div class=\"page page-orders pull-to-header\" ng-controller=\"ShowOrderController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=orders.list>Orders</a></li><li class=active>{{vm.order.id}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><!-- row --><div class=row><!-- col --><div class=col-md-9><p class=\"text-default lt\">Created: {{ vm.order.created_at | date: \'MMMM dd, yyyy\' }} at {{ vm.order.created_at | date: \'HH:mm\' }}</p><h5 class=\"text-uppercase text-strong mt-40 mb-0\">Status</h5><h3 class=\"text-uppercase mt-0 mb-20\" ng-class=\"{\'text-success\' : vm.order.status == \'approved\',\'text-warning\' : vm.order.status == \'pending\',\'text-lightred\' : vm.order.status == \'cancelled\',\'text-primary\' : vm.order.status == \'received\'}\">{{vm.order.status | uppercase}}</h3></div><!-- /col --><!-- col --><div class=col-md-3><h5 class=\"text-uppercase text-strong mb-10\">Customer</h5><ul class=\"list-unstyled text-default lt mb-20\"><li><strong class=\"inline-block w-xs\">Name:</strong> {{vm.order.customer.name}}</li><li><strong class=\"inline-block w-xs\">State:</strong> {{vm.order.customer.country}}</li><li><strong class=\"inline-block w-xs\">Phone:</strong> {{vm.order.customer.phone}}</li><li><strong class=\"inline-block w-xs\">Email:</strong> <a href=javascript:;>{{vm.order.customer.email}}</a></li></ul></div><!-- /col --></div><!-- /row --><!-- row --><div class=\"row b-t pt-20\"><!-- col --><div class=\"col-md-3 b-r\"><h5 class=\"text-uppercase text-strong mb-10\">Order Details</h5><ul class=\"list-unstyled text-default lt mb-20\"><li><strong>ID:</strong> <a href=javascript:;>{{vm.order.id}}</a></li><li>{{ vm.order.created_at | date: \'MMMM dd, yyyy\' }} at {{ vm.order.created_at | date: \'HH:mm\' }}</li><li>{{vm.order.customer.name}}</li><li>{{vm.order.customer.country}}</li></ul></div><!-- /col --><!-- col --><div class=\"col-md-6 b-r\"><h5 class=\"text-uppercase text-strong mb-10\">Address</h5><!-- col --><div class=col-md-6><ul class=\"list-unstyled text-default lt mb-20\"><li>{{vm.order.shipTo.name}}</li><li>{{vm.order.shipTo.street}}</li><li>{{vm.order.shipTo.city}}</li><li>{{vm.order.shipTo.zip}}</li><li>{{vm.order.shipTo.country}}</li></ul></div><!-- /col --><!-- col --><div class=col-md-6><ul class=\"list-unstyled text-default lt mb-20\"><li>{{vm.order.customer.email}}</li><li>{{vm.order.customer.phone}}</li></ul></div><!-- /col --></div><!-- /col --><!-- col --><div class=col-md-3><h5 class=\"text-uppercase text-strong mb-10\">Delivery & Payment</h5><ul class=\"list-unstyled text-default lt mb-20\"><li><strong>Delivery:</strong> {{vm.order.delivery}}</li><li><strong>Payment:</strong> {{vm.order.payment}}</li></ul></div><!-- /col --></div><!-- /row --></section><!-- /tile body --></div><!-- /tile --><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=\"tile-body p-0\"><div class=table-responsive><table class=\"table table-hover\"><thead><tr><th>Product Image</th><th>Product</th><th>Category</th><th>Unit Price</th><th>Amount</th><th>Total</th></tr></thead><tbody><tr ng-repeat=\"(id, product) in vm.order.products\"><td style=\"vertical-align: middle\"><img ng-src={{ctrl.productsObject[id].images[0].src}} alt={{ctrl.productsObject[id].name}} style=\"width: 64px; height: 64px\"></td><td style=\"vertical-align: middle\"><a ui-sref=\"products.show({id: id})\">{{ctrl.productsObject[id].name}}</a><br><span class=\"text-sm text-muted\">{{ctrl.productsObject[id].shortDescription | limitTo: 80}}...</span></td><td style=\"vertical-align: middle\">{{ctrl.categoriesObject[ctrl.productsObject[id].categoryId].name}}</td><td style=\"vertical-align: middle\">{{product.price | currency}}</td><td style=\"vertical-align: middle\">{{product.amount}}</td><td style=\"vertical-align: middle\">{{(product.price) * product.amount | currency}}</td></tr></tbody></table></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=\"col-md-3 col-md-offset-9 price-total\"><!-- tile --><div class=\"tile tile-simple bg-slategray\"><!-- tile body --><section class=tile-body><ul class=list-unstyled><li><strong class=\"inline-block w-sm mb-5\">Subtotal:</strong> {{vm.order.subTotal | currency}}</li><li><strong class=\"inline-block w-sm mb-5\">Vat %:</strong> {{ main.settings.globalVAT }}</li><li><strong class=\"inline-block w-sm mb-5\">Vat Total:</strong> {{ vm.order.subTotal * (main.settings.globalVAT / 100) | currency}}</li><li><strong class=\"inline-block w-sm\">Total:</strong><h3 class=\"inline-block text-success\">{{ vm.order.subTotal + (vm.order.subTotal * (main.settings.globalVAT / 100)) | currency}}</h3></li></ul></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/products/_form.html","<form name=vm.form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=id class=\"col-sm-3 control-label minotaur-label\">ID</label><div class=col-sm-9><input type=text name=id class=form-control id=id placeholder=\"Product ID...\" ng-model=vm.product.id required disabled></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"Product name...\" ng-model=vm.product.name required></div></div><div class=form-group><label for=description class=\"col-sm-3 control-label minotaur-label\">Description <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=description id=description ng-model=vm.product.description class=form-control placeholder=\"Product description...\" rows=5 required></textarea></div></div><div class=form-group><label for=shortDescription class=\"col-sm-3 control-label minotaur-label\">Short Description <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=shortDescription id=shortDescription ng-model=vm.product.shortDescription class=form-control placeholder=\"Product short description...\" rows=2 ng-maxlength=260 required></textarea><span class=help-block>as show in product listing, max. 260 characters</span></div></div><div class=form-group><label for=category class=\"col-sm-3 control-label minotaur-label\">Category <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=category class=form-control id=category ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childCategories\" ng-model=vm.product.categoryId data-placeholder=\"Select a category...\" required><option></option></select></div></div><div class=form-group><label for=price class=\"col-sm-3 control-label minotaur-label\">Price <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><div class=input-group><div class=input-group-addon>$</div><input type=number class=form-control name=price id=price ng-model=vm.product.price min=0 step=any required></div></div></div><div class=form-group><label for=discount class=\"col-sm-3 control-label minotaur-label\">Discount <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><div class=input-group><input type=number class=form-control name=discount id=discount ng-model=vm.product.discount min=0 max=100 required><div class=input-group-addon>%</div></div></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label minotaur-label\">Unit <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=unit class=form-control id=unit ng-options=\"k as v for (k,v) in ctrl.units\" ng-model=vm.product.unit data-placeholder=\"Select a unit...\" required><option></option></select></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label minotaur-label\">Status <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=status class=form-control id=status ng-options=\"v as v for (k,v) in ctrl.statuses\" ng-model=vm.product.status data-placeholder=\"Select a status...\" required><option></option></select></div></div><div class=form-group><label class=\"control-label minotaur-label col-sm-3\">Images</label><div class=col-sm-9><ul class=\"list-unstyled list-inline thumbs-list\"><li ng-repeat=\"image in vm.product.images\"><img ngf-thumbnail=image alt=\"\" style=\"width: 120px; height: 120px\"> <img ngf-thumbnail=image.src alt=\"\" style=\"width: 120px; height: 120px\"> <button class=btn-nostyle ng-click=\"image = null\" ng-show=\"image && !vm.editing\">x</button></li></ul><p class=\"help-block text-danger\" ng-show=vm.editing>Adding new images will rewrite actual images!</p><div ngf-drop ngf-select ngf-drag-over-class=dragover ngf-multiple=true accept=image/* ng-model=vm.product.images class=\"fileupload drop-box\" name=images>click or drop files here...</div></div></div><div class=form-footer><i class=\"fa fa-spinner fa-pulse fa-fw\" ng-if=vm.processing></i> <button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=\"vm.form.$invalid || vm.processing\">Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=products.list ng-disabled=vm.processing><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/products/edit.html","<div class=\"page page-products pull-to-header\" ng-controller=\"EditProductController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Products</a></li><li class=active>{{vm.product.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/products/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/products/list.html","<div class=\"page page-products pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=products.list>Products</a></li><li class=active>Manage Products</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Products</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add Product\" tooltip-placement=bottom ui-sref=products.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"product in $data\"><td data-title=\"\'ID\'\" sortable>{{product.id}}</td><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"products.show({ id: product.$id })\">{{product.name}}</a></td><td data-title=\"\'Category\'\" sortable>{{product.categoryName}}</td><td data-title=\"\'Price\'\" sortable>{{product.price | currency}}</td><td data-title=\"\'Date Created\'\" sortable>{{product.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : product.status == \'published\',\'bg-warning\' : product.status == \'not published\',\'bg-lightred\' : product.status == \'banned\'}\">{{ product.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"products.edit({ id: product.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(product)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/products/new.html","<div class=\"page page-products pull-to-header\" ng-controller=\"NewProductController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=products.list>Products</a></li><li class=active>New Product</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/products/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/products/show.html","<div class=\"page page-products pull-to-header\" ng-controller=\"ShowProductController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Products</a></li><li class=active>{{vm.product.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-4 magnific-popup=\"{delegate: \'a.img-link\', type: \'image\'}\"><a href={{vm.product.images[0].src}} class=img-link ng-show=\"vm.product.images.length > 0\"><img ng-src={{vm.product.images[0].src}} alt=vm.product.name class=\"img-responsive mb-20\"> </a><a href=javascript:; ng-show=\"vm.product.images.length === 0 || !vm.product.images\"><img src=assets/images/no-product-image.png alt=vm.product.name class=\"img-responsive mb-20\"> </a><!-- thumbnails --><slick dots=true infinite=false speed=300 slides-to-show=4 touch-move=false slides-to-scroll=1 arrows=false init-onload=true data=vm.product.images><div ng-repeat=\"image in vm.product.images\" ng-if=!$first href={{vm.product.images[$index].src}} class=mr-5><a href={{vm.product.images[$index].src}} class=img-link><img ng-src={{vm.product.images[$index].src}} alt=vm.product.name class=img-responsive></a></div></slick><!-- /thumbnails --></div><!-- /col --><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.product.name}} <span class=label ng-class=\"{\'bg-success\' : vm.product.status == \'published\',\'bg-warning\' : vm.product.status == \'not published\',\'bg-lightred\' : vm.product.status == \'banned\'}\">{{ vm.product.status }}</span></h2><p class=\"short-desc text-sm text-default lt mb-20\">{{vm.product.shortDescription}}</p><p class=\"desc text-default lt mb-20\">{{vm.product.description}}</p><h6><strong>Category:</strong> {{ctrl.categoriesObject[vm.product.categoryId].name}}</h6><h3 class=\"price mt-40 mb-0 text-success\">{{ vm.product.price | currency}} / <small>{{vm.product.unit}}</small></h3><p class=\"discount text-sm text-default lt\">Discount: {{vm.product.discount}}%</p></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=products.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/profile/profile.html","<div class=\"page page-dashboard pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li class=active>My Account</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-6><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Personal Info</h1><div class=controls><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><form name=form class=\"form form-horizontal\"><div class=\"form-group mt-20\"><label for=avatar class=\"col-sm-3 control-label minotaur-label\">Avatar</label><div class=col-sm-9><img ngf-thumbnail=ctrl.user.avatar alt=\"\" class=mb-10 style=\"width: 80px; height: 80px\"><a href=javascript:; class=\"inline-block p-5 text-danger ml-5\" ng-click=\"ctrl.user.avatar = null\" ng-show=ctrl.user.avatar><i class=\"fa fa-times\"></i></a> <input type=file name=avatar id=avatar ng-model=ctrl.user.avatar ngf-select ngf-pattern=\"\'image/*\'\" accept=image/* ngf-max-size=5MB></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Name</label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"User name...\" ng-model=ctrl.user.name></div></div><div class=form-group ng-show=ctrl.changeEmail><label for=email class=\"col-sm-3 control-label minotaur-label\">Email <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=email name=email class=form-control id=email placeholder=\"User email...\" ng-model=ctrl.user.email required></div></div><div class=form-group ng-show=ctrl.changePass><label for=oldpassword class=\"col-sm-3 control-label minotaur-label\">Old Password <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=oldpassword class=form-control id=oldpassword placeholder=\"User old password...\" ng-model=ctrl.oldpassword ng-required=ctrl.changePass></div></div><div class=form-group ng-show=\"ctrl.changePass || ctrl.changeEmail\"><label for=password class=\"col-sm-3 control-label minotaur-label\">Password <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=password class=form-control id=password placeholder=\"User password...\" ng-model=ctrl.user.password ng-required=\"ctrl.changePass || ctrl.changeEmail\"></div></div><div class=form-group ng-show=\"ctrl.changePass || ctrl.changeEmail\"><label for=password class=\"col-sm-3 control-label minotaur-label\">Password Confirm <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=passwordConfirm placeholder=\"Password confirmarion...\" class=form-control ng-model=ctrl.passwordConfirm match=ctrl.user.password ng-required=\"ctrl.changePass || ctrl.changeEmail\"></div></div><div class=form-group><label for=street class=\"col-sm-3 control-label minotaur-label\">Street</label><div class=col-sm-9><input type=text name=street class=form-control id=street placeholder=\"User address street...\" ng-model=ctrl.user.address.street></div></div><div class=form-group><label for=city class=\"col-sm-3 control-label minotaur-label\">City</label><div class=col-sm-9><input type=text name=city class=form-control id=city placeholder=\"User address city...\" ng-model=ctrl.user.address.city></div></div><div class=form-group><label for=zip class=\"col-sm-3 control-label minotaur-label\">ZIP</label><div class=col-sm-9><input type=text name=zip class=form-control id=zip placeholder=\"User address zip...\" ng-model=ctrl.user.address.zip></div></div><div class=form-group><label for=country class=\"col-sm-3 control-label minotaur-label\">Country</label><div class=col-sm-9><input type=text name=country class=form-control id=country placeholder=\"User address country...\" ng-model=ctrl.user.address.country></div></div><div class=form-group><label for=phone class=\"col-sm-3 control-label minotaur-label\">Phone</label><div class=col-sm-9><input type=text name=phone class=form-control id=phone placeholder=\"User address phone...\" ng-model=ctrl.user.phone></div></div><div class=form-group><div class=\"col-sm-9 col-md-offset-3\"><label class=\"checkbox minotaur-checkbox mr-20\" style=\"display: inline-block\"><input type=checkbox ng-disabled=ctrl.changePass ng-model=ctrl.changeEmail> Change email<div class=input-indicator></div></label><label class=\"checkbox minotaur-checkbox\" style=\"display: inline-block\"><input type=checkbox ng-disabled=ctrl.changeEmail ng-model=ctrl.changePass> Change password<div class=input-indicator></div></label></div></div></form></section><!-- /tile body --><div class=\"tile-footer text-right bg-tr-black lter\"><!-- SUBMIT BUTTON --> <button class=\"btn btn-success minotaur-btn\" ng-click=ctrl.save() ng-disabled=form.$invalid>Save</button></div></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/signup/signup.html","<div class=\"page page-core page-signup\"><div class=login-modal><div class=branding><img src=assets/images/logo-alt.png alt><h2 class=brand><strong>Nationaal</strong>Erfgoed</h2></div><form name=form ng-submit=ctrl.createUser()><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-user></i></span> <input type=text placeholder=\"Full name\" class=form-control ng-model=ctrl.name required></div><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-envelope></i></span> <input type=email placeholder=\"Email address\" class=form-control ng-model=ctrl.email required></div><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-key></i></span> <input type=password placeholder=Password class=form-control ng-model=ctrl.password required></div><div class=form-group><label class=\"minotaur-checkbox minotaur-label inline-block\">I agree to the <a href=javascript:;>Terms of Service</a> & <a href=javascript:;>Privacy Policy</a> <input type=checkbox required><div class=input-indicator></div></label></div><button type=submit class=\"btn btn-lg btn-block btn-rounded-40\" ng-disabled=form.$invalid>Submit</button></form><div class=\"mt-15 text-center\">Already have an account? <a ui-sref=core.login>Please log in</a></div></div></div>");
$templateCache.put("app/pages/settings/settings.html","<div class=\"page page-settings pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li class=active>Settings</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-6><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Global Settings</h1><div class=controls><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><form name=form class=\"form form-horizontal\"><div class=form-group><label for=vat class=\"col-sm-3 control-label minotaur-label\">Global VAT <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=number name=vat class=form-control id=vat placeholder=\"Set global VAT value...\" ng-model=ctrl.settings.globalVAT required></div></div></form></section><!-- /tile body --><div class=\"tile-footer text-right bg-tr-black lter\"><!-- SUBMIT BUTTON --> <button class=\"btn btn-success minotaur-btn\" ng-click=ctrl.save() ng-disabled=form.$invalid>Save</button></div></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/stories/_form.html","<form name=vm.form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=id class=\"col-sm-3 control-label\">ID</label><div class=col-sm-9><input type=text name=id class=form-control id=id placeholder=\"story ID...\" ng-model=vm.story.id required disabled></div></div><div class=form-group><label for=title class=\"col-sm-3 control-label\">Title <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=title class=form-control id=title placeholder=\"story title...\" ng-model=vm.story.title required></div></div><div class=form-group><label for=category class=\"col-sm-3 control-label\">Category <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=category class=form-control id=category ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childCategories\" ng-model=vm.story.category data-placeholder=\"Select a category...\" required><option></option></select></div></div><div class=form-group><label for=city class=\"col-sm-3 control-label\">City <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=city class=form-control id=city ng-options=\"c.$id as c.name for c in ctrl.childCities\" ng-model=vm.story.address.city data-placeholder=\"Select a city...\" required><option></option></select><!--<input type=\"text\" name=\"city\" class=\"form-control\" id=\"city\" placeholder=\"which city...\" places-auto-complete ng-model=\"vm.story.address.city\" required>--></div></div><div class=form-group><label for=year class=\"col-sm-3 control-label\">Datum<span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-2><input type=number name=year class=form-control id=year placeholder=Jaartal ng-model=vm.story.date.year></div><div class=col-sm-2><input type=number name=month class=form-control id=month placeholder=Maand ng-model=vm.story.date.month></div><div class=col-sm-2><input type=number name=day class=form-control id=day placeholder=Dag ng-model=vm.story.date.day></div></div><div class=form-group><label for=inleiding class=\"col-sm-3 control-label\">Inleiding <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=intro id=inleiding ng-model=vm.story.intro class=form-control placeholder=Inleiding... rows=2 ng-maxlength=300 required></textarea><span class=help-block>De inleiding van het verhaal. Verschijnt los van de bodytekst in de apps. max 300 tekens</span></div></div><div class=form-group><label for=verhaal class=\"col-sm-3 control-label\">Verhaal <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=verhaal id=verhaal ng-model=vm.story.fullStory class=form-control placeholder=\"Het verhaal...\" rows=10 required></textarea></div></div><div class=form-group><label for=samenvatting class=\"col-sm-3 control-label\">Samenvatting <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=summary id=samenvatting ng-model=vm.story.summary class=form-control placeholder=Samenvatting... rows=2 ng-maxlength=140 required></textarea><span class=help-block>Wat onder andere in de markers op de kaartweergave zal verschijnen. max. 140 characters</span></div></div><div class=form-group><label for=partner class=\"col-sm-3 control-label\">Partner</label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=partner class=form-control id=partner ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childPartners\" ng-model=vm.story.partner><option></option></select></div></div><div class=form-group><label for=monument class=\"col-sm-3 control-label\">Monument <span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=monument class=form-control id=monument ng-options=\"l.$id as l.name group by l.parentName for l in ctrl.childmonuments\" ng-model=vm.story.locationID data-placeholder=\"Select a monument...\"><option></option></select></div></div><div class=form-group><label for=dienst class=\"col-sm-3 control-label\">Dienst <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select multiple chosen=\"{width: \'100%\'}\" name=dienst class=form-control id=dienst ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childServices\" ng-model=vm.story.services data-placeholder=\"Select a service...\" required><option></option></select><span class=help-block>Bij welke dienst binnen Nationaal Erfgoed hoort dit verhaal?</span></div></div><div class=form-group><label for=dienst class=\"col-sm-3 control-label\">Locatie <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><ng-map center=\"{{vm.story.mapdata.latitude}}, {{vm.story.mapdata.longitude}}\" zoom=16 pan-control=false map-type-control=false><marker position=\"{{vm.story.mapdata.latitude}}, {{vm.story.mapdata.longitude}}\" title=\"drag me\" draggable=true on-dragend=vm.getCurrentLocation()></marker><shape id=circle name=circle centered=true center=\"{{vm.story.mapdata.latitude}}, {{vm.story.mapdata.longitude}}\" stroke-color=#FF0000 stroke-opacity=0.8 stroke-weight=1 radius={{vm.story.pushradius}} editable=false></shape></ng-map><span class=help-block>Versleep de marker om de locatie te bepalen</span><div class=\"col-sm-6 p-0 pr-20\">Latitude: <input type=text class=form-control id=us2-lat ng-model=vm.story.mapdata.latitude><br>Pushradius: <input type=text class=form-control id=us2-radius ng-model=vm.story.pushradius> <span class=help-block>Pushradius geeft het gebied aan waarbinnen een pushbericht verzonden wordt naar de gebruiker.</span></div><div class=\"col-sm-6 p-0\">Longitude: <input type=text class=form-control id=us2-lon ng-model=vm.story.mapdata.longitude><br>Address: <input class=form-control places-auto-complete ng-model=vm.story.address.fulladdress></div></div></div><div class=form-group><label for=customtitle class=\"col-sm-3 control-label\">Custom Maps <span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-3><input type=text name=customtitle class=form-control id=customtitle placeholder=\"De titel, zichtbaar in google maps, max 40 tekens\" ng-maxlength=40 ng-model=vm.story.mapdata.title></div><div class=col-sm-6><input type=text name=custombody class=form-control id=custombody placeholder=\"Korte samenvatting, zichtbaar in google maps, max 140 tekens\" ng-maxlength=140 ng-model=vm.story.mapdata.body></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label\">Status bericht<span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=status class=form-control id=status ng-options=\"v as v for (k,v) in ctrl.statuses\" ng-model=vm.story.status data-placeholder=\"Select a status...\" required><option></option></select></div></div><div class=form-group><label class=\"control-label col-sm-3\">Main image</label><div class=col-sm-9><ul class=\"list-unstyled list-inline thumbs-list\"><!--<li ng-repeat=\"imageMain in vm.story.imageMain\">--><li><img ngf-thumbnail=vm.story.imageMain alt=\"\" style=\"width: 120px; height: 120px\"> <button class=btn-nostyle ng-click=\"imageMain = null\" ng-show=\"imageMain && !editing\">x</button><uib-progressbar class=\"progress-xxs mt-10\" value=imageMain.progress type=cyan ng-show=\"imageMain.progress >= 0\"></uib-progressbar></li></ul><div ngf-drop ngf-select ngf-drag-over-class=dragover ngf-multiple=false accept=image/* ng-model=vm.story.imageMain class=\"fileupload drop-box\" name=imageMain>click or drop files here...</div><span class=help-block>Dit is de kopfoto, je kunt er maar 1 uploaden!</span></div></div><div class=form-group><label class=\"control-label col-sm-3\">Images</label><div class=col-sm-9><ul class=\"list-unstyled list-inline thumbs-list\"><li ng-repeat=\"image in vm.story.imagess\"><img ngf-thumbnail=image alt=\"\" style=\"width: 120px; height: 120px\"> <img ngf-thumbnail=image.src alt=\"\" style=\"width: 120px; height: 120px\"> <button class=btn-nostyle ng-click=\"image = null\" ng-show=\"image && !editing\">x</button><uib-progressbar class=\"progress-xxs mt-10\" value=image.progress type=cyan ng-show=\"image.progress >= 0\"></uib-progressbar></li></ul><ul class=\"list-unstyled list-inline thumbs-list\" ng-show=editing><li ng-repeat=\"image in vm.story.images\"><img ngf-thumbnail=image.src alt=\"\" style=\"width: 120px; height: 120px\"><!--<button class=\"btn-nostyle\" ng-click=\"imageDelete(story, image)\" ng-show=\"editing\">x</button>--><uib-progressbar class=\"progress-xxs mt-10\" value=image.progress type=cyan ng-show=\"image.progress >= 0\"></uib-progressbar></li></ul><div ngf-drop ngf-select ngf-drag-over-class=dragover ngf-multiple=true ngf-keep=true accept=image/* ng-model=vm.story.imagess class=\"fileupload drop-box\" name=images>click or drop files here...</div><span class=help-block>Kies meerdere foto\'s voor de image gallery binnen de app.</span></div></div><div class=form-footer><button class=\"btn btn-success b-0 pull-right\" ng-click=ok(form) ng-disabled=form.$invalid>Submit</button> <button class=\"btn btn-lightred btn-ef btn-ef-4 btn-ef-4c\" ui-sref=app.stories.list><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/stories/edit.html","<div class=\"page page-stories pull-to-header\" ng-controller=\"EditStoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Stories</a></li><li class=active>{{vm.story.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/stories/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/stories/list.html","<div class=\"page page-stories pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=stories.list>Stories</a></li><li class=active>Manage Stories</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Stories</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add Story\" tooltip-placement=bottom ui-sref=stories.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"story in $data\"><td data-title=\"\'ID\'\" sortable>{{story.id}}</td><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"stories.show({ id: story.$id })\">{{story.title}}</a></td><td data-title=\"\'Category\'\" sortable>{{story.categoryName}}</td><td data-title=\"\'Date Created\'\" sortable>{{story.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : story.status == \'published\',\'bg-warning\' : story.status == \'not published\',\'bg-lightred\' : story.status == \'banned\'}\">{{ story.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"stories.edit({ id: story.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(story)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/stories/new.html","<div class=\"page page-stories pull-to-header\" ng-controller=\"NewStoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=stories.list>Stories</a></li><li class=active>New Story</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/stories/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/stories/show.html","<div class=\"page page-stories pull-to-header\" ng-controller=\"ShowStoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Stories</a></li><li class=active>{{vm.story.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-4 magnific-popup=\"{delegate: \'a.img-link\', type: \'image\'}\"><a href={{vm.story.images[0].src}} class=img-link ng-show=\"vm.story.images.length > 0\"><img ng-src={{vm.story.images[0].src}} alt=vm.story.name class=\"img-responsive mb-20\"> </a><a href=javascript:; ng-show=\"vm.story.images.length === 0 || !vm.story.images\"><img src=assets/images/no-story-image.png alt=vm.story.name class=\"img-responsive mb-20\"> </a><!-- thumbnails --><slick dots=true infinite=false speed=300 slides-to-show=4 touch-move=false slides-to-scroll=1 arrows=false init-onload=true data=vm.story.images><div ng-repeat=\"image in vm.story.images\" ng-if=!$first href={{vm.story.images[$index].src}} class=mr-5><a href={{vm.story.images[$index].src}} class=img-link><img ng-src={{vm.story.images[$index].src}} alt=vm.story.name class=img-responsive></a></div></slick><!-- /thumbnails --></div><!-- /col --><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.story.name}} <span class=label ng-class=\"{\'bg-success\' : vm.story.status == \'published\',\'bg-warning\' : vm.story.status == \'not published\',\'bg-lightred\' : vm.story.status == \'banned\'}\">{{ vm.story.status }}</span></h2><p class=\"short-desc text-sm text-default lt mb-20\">{{vm.story.shortDescription}}</p><p class=\"desc text-default lt mb-20\">{{vm.story.description}}</p><h6><strong>Category:</strong> {{ctrl.categoriesObject[vm.story.categoryId].name}}</h6><h3 class=\"price mt-40 mb-0 text-success\">{{ vm.story.price | currency}} / <small>{{vm.story.unit}}</small></h3><p class=\"discount text-sm text-default lt\">Discount: {{vm.story.discount}}%</p></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=stories.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/users/_form.html","<form name=form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=name class=\"col-sm-3 control-label minotaur-label\">Name</label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"User name...\" ng-model=vm.user.name></div></div><div class=form-group ng-if=!vm.editing><label for=email class=\"col-sm-3 control-label minotaur-label\">Email <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=email name=email class=form-control id=email placeholder=\"User email...\" ng-model=vm.user.email required></div></div><div class=form-group ng-if=!vm.editing><label for=password class=\"col-sm-3 control-label minotaur-label\">Password <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=password class=form-control id=password placeholder=\"User password...\" ng-model=vm.user.password required></div></div><div class=form-group ng-if=!vm.editing><label for=password class=\"col-sm-3 control-label minotaur-label\">Password Confirm <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=passwordConfirm placeholder=\"Password confirmarion...\" class=form-control ng-model=passwordConfirm match=vm.user.password required></div></div><div class=form-group><label for=role class=\"col-sm-3 control-label minotaur-label\">Role <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=role class=form-control id=role ng-options=\"v for (k,v) in ctrl.role_value\" ng-model=vm.user.role_value data-placeholder=\"Select a role...\" required><option></option></select></div></div><!-- <div class=\"form-group\">\n    <label for=\"street\" class=\"col-sm-3 control-label minotaur-label\">Street</label>\n    <div class=\"col-sm-9\">\n      <input type=\"text\" name=\"street\" class=\"form-control\" id=\"street\" placeholder=\"User address street...\" ng-model=\"vm.user.address.street\">\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <label for=\"city\" class=\"col-sm-3 control-label minotaur-label\">City</label>\n    <div class=\"col-sm-9\">\n      <input type=\"text\" name=\"city\" class=\"form-control\" id=\"city\" placeholder=\"User address city...\" ng-model=\"vm.user.address.city\">\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <label for=\"zip\" class=\"col-sm-3 control-label minotaur-label\">ZIP</label>\n    <div class=\"col-sm-9\">\n      <input type=\"text\" name=\"zip\" class=\"form-control\" id=\"zip\" placeholder=\"User address zip...\" ng-model=\"vm.user.address.zip\">\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <label for=\"country\" class=\"col-sm-3 control-label minotaur-label\">Country</label>\n    <div class=\"col-sm-9\">\n      <input type=\"text\" name=\"country\" class=\"form-control\" id=\"country\" placeholder=\"User address country...\" ng-model=\"vm.user.address.country\">\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <label for=\"phone\" class=\"col-sm-3 control-label minotaur-label\">Phone</label>\n    <div class=\"col-sm-9\">\n      <input type=\"text\" name=\"phone\" class=\"form-control\" id=\"phone\" placeholder=\"User address phone...\" ng-model=\"vm.user.phone\">\n    </div>\n  </div> --><div class=form-footer><button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=form.$invalid>Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=users.list><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/users/edit.html","<div class=\"page page-users pull-to-header\" ng-controller=\"EditUserController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=users.list>Users</a></li><li class=active>{{vm.user.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/users/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/users/list.html","<div class=\"page page-users pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=users.list>Users</a></li><li class=active>Manage Users</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Users</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add User\" tooltip-placement=bottom ui-sref=users.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6><div ng-show=\"main.currentUser.role_value >= 98 && main.currentUser.neService.nationaal_erfgoed == true\"><button ng-click=ctrl.tableParams.filter({blocked:false}) class=\"btn btn-default\">Alle profielen</button> <button ng-click=\"ctrl.tableParams.filter({blocked:false, neService:{history2go:true}})\" class=\"btn btn-default\">History2Go</button> <button ng-click=\"ctrl.tableParams.filter({blocked:false, neService:{verhalensprokkelaar:true}})\" class=\"btn btn-default\">Verhalensprokkelaar</button></div></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"user in $data\"><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"users.show({ id: user.$id })\">{{user.name}}</a></td><td data-title=\"\'Email\'\" sortable><a href=javascript:; ui-sref=\"users.show({ id: user.$id })\">{{user.email}}</a></td><!-- <td data-title=\"\'Address\'\" sortable=\"\'address.street\'\">\n                  {{user.address.street}}, {{user.address.city}} {{user.address.zip}}, {{user.address.country}}\n                </td> --><!-- <td data-title=\"\'Phone\'\" sortable=\"\'phone\'\">\n                  {{user.phone}}\n                </td> --><td data-title=\"\'Role\'\" sortable>{{user.role_value}}</td><td data-title=\"\'Dienst\'\" sortable>{{user.neService}}</td><td data-title=\"\'Actions\'\" class=actions style=\"width: 320px\"><div ng-show=\"user.role_value < 51 || user.role_value == null\"><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"users.edit({ id: user.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(user)>Delete</button> <button class=\"btn btn-warning btn-xs minotaur-btn\" ng-click=ctrl.passReset(user)>Password reset</button></div></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Vorige</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/users/new.html","<div class=\"page page-users pull-to-header\" ng-controller=\"NewUserController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=users.list>Users</a></li><li class=active>New User</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/users/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/users/show.html","<div class=\"page page-users pull-to-header\" ng-controller=\"ShowUserController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=users.list>Users</a></li><li class=active>{{vm.user.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><ul class=\"list-unstyled m-20\"><li ng-if=vm.user.name><strong>Name:</strong> {{vm.user.name}}</li><li><strong>Email:</strong> {{vm.user.email}}</li><li><strong>Address:</strong> {{vm.user.address.street}}, {{vm.user.address.city}} {{vm.user.address.zip}}, {{vm.user.address.country}}</li><li><strong>Phone:</strong> {{vm.user.phone}}</li><li><strong>Role:</strong> {{vm.user.role}}</li></ul><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=users.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/components/partials/customize/minotaur-customize.html","<button class=\"btn btn-default toggle\"><i class=\"fa fa-adjust\"></i></button><div class=\"pull-right panel\"><div class=panel-heading><h4>Customize:</h4></div><div class=panel-body><h5>Solid:</h5><ul><li><div class=default ng-click=\"main.headerStyle = \'header-solid-default\'\"></div></li><li><div class=greensea ng-click=\"main.headerStyle = \'header-solid-greensea\'\"></div></li><li><div class=lightred ng-click=\"main.headerStyle = \'header-solid-lightred\'\"></div></li><li><div class=amethyst ng-click=\"main.headerStyle = \'header-solid-amethyst\'\"></div></li><li><div class=drank ng-click=\"main.headerStyle = \'header-solid-drank\'\"></div></li><li><div class=gray ng-click=\"main.headerStyle = \'header-solid-gray\'\"></div></li></ul><h5>Gradient:</h5><ul><li><div class=default ng-click=\"main.headerStyle = null\"></div></li><li><div class=greensea ng-click=\"main.headerStyle = \'header-gradient-greensea\'\"></div></li><li><div class=lightred ng-click=\"main.headerStyle = \'header-gradient-lightred\'\"></div></li><li><div class=amethyst ng-click=\"main.headerStyle = \'header-gradient-amethyst\'\"></div></li><li><div class=drank ng-click=\"main.headerStyle = \'header-gradient-drank\'\"></div></li><li><div class=gray ng-click=\"main.headerStyle = \'header-gradient-gray\'\"></div></li></ul><h5>Primary Color:</h5><ul><li><div class=default ng-click=\"main.primaryColor = null\"></div></li><li><div class=greensea ng-click=\"main.primaryColor = \'primary-color-greensea\'\"></div></li><li><div class=lightred ng-click=\"main.primaryColor = \'primary-color-lightred\'\"></div></li><li><div class=amethyst ng-click=\"main.primaryColor = \'primary-color-amethyst\'\"></div></li><li><div class=drank ng-click=\"main.primaryColor = \'primary-color-drank\'\"></div></li><li><div class=gray ng-click=\"main.primaryColor = \'primary-color-gray\'\"></div></li></ul></div></div>");
$templateCache.put("app/components/partials/header/header.html","<div class=navbar-header><button type=button class=\"header-nav-toggle collapsed\" data-toggle=collapse data-target=#header-navbar aria-expanded=false aria-controls=header-navbar><span class=sr-only>Toggle header</span> <i class=\"fa fa-cog\"></i></button> <button type=button class=navigation-toggle id=navigation-toggle><span class=sr-only>Toggle navigation</span> <i class=\"fa fa-bars\"></i></button> <a class=navbar-brand ui-sref=dashboard><span><strong>Nationaal</strong> Erfgoed</span></a></div><!-- <div class=\"main-search hidden-xs\">\n  <form>\n    <input type=\"text\" class=\"form-control\" placeholder=\"Search...\">\n    <button class=\"btn\">\n      <i class=\"fa fa-search\"></i>\n    </button>\n  </form>\n</div> --><div id=header-navbar class=\"navbar-collapse collapse\"><ul class=\"nav navbar-nav navbar-right\"><li><!-- Single button --><div uib-dropdown><button id=profile type=button class=\"btn no-bg\" uib-dropdown-toggle><img src=assets/images/placeholder-avatar.png alt=\"\" class=\"img-responsive img-circle hidden-xs\" ng-if=!main.currentUser.avatar> <img ng-src={{main.currentUser.avatar}} alt=\"\" class=\"img-responsive img-circle hidden-xs\" ng-if=main.currentUser.avatar> <span class=nav-text><i class=\"fa fa-user\"></i> {{main.currentUser.name}}</span></button><div class=\"dropdown-menu with-arrow animated littleFadeInRight profile\" uib-dropdown-menu role=menu aria-labelledby=profile><div class=media><div class=media-left><img src=assets/images/placeholder-avatar.png alt=\"\" class=\"media-object img-circle\" ng-if=!main.currentUser.avatar> <img ng-src={{main.currentUser.avatar}} alt=\"\" class=\"media-object img-circle\" ng-if=main.currentUser.avatar></div><div class=media-body><h4 class=\"text-sm uppercase-bold\">{{main.currentUser.name}}</h4><a href=javascript:;>{{main.currentUser.email}}</a><ul class=list-unstyled><li ng-class=\"{\'active\':$state.includes(\'profile\')}\"><a ui-sref=profile><i class=\"fa fa-user\"></i> Edit Profile</a></li></ul></div></div><div class=footer><button class=\"btn btn-theme minotaur-btn\" ng-click=header.logout();><i class=\"fa fa-power-off\"></i> Logout</button></div></div></div></li></ul></div>");
$templateCache.put("app/components/partials/navigation/navigation.html","<div class=nav-heading><a class=brand ui-sref=dashboard></a><h3>Navigation</h3></div><div slimscroll=\"{\n      height: \'100%\',\n      size: \'4px\',\n      borderRadius: \'0px\',\n      opacity: .2\n     }\"><ul class=\"nav nav-sidebar\"><li ng-class=\"{\'active\':$state.includes(\'dashboard\')}\"><a ui-sref=dashboard><span class=nav-text>Dashboard</span> <i class=\"fa fa-home\"></i></a></li><li ng-class=\"{\'open active\':$state.includes(\'settings\')}\" ng-show=\"main.currentUser.role_value >= 98 && main.currentUser.neService.nationaal_erfgoed == true\"><a href=javascript:;><span class=nav-text>Settings</span> <i class=\"fa fa-cog\"></i></a><ul><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'cities\')}\"><a ui-sref=cities.list><span class=nav-text>Steden</span> <i class=\"fa fa-building-o\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'categories\')}\" ng-show=\"main.currentUser.role_value >= 11\"><a ui-sref=categories.list><span class=nav-text>Categorieen</span> <i class=\"fa fa-bookmark-o\"></i></a></li></ul></li><li ng-class=\"{\'open active\':$state.includes(\'crm\')}\" ng-show=\"main.currentUser.role_value >= 98 && main.currentUser.neService.nationaal_erfgoed == true\"><a href=javascript:;><span class=nav-text>CRM</span> <i class=\"fa fa-briefcase\"></i></a><ul><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'services\')}\"><a ui-sref=cities.list><span class=nav-text>Services</span> <i class=\"fa fa-building-o\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'partners\')}\"><a ui-sref=categories.list><span class=nav-text>Partners</span> <i class=\"fa fa-bookmark-o\"></i></a></li></ul></li><li ng-class=\"{\'open active\':$state.includes(\'community\')}\" ng-show=\"main.currentUser.role_value >= 49\"><a href=javascript:;><span class=nav-text>Community Management</span> <i class=\"fa fa-user-circle\"></i></a><ul><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'users\')}\" ng-show=\"main.currentUser.role_value >= 99 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=users.list()><span class=nav-text>All users</span> <i class=\"fa fa-building-o\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'gamification\')}\" ng-show=\"main.currentUser.role_value >= 49 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=categories.list><span class=nav-text>Gamification</span> <i class=\"fa fa-bookmark-o\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'users\')}\" ng-show=\"main.currentUser.role_value >= 49 && main.currentUser.neService.verhalensprokkelaar == true || main.currentUser.role_value >= 48 && main.currentUser.neService.nationaal_erfgoed == true\" ng-hide=\"main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=\"users.list({ service: \'verhalensprokkelaar\' })\"><span class=nav-text>Gebruikers Verhalensprokkelaar</span> <i class=\"fa fa-bookmark-o\"></i></a></li></ul></li><li ng-class=\"{\'open active\':$state.includes(\'history\')}\"><a href=javascript:;><span class=nav-text>History Database</span> <i class=\"fa fa-university\"></i></a><ul><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'history2go\')}\" ng-show=\"main.currentUser.role_value >= 11 && main.currentUser.neService.history2go == true || main.currentUser.role_value >= 11 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=h2g.list><span class=nav-text>History2Go</span> <i class=\"fa fa-map-marker\"></i></a><ul><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'history2go\')}\"><a ui-sref=h2g.list><span class=nav-text>All stories</span> <i class=\"fa fa-map-marker\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'history2go\')}\"><a ui-sref=categories.list><span class=nav-text>Moderate</span> <i class=\"fa fa-bookmark-o\"></i></a></li></ul></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'ondemand\')}\" ng-show=\"main.currentUser.role_value >= 11 && main.currentUser.neService.history2go == true || main.currentUser.role_value >= 11 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=categories.list><span class=nav-text>On demand</span> <i class=\"fa fa-bookmark-o\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'monuments\')}\" ng-show=\"main.currentUser.role_value >= 11 && main.currentUser.neService.nationaal_erfgoed == true || main.currentUser.role_value >= 11 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=categories.list><span class=nav-text>Monuments</span> <i class=\"fa fa-bookmark-o\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'history2day\')}\" ng-show=\"main.currentUser.role_value >= 11 && main.currentUser.neService.nationaal_erfgoed == true || main.currentUser.role_value >= 11 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=categories.list><span class=nav-text>History2day</span> <i class=\"fa fa-bookmark-o\"></i></a></li><!-- <li ui-sref-active=\"active\" ng-class=\"{\'active\':$state.includes(\'verhalensprokkelaar\')}\" ng-show=\"main.currentUser.role_value >= 11 && main.currentUser.neService.verhalensprokkelaar == true\">\n          <a ui-sref=\"bappzs.list\">\n            <span class=\"nav-text\">Verhalensprokkelaar</span>\n            <i class=\"fa fa-bookmark-o\"></i>\n          </a>\n        </li> --><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'verhalensprokkelaar\')}\" ng-show=\"main.currentUser.role_value >= 9 && main.currentUser.neService.verhalensprokkelaar == true || main.currentUser.role_value >= 9 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=bappzs.list><span class=nav-text>Verhalensprokkelaar</span> <i class=\"fa fa-star-o\"></i></a><ul><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'verhalensprokkelaar\')}\" ng-show=\"main.currentUser.role_value >= 9 && main.currentUser.neService.verhalensprokkelaar == true || main.currentUser.role_value >= 9 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=bappzs.list><span class=nav-text>Verhalen</span> <i class=\"fa fa-list-ul\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'verhalensprokkelaar\')}\" ng-show=\"main.currentUser.role_value >= 11 && main.currentUser.neService.verhalensprokkelaar == true || main.currentUser.role_value >= 11 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=bappzs.moderate><span class=nav-text>Moderatie</span> <i class=\"fa fa-pencil-square-o\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'verhalensprokkelaar\')}\" ng-show=\"main.currentUser.role_value >= 11 && main.currentUser.neService.verhalensprokkelaar == true || main.currentUser.role_value >= 11 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=bappz_categories.list><span class=nav-text>Categorieën</span> <i class=\"fa fa-clone\"></i></a></li><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'verhalensprokkelaar\')}\" ng-show=\"main.currentUser.role_value >= 11 && main.currentUser.neService.verhalensprokkelaar == true || main.currentUser.role_value >= 11 && main.currentUser.neService.nationaal_erfgoed == true\"><a ui-sref=locations.list><span class=nav-text>Locaties</span> <i class=\"fa fa-map-marker\"></i></a></li></ul></li></ul></li><!-- <li ng-class=\"{\'active\':$state.includes(\'products\')}\">\n      <a ui-sref=\"products.list\">\n        <span class=\"nav-text\">Products</span>\n        <i class=\"fa fa-gift\"></i>\n      </a>\n    </li> --><!-- <li ng-class=\"{\'active\':$state.includes(\'stories\')}\">\n      <a ui-sref=\"stories.list\">\n        <span class=\"nav-text\">Stories</span>\n        <i class=\"fa fa-gift\"></i>\n      </a>\n    </li>\n    <li ng-class=\"{\'active\':$state.includes(\'orders\')}\">\n      <a ui-sref=\"orders.list\">\n        <span class=\"nav-text\">Orders</span>\n        <i class=\"fa fa-usd\"></i>\n      </a>\n    </li>\n    <li ng-class=\"{\'active\':$state.includes(\'users\')}\">\n      <a ui-sref=\"users.list\">\n        <span class=\"nav-text\">Users</span>\n        <i class=\"fa fa-users\"></i>\n      </a>\n    </li>\n    <li ng-class=\"{\'active\':$state.includes(\'settings\')}\">\n      <a ui-sref=\"settings\">\n        <span class=\"nav-text\">Settings</span>\n        <i class=\"fa fa-cog\"></i>\n      </a>\n    </li> --></ul></div>");
$templateCache.put("app/components/partials/rightbar/rightbar.html","<uib-tabset><uib-tab id=users><uib-tab-heading>Chat</uib-tab-heading><h6><strong>Online</strong> Users</h6><ul><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/ici-avatar.jpg alt></a><div class=media-body><span class=media-heading>Ing. Imrich <strong>Kamarel</strong></span> <small><i class=\"fa fa-map-marker\"></i> Ulaanbaatar, Mongolia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/arnold-avatar.jpg alt> </a><span class=\"badge bg-lightred unread\">3</span><div class=media-body><span class=media-heading>Arnold <strong>Karlsberg</strong></span> <small><i class=\"fa fa-map-marker\"></i> Bratislava, Slovakia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/peter-avatar.jpg alt></a><div class=media-body><span class=media-heading>Peter <strong>Kay</strong></span> <small><i class=\"fa fa-map-marker\"></i> Kosice, Slovakia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/george-avatar.jpg alt></a><div class=media-body><span class=media-heading>George <strong>McCain</strong></span> <small><i class=\"fa fa-map-marker\"></i> Prague, Czech Republic</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=busy><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar1.jpg alt></a><div class=media-body><span class=media-heading>Lucius <strong>Cashmere</strong></span> <small><i class=\"fa fa-map-marker\"></i> Wien, Austria</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=busy><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar2.jpg alt></a><div class=media-body><span class=media-heading>Jesse <strong>Phoenix</strong></span> <small><i class=\"fa fa-map-marker\"></i> Berlin, Germany</small> <span class=\"badge badge-outline status\"></span></div></div></li></ul><h6><strong>Offline</strong> Users</h6><ul><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar4.jpg alt></a><div class=media-body><span class=media-heading>Dell <strong>MacApple</strong></span> <small><i class=\"fa fa-map-marker\"></i> Paris, France</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar5.jpg alt></a><div class=media-body><span class=media-heading>Roger <strong>Flopple</strong></span> <small><i class=\"fa fa-map-marker\"></i> Rome, Italia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar6.jpg alt></a><div class=media-body><span class=media-heading>Nico <strong>Vulture</strong></span> <small><i class=\"fa fa-map-marker\"></i> Kyjev, Ukraine</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar7.jpg alt></a><div class=media-body><span class=media-heading>Bobby <strong>Socks</strong></span> <small><i class=\"fa fa-map-marker\"></i> Moscow, Russia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar8.jpg alt></a><div class=media-body><span class=media-heading>Anna <strong>Opichia</strong></span> <small><i class=\"fa fa-map-marker\"></i> Budapest, Hungary</small> <span class=\"badge badge-outline status\"></span></div></div></li></ul></uib-tab><uib-tab><uib-tab-heading>Friends</uib-tab-heading><h6><strong>Friends</strong> List</h6><ul><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/arnold-avatar.jpg alt> </a><span class=\"badge bg-lightred unread\">3</span><div class=media-body><span class=media-heading>Arnold <strong>Karlsberg</strong></span> <small><i class=\"fa fa-map-marker\"></i> Bratislava, Slovakia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar8.jpg alt></a><div class=media-body><span class=media-heading>Anna <strong>Opichia</strong></span> <small><i class=\"fa fa-map-marker\"></i> Budapest, Hungary</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=busy><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar1.jpg alt></a><div class=media-body><span class=media-heading>Lucius <strong>Cashmere</strong></span> <small><i class=\"fa fa-map-marker\"></i> Wien, Austria</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/ici-avatar.jpg alt></a><div class=media-body><span class=media-heading>Ing. Imrich <strong>Kamarel</strong></span> <small><i class=\"fa fa-map-marker\"></i> Ulaanbaatar, Mongolia</small> <span class=\"badge badge-outline status\"></span></div></div></li></ul></uib-tab><uib-tab heading=\"Long Justified\"><uib-tab-heading>Settings</uib-tab-heading><h6><strong>Chat</strong> Settings</h6><ul class=settings><li><div class=form-group><label class=\"col-xs-8 control-label\">Show Offline Users</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-offline checked><label class=onoffswitch-label for=show-offline><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">Show Fullname</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-fullname><label class=onoffswitch-label for=show-fullname><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">History Enable</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-history checked><label class=onoffswitch-label for=show-history><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">Show Locations</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-location checked><label class=onoffswitch-label for=show-location><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">Notifications</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-notifications><label class=onoffswitch-label for=show-notifications><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">Show Undread Count</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-unread checked><label class=onoffswitch-label for=show-unread><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li></ul></uib-tab></uib-tabset><a href=javascript:; id=close-rightbar></a>");}]);